export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "Hotel knowledge base",
    "tip": "Manage questions and answers for the current hotel.",
    "created": "Created",
    "updated": "Updated",
    "to": "to",
    "startDate": "Start date",
    "endDate": "End date",
    "question": "Question",
    "answer": "Answer",
    "tags": "Tags",
    "questionSearch": "Search questions",
    "tagSearch": "Search tags",
    "search": "Search",
    "reset": "Reset",
    "create": "Add",
    "batchDelete": "Delete selected",
    "loadFailed": "Loading failed. Please try again.",
    "notFilled": "Not provided",
    "actions": "Actions",
    "view": "View full text",
    "edit": "Edit",
    "delete": "Delete",
    "details": "Knowledge details",
    "missingTitle": "Missing historical content",
    "missingView": "The question or answer is missing. Complete it before saving.",
    "missingForm": "The question or answer is missing. Complete it before saving.",
    "noDetails": "No details",
    "close": "Close",
    "enterQuestion": "Enter a question",
    "enterAnswer": "Enter an answer",
    "answerPlaceholder": "Enter an answer. Multiple lines are supported.",
    "tagPlaceholder": "Enter a tag and press Enter",
    "tagTip": "Press Enter to add a tag. Commas and spaces do not split tags. The total tag length is limited to 512 characters.",
    "cancel": "Cancel",
    "save": "Save",
    "chooseHotel": "Select a hotel first",
    "empty": "No data",
    "editTitle": "Edit knowledge",
    "createTitle": "Add knowledge",
    "tagRequired": "Add at least one tag",
    "tagText": "Tags must be text. Remove and add them again.",
    "tagBlank": "Tags cannot be blank. Remove and add them again.",
    "tagsTooLong": "Tags are too long. Shorten them and try again.",
    "questionTooLong": "The question cannot exceed 512 characters",
    "answerTooLong": "The answer cannot exceed 5000 characters",
    "invalidRecord": "Invalid record. Reopen it for editing.",
    "editSuccess": "Updated successfully",
    "createSuccess": "Added successfully",
    "deleteLimit": "A maximum of 100 records can be deleted at once",
    "confirmBatch": "Delete the {count} selected records on this page? This cannot be undone.",
    "confirmOne": "Delete this record? This cannot be undone.",
    "deleteConfirm": "Confirm deletion",
    "confirmDelete": "Delete",
    "deleteSuccess": "Deleted successfully",
    "dataChanged": "The data has changed. Refresh the list and try again."
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "AI Usage Statistics",
    "priceConfig": "Room Type Pricing Settings",
    "dateRange": "Date Range",
    "startDate": "Start Date",
    "endDate": "End Date",
    "scene": "Notification Type",
    "all": "All",
    "callStatus": "Call Status",
    "callStatusLabel": "Call status information",
    "running": "In Progress",
    "success": "Succeeded",
    "failed": "Failed",
    "tokenStatus": "Usage Data",
    "tokenStatusLabel": "Usage data information",
    "known": "Available",
    "unknownUsage": "Unavailable",
    "query": "Search",
    "reset": "Reset",
    "categoryError": "Failed to load notification types",
    "retry": "Reload",
    "chooseHotel": "Please select a hotel first",
    "dailyUsage": "Daily AI Usage",
    "noCallsFiltered": "No calls match the selected filters.",
    "statisticsError": "Failed to load usage statistics",
    "loadingTrend": "Loading trend…",
    "details": "Call Details",
    "detailsError": "Failed to load call details",
    "loading": "Loading…",
    "noCalls": "No call records",
    "waiting": "Waiting for search",
    "callTime": "Call Time",
    "usage": "AI Usage",
    "requestInfo": "Request Information",
    "requestId": "Request ID: ",
    "requestDetails": "Request Details",
    "totalUsage": "Total AI Usage",
    "callCount": "Call Count",
    "successCount": "Successful Calls",
    "unknownCount": "Calls with Unknown Usage",
    "today": "Today",
    "last7": "Last 7 Days",
    "last30": "Last 30 Days",
    "thisMonth": "This Month",
    "pending": "Pending",
    "unknown": "Unknown",
    "usageLabel": "Usage: ",
    "callCountLabel": "Calls: ",
    "unknownCountLabel": "Calls with unknown usage: ",
    "missingUsage": "Some calls have unavailable usage data",
    "usageAxis": "Usage",
    "description": "Usage covers recorded AI calls for the current hotel and excludes chats not linked to a hotel. Dates use Beijing time.",
    "callStatusHelp": "In progress, succeeded and failed refer to the platform call status. Success does not mean a notification was generated.",
    "usageHelp": "Available: usage is known, including zero. Unavailable: a call exists but usage is unknown and excluded from total usage, regardless of call success or failure.",
    "invalidDates": "Select a valid date range. The start must not be after the end, and neither date may be after today in Beijing time."
  },
  navbar: {
    searchHotel: 'Search Hotel',
    nightAudit: 'Night Audit',
    nightAuditWarning: 'Night audit in progress, please try again later',
    groupBooking: 'Group',
    orderBox: 'Order Box',
  },
  common: {
    logo: 'Logo',
    bundleSale: 'Bundle Sale',
    splitTax: 'Tax Breakdown',
    taxIncluded: 'Tax Included',
    taxExcluded: 'Tax Excluded',
    businessFeeUnit: 'Charge Unit',
    fixedAmount: 'Fixed Amount',
    percentage: 'Percentage',
    pleaseEnter: 'Please enter',
    confirmCheckInOutTime: 'You have booked a room with check-in on {checkIn} and check-out on {checkOut}. Please confirm the check-in and check-out dates.',
    tax: 'Tax',
    expenseWithTax: 'Expense (Tax Included)',
    totalProductPrice: 'Total Product Amount',
    expenseWithoutTax: 'Expense (Excl. Tax)',
    roomFeeWithoutTax: 'Room Charge (Excl. Tax)',
    salesAmountWithoutTax: 'Sales Amount (Excl. Tax)',
    taxIncludedPrice: 'Tax Price',
    title: 'EaseHUB Hotel Management System',
    billingCycleType: 'Billing Cycle Type',
    weeklySettlement: 'Weekly Settlement',
    monthlySettlement: 'Monthly Settlement',
    accountReceivablePayment: 'Account Receivable Payment',
    noResults: 'No related hotel information found',
    shiftHandover: 'Shift Handover',
    salesClerk: 'Cashier',
    currentShift: 'Current Shift',
    requestFailed: 'Request Failed',
    confirmModify: 'Confirm Modification',
    operationSuccess: 'Operation Successful!',
    individualBooking: 'Reserve',
    longBooking: 'Long Stay',
    cashPay: 'Cash Payment',
    cashPayment: 'Direct Bill',
    doorCard: 'Key Card',
    more: 'More',
    success: 'Success',
    close: 'Close',
    loadingEllipsis: 'Loading...',
    cancel: 'Cancel',
    printReport: 'Print',
    printTime: 'Print Time',
    businessDay: 'Business Day',
    operationDate: 'Operation Date',
    subject: 'Subject',
    amount: 'Amount',
    save: 'Save',
    yuan: '',
    confirm: 'Confirm',
    nextStep: 'Next Step',
    all: 'All',
    immediateQuery: 'Search',
    action: 'Action',
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Enter',
    inputYuan: 'Please enter ',
    yes: 'Yes',
    no: 'No',
    remark: 'Remark',
    delete: 'Delete',
    oneHour: '1 Hour',
    twoHours: '2 Hours',
    threeHours: '3 Hours',
    fourHours: '4 Hours',
    fiveHours: '5 Hours',
    sixHours: '6 Hours',
    sevenHours: '7 Hours',
    eightHours: '8 Hours',
    saveSuccess: 'Saved Successfully',
    notice: 'Notice',
    status: 'Status',
    cancelled: 'Cancelled',
    booked: 'Booked',
    hardLoading: 'Loading…',
    startDate: 'Start Date',
    endDate: 'End Date',
    Deadline: 'Deadline',
    name2: 'Name',
    roomNumber: 'Room Number',
    checkInDate3: 'Check-in Date',
    checkOutDate3: 'Check-out Date',
    unitPrice3: 'Unit Price',
    quantity: 'Quantity',
    addBook: 'Add Account Set',
    bookName: 'Account Set Name',
    accountOfConsumption: 'Consumption Subject',
    details3: 'Details',
    id: 'ID',
    commodityDetail: 'Product Details',
    externalDocumentNumber: 'External Document No.',
    accountOfPayment2: 'Payment Subject',
    strikeABalance: 'Write-off',
    pleaseFillInRemarks2: 'Please fill in remarks',
    search: 'Search',
    nationality: 'Nationality',
    sex: 'Gender',
    male: 'Male',
    female: 'Female',
    nation: 'Ethnicity',
    contactInformation2: 'Contact Information',
    dateOfBirth: 'Date of Birth',
    documentType: 'Document Type',
    address2: 'Address',
    documentNumber: 'Document Number',
    validityOfVisa: 'Visa Validity',
    visaType: 'Visa Type',
    visaNumber: 'Visa Number',
    pleaseEnterYourIdNumber: 'Please enter ID number',
    pleaseEnterTheCorrectIdNumber4: 'Please enter a valid ID number',
    pleaseFillInYourName2: 'Please enter name',
    pleaseSelectDocumentType: 'Select document type',
    dontWorryAboutGoldMembers2: 'Qingzhu Gold Member',
    goEasyOnThePlatinumMembers2: 'Qingzhu Platinum Member',
    lightOnDiamondMembers2: 'Qingzhu Diamond Member',
    unregisteredMember: 'Unregistered Member',
    ok2: 'OK',
    issuingAuthority: 'Issuing Authority',
    idPhoto: 'ID Photo',
    qingzhuGroup: 'Qingzhu Group',
    mobilePhoneNumber: 'Mobile Number',
    view: 'View',
    activated: 'Activated',
    nonmember: 'Non-member',
    coupon: 'Coupon',
    ranking5: 'Ranking',
    hotelName4: 'Hotel Name',
    isNotSet: 'Not Set',
    yu: 'Remaining',
    noVacancy: 'Fully Occupied',
    consumption: 'Consumption',
    refund: 'Refund',
    iGotIt2: 'Got It',
    startANightTrial: 'Start Night Audit',
    operator: 'Operator',
    handledBy: 'Handled By',
    to: 'To',
    currentBusinessDay: 'Current Business Day',
    ok: 'OK',
    morningShift2: 'Morning Shift',
    middleShift2: 'Middle Shift',
    nightShift2: 'Night Shift',
    pleaseEnterYourName: 'Please enter name',
    selectAll: 'Select All',
    pleaseEnterContent: 'Please enter content',
    serialNumber: 'Serial Number',
    address: 'Address',
    signatureOfAuthorizer: 'Authorizer Signature',
    signature3: 'Signature',
    roomType: 'Room Type',
    dayRate: 'Day Rate',
    checkInTime: 'Check-in',
    checkOutTime: 'Check-out',
    settlementAmount: 'Settlement Amount',
    hotelAddress: 'Hotel Address',
    selectDate: 'Select Date',
    selectionTime: 'Select Time',
    cancelCard: 'Cancel Card',
    thisCardIsEmptyPleaseMakeABusinessCardFirst: 'This card is empty. Please create a card first.',
    logoutSuccessful: 'Card Cancellation Successful',
    cardCancellationFailure: 'Card Cancellation Failed',
    contactSupport: 'Please contact technical support to check hardware service availability',
    submit: 'Submit',
    contactPerson6: 'Contact Person',
    contactNumber2: 'Contact Number',
    merchant3: 'Merchant',
    Submitsuccessfully: 'Submitted Successfully',
    smallProgram: 'Mini Program',
    technicalSupport: 'Technical Support',
    roomBillCheck: 'Room Bill Verification',
    financialAssistant: 'Financial Assistant',
    settlementCycle: 'Settlement Cycle',
    refundSuccessful: 'Refund Successful',
    beingRefunded: 'Refund in Progress',
    refundFailure: 'Refund Failed',
    channel: 'Channel',
    cloakroom: 'Room Off-Shelf',
    infiniteQuantity: 'Unlimited Quantity',
    compute: 'Calculate',
    dateOfSale: 'Sale Date',
    originalPrice: 'Original Price',
    pleaseEnterTheOriginalPrice: 'Please enter the original price',
    member: 'Member',
    salesAmount: 'Sales Amount',
    amountOfConsumption: 'Consumption Amount',
    protocolUnit: 'Corporate Contract Unit',
    subjectDesc: 'Subject Description',
    qzOrderNo: 'Qingzhu Order No.',
    checkInType: 'Check-in Type',
    checkInOutDate: 'Check-in / Check-out Date',
    channelOrderNo: 'Channel Order No.',
    pleaseEnterTheCorrectPhoneNumber3: 'Please enter a valid phone number',
    logs: 'Logs',
    walkIn: 'Walk-in',
    businessCardPrintingSuccess: 'Card Created Successfully',
    exportSuccessfully2: 'Export Successful',
    exportFailure: 'Export Failed',
    other: 'Other',
    toBeProcessed: 'Pending',
    completed: 'Completed',
    commonProduct: 'Standard Product',
    freeRoomProducts: 'Free Room Product',
    makeACard: 'Make Card',
    day: 'Day',
    points2: 'Minute',
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    lose: 'Failed',
    since: 'Since',
    amountTotal: 'Subtotal',
    total: 'Total',
    tradeName: 'Product Name',
    itemType: 'Item Type',
    orderStatus: 'Order Status',
    orderNumber: 'Order No.',
    anonymousUser: 'Anonymous User',
    commentTime: 'Comment Time',
    merchantReply: 'Merchant Reply',
    recoveryTime: 'Reply Time',
    recover: 'Reply',
    pleaseWriteAResponseOfAtLeast10Words: 'Please enter at least 10 characters',
    replyTextMinimum10Words: 'Reply must contain at least 10 characters',
    negativeComment: 'Negative Review',
    cancel2: 'Cancel',
    commentTemplateManagement: 'Comment Template Management',
    modifiedSuccessfully: 'Modified Successfully',
    hygiene: 'Hygiene',
    service: 'Service',
    facility: 'Facility',
    position: 'Location',
    appeal: 'Appeal',
    successfullyDeleted: 'Deleted Successfully',
    replySuccessfully2: 'Reply Successful',
    theMobilePhoneNumberFormatIsIncorrect5: 'Invalid phone number format',
    none4: 'None',
    thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen:
      'This function is not yet enabled. Click to enable if needed.',
    noCommentsYet: 'No Comments',
    picture: 'Picture',
    guestName: 'Guest Name',
    handle: 'Handle',
    edit: 'Edit',
    type: 'Type',
    salesman: 'Salesperson',
    successfulOperation: 'Operation Successful',
    pleaseEnterTheCompanyName2: 'Please enter company name',
    customerType: 'Customer Type',
    effective: 'Active',
    inVain: 'Inactive',
    valid: 'valid',
    forbidden: 'Disabled',
    enable: 'Enable',
    companyName2: 'Company Name',
    favorable2: 'Discount',
    day2: 'Day',
    telephone: 'Telephone',
    pleaseEnterThePhoneNumber: 'Please enter phone number',
    mailbox: 'Email',
    accountName: 'Account Name',
    startTime: 'Start Time',
    endTime: 'End Time',
    beingSubmitted: 'Submitting',
    pleaseSelectGender: 'Select gender',
    confirmDeletion: 'Confirm Deletion',
    letMeThinkItOver: 'Let me think about it',
    theSizeOfTheUploadedPictureCannotExceed: 'Uploaded picture must not exceed',
    identificationCard2: 'ID Card',
    editor: 'Editor',
    topLine: 'Online',
    downline: 'Offline',
    validity: 'Validity',
    fullDayRoom: 'Full-day Room',
    hourlyRoom: 'Hourly Room',
    append3: 'Add',
    immediatelyReduce3: 'Instant Discount',
    activityName2: 'Activity Name',
    sort: 'Category',
    on: 'On',
    amountOfGift2: 'Gift Amount',
    pleaseFillIn2: 'Please fill in',
    pleaseSelectADate: 'Select a date',
    roomFeeConsumption: 'Room Fee Consumption',
    selectFile: 'Select File',
    uploadFailure: 'Upload Failed',
    uploadSuccessfully: 'Uploaded',
    print: 'Print',
    dateRange: 'Date Range',
    reupload: 'Re-upload',
    printBill: 'Print Bill',
    cardNumber: 'Card No.',
    paymentMethod: 'Payment Method',
    payMethod: 'Pay Method',
    balance: 'Balance',
    membershipCardNumber: 'Membership Card No.',
    birthday: 'Birthday',
    tradingHours: 'Transaction Time',
    enterAMaximumOf50Characters: 'Enter up to 50 characters',
    membersMobileNumber: 'Member Phone Number',
    time: 'Time',
    modifyInformation: 'Modify Information',
    lengthOfStay: 'Length of Stay',
    roomListNumber: 'Room Order No',
    roomTypeName: 'Room Type Name',
    settleAccounts: 'Settle',
    accountNumber: 'Guest Account',
    paymentRecord: 'Payment Record',
    paymentAmount: 'Payment Amount',
    paymentVerificationCode: 'Payment Verification Code',
    enterInAnAccount: 'Post Charge',
    pleaseSelectACollectionSet: 'Select a receivable account set',
    pleaseSelectTheAccountNumber: 'Select an account',
    pleaseSelectAPaymentMethod: 'Select payment method',
    vipSignature: 'VIP Signature',
    amountNotWrittenOff3: 'Amount Not Written Off',
    availableCredit3: 'Available Credit',
    maximumAmount4: 'Maximum Amount',
    whetherItIsValidOrNot: 'Valid or Not',
    enabledSuccessfully: 'Enabled Successfully',
    disableSuccessfully: 'Disabled Successfully',
    roomNumberName: 'Room No. - Name',
    payment2: 'Payment',
    operatingTime: 'Operation Time',
    classes: 'Shift',
    transfer: 'Transfer',
    accountOutstanding2: 'Unsettled',
    accountClosed: 'Settled',
    rolledOut: 'Transferred Out',
    haveStruckOff: 'Written Off',
    noRoomChargeIsGenerated: 'No room charge generated',
    date3: 'Date',
    itemName4: 'Item Name',
    pleaseEnterRemarks2: 'Please enter remarks',
    entryAndDepartureTime: 'Check-in / Check-out Time',
    roomRate: 'Room Rate',
    preAuthorizationAmount: 'Pre-authorization Amount',
    room: 'Room',
    settlement: 'Settlement',
    pleaseSelectMemberInformation: 'Select member information',
    pleaseFillInThePaymentVerificationCode: 'Please enter payment verification code',
    accountNumber3: 'Account No.',
    successfulEntry: 'Posted Successfully',
    externalOrderNumber: 'External Order No.',
    transferTo: 'Transfer To',
    beAuthorized: 'Authorized',
    haveAlreadySettled: 'Settled',
    authorizationMode: 'Authorization Mode',
    authorizedAmount: 'Authorized Amount',
    authorizationTime: 'Authorization Time',
    productType: 'Product Type',
    pleaseEnterTheChannelNumber: 'Please enter channel order number',
    derive: 'Export',
    unwritten: 'Unwritten',
    cancelled3: 'Written Off',
    lehuiScanTheCode: 'Lehui - Scan Code',
    amountOnAccount3: 'Posted Amount',
    billingTime5: 'Posting Time',
    nameOfGuest3: 'Guest Name',
    roomNumber3: 'Room No.',
    people: 'People',
    nameOfExpenseItem: 'Expense Item',
    viewDetails: 'View Details',
    bankOfDeposit: 'Bank of Deposit',
    bankCardNumber4: 'Bank Card Number',
    toBeConfirmed2: 'To Be Confirmed',
    rejected: 'Rejected',
    adjustmentAmount: 'Adjustment Amount',
    meituan: 'Meituan',
    totalOrderAmount: 'Total Order Amount',
    lightSettlementWithMerchants: 'Qingzhu & Merchant Settlement',
    membershipDistribution: 'Membership Revenue Share',
    crossStoreRebate: 'Cross-store Rebate',
    avoidCommissionSubsidies: 'Qingzhu Commission Subsidy',
    membershipIncentiveSettlement: 'Membership Incentive Settlement',
    theUnitedStatesGroupDirectlyConnected: 'Meituan Direct Connection',
    flyingPigsConnectDirectly: 'Fliggy Direct Connection',
    fullNameOfTheBank4: 'Full Bank Name',
    accountBankAbbreviation4: 'Bank Abbreviation',
    theLocationOfTheBank4: 'Bank Location',
    pleaseEnterYourFullBankName2: 'Please enter full bank name',
    pleaseSelectBankAbbreviation2: 'Select bank abbreviation',
    pleaseSelectYourBankLocation2: 'Select bank location',
    pleaseEnterYourBankCardNumber2: 'Please enter bank card number',
    modificationTime2: 'Modification Time',
    bankExample: 'Example: ICBC XX Branch',
    companyNameNote: 'Note: Fill in corporate name if public account',
    causeOfFailure: 'Cause of Failure',
    pleaseEnterYourPhoneNumber: 'Please enter phone number',
    downloadStatement: 'Download Statement',
    operationLog: 'Operation Log',
    ctripDirectConnection: 'Ctrip Direct Connection',
    directConnectionInTheSameDirection: 'Tongcheng Direct Connection',
    flyingPig: 'Fliggy',
    ctrip: 'Ctrip',
    roomNight: 'Room Night',
    pictureUpload: 'Picture Upload',
    aSinglePictureMustNotBeLargerThan: 'Single picture must not exceed',
    checkInRoomType2: 'Check-in Room Type',
    checkInPerson: 'Check-in Guest',
    hotelSellingPrice: 'Hotel Selling Price',
    effectiveDate3: 'Effective Date',
    viewExamples: 'View Example',
    underReview: 'Under Review',
    billingType: 'Invoice Type',
    invoiceTitle2: 'Invoice Title',
    pleaseEnterTheInvoiceTitle2: 'Please enter invoice title',
    invoiceHasBeenIssued: 'Invoiced',
    haveBeenCancelled: 'Cancelled',
    paymentStatus: 'Payment Status',
    preferentialPrice: 'Discount Price',
    gateRate: 'Rack Rate',
    availableRoom: 'Available Rooms',
    orderableNumber: 'Bookable Number',
    numberOfRoomsReserved: 'Reserved Rooms',
    breakfast: 'Breakfast',
    copyOf: 'Copies',
    dailyRate: 'Daily Rate',
    typeOfTouristSource3: 'Market Segment',
    namephoneNumbermembershipNumber: 'Name / Phone / Member No.',
    selectTimePoint5: 'Select Time Point',
    externalChannel3: 'External Channel',
    retentionTime3: 'Retention Time',
    contactName2: 'Contact Name',
    numberOfDays: 'Number of Days',
    pleaseSelectAProtocolUnit3: 'Select a contract unit',
    pleaseEnterTheNameOfTheExternalChannel2: 'Please enter external channel name',
    pleaseFillInTheMembershipInformation3: 'Please enter membership information',
    pleaseFillInTheReservationName2: 'Please enter reservation name',
    pleaseFillInTheReservationNumber2: 'Please enter reservation phone number',
    theAmountCanOnlyBeEnteredInNumbers2: 'Amount must be a number',
    noMemberInformationFound: 'No member information found',
    noProtocolUnitIsQueried2: 'No contract unit found',
    bulkRepricing: 'Bulk Update Rates',
    totalRoomRate6: 'Total Room Rate',
    trialCalculationOfHousePrice3: 'Room Price Trial Calculation',
    free: 'Free',
    between: 'Rooms',
    upgradeRoomType: 'Upgrade Room Type',
    printOrNot: 'Print or Not',
    predepartureTime2: 'Planned Check-out Time',
    rooms: 'Rooms',
    averageHousePrice: 'Average Room Price',
    arrivalTime: 'Arrival Time',
    creationTime: 'Creation Time',
    advancedSearch: 'Advanced Search',
    simpleSearch: 'Simple Search',
    price: 'Price',
    orderTaking: 'Order Taking',
    sellingPrice: 'Selling Price',
    floorPrice: 'Floor Price',
    channelName2: 'Channel Name',
    bookingSuccessful2: 'Booking Successful',
    checkedIn2: 'Checked-in',
    cancelSuccessfully2: 'Cancelled Successfully',
    sorting: 'Sorting',
    invoiceNumber2: 'Invoice Number',
    taxIdentificationNumber: 'Tax Identification No.',
    emailAddress: 'Email Address',
    eTicket: 'Electronic VAT Invoice (Special)',
    eTicket2: 'Electronic VAT Invoice (Normal)',
    paperTicket: 'Paper VAT Invoice (Special)',
    paperTicket2: 'Paper VAT Invoice (Normal)',
    void: 'Voided',
    teamType: 'Group Type',
    teamName: 'Group Name',
    markUpAmount: 'Markup Amount',
    productName: 'Product Name',
    lengthOfStay2: 'Length of Stay',
    hours: 'Hours',
    checkIn: 'Check-in',
    changeRooms: 'Change Room',
    rowHouse: 'Assign Room',
    printCheckInSlip: 'Print Check-in Slip',
    proceedWith: 'Proceed',
    rowHouseSuccess2: 'Room Assigned Successfully',
    toCheckIn: 'To Check In',
    checkedOut: 'Checked Out',
    onAccount: 'On account',
    basicInformation: 'Basic Information',
    prepayment: 'Prepayment',
    originalHouseType: 'Original Room Type',
    seeMore: 'See More',
    thisRoomSupportsSmartDoorLocks: 'This room supports smart door locks',
    listingStatus: 'Room Order Status',
    checkin: 'Check-in',
    preionization2: 'Pre Check-out',
    weekTitle: 'Week',
    thePriceActuallyPaidByTheGuest: 'Actual Price Paid by Guest',
    late3: 'N',
    late4: 'Days',
    nonCancellable2: 'Non-cancellable',
    one: 'One',
    two: 'Two',
    three: 'Three',
    four: 'Four',
    five: 'Five',
    six: 'Six',
    lightweightDistribution: 'Qingzhu Distribution',
    liveAndTravelLightly: 'Qingzhu Business Travel',
    jingdongDirectLink: 'JD Direct Link',
    baiduMapDirectConnection: 'Baidu Map Direct Link',
    tiktokDirectConnection: 'TikTok Direct Link',
    ctripSingleStore: 'Ctrip Single Store',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
    preCancelable: 'Cancelable Before Stay',
    partialWriteOff: 'Partially Written Off',
    tookEffect: 'Took Effect',
    loseEffectiveness: 'Invalid',
    joinAHouse3: 'Link Rooms',
    bookingInformation: 'Booking Information',
    pleaseSelectARoom3: 'Select a room',
    houseInformation: 'Linked Room Info',
    thereIsNoRowHouse: 'Room not assigned',
    reasonsForChangingRooms3: 'Reason for Room Change',
    numberOfRooms7: 'Total Number of Rooms',
    typeOfOperation3: 'Operation Type',
    exchangeAndUpgradeReport2: 'Room Change & Upgrade Report',
    noDataAvailable2: 'No Data Available',
    pleaseSelectABusinessDayRange2: 'Select business day range',
    exportReport: 'Export',
    accountName3: 'Subject Name',
    aMaximumOf31DaysCanBeQueried: 'Maximum query range is 31 days',
    naturalDay2: 'Calendar Day',
    otherConsumption3: 'Other Consumption',
    aggregateConsumption3: 'Total Consumption',
    aggregateConsumptionTaxIncluded: 'Total Consumption (Tax Included)',
    aggregateConsumption3: 'Total Spend',
    materialType: 'Material Type',
    materialName: 'Material Name',
    storageTypeSell: 'Sell',
    materialCode: 'Material Code',
    materialUnit: 'Unit',
    inStorageNum: 'Stock In Quantity',
    outStorageNum: 'Stock Out Quantity',
    selectTime: 'Select time',
    floor: 'Floor',
    lumpSumPayment3: 'Total Payment',
    ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay:
      'Charge full-day room rate if amount exceeds half-day rate but less than full-day rate',
    businessDate: 'Business Date',
    calculationFormula: 'Calculation',
    manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight:
      'Manual additional room fee calculation: Half-day = 0.5 room-night, Full-day = 1 room-night',
    halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate:
      'Half-day rate: Extra charge ≤ half of room rate',
    fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn:
      'Full-day rate: Extra charge ≥ full room rate. If exceeds twice the rate, record 2 room-nights, and so on.',
    rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights:
      'Rented room-nights exclude free & self-use rooms',
    subtotal: 'Subtotal',
    totalOccupancy3: 'Total Rooms',
    lettingRate: 'Occupancy Rate',
    inResidenceDate: 'In-house Date',
    bookingDate: 'Booking Date',
    exposureNumber2: 'Exposure Count',
    numberOfVisitors3: 'Visitors',
    onlineChannel3: 'Online Channel',
    reasonForDeactivation: 'Out of Service Reason',
    downTime: 'Deactivation Time',
    enterAMaximumOf20Characters: 'Enter up to 20 characters',
    checkInInformation: 'Check-in Information',
    numberOfRooms6: 'Number of Rooms',
    totalPrice: 'Total Price',
    paymentInformation2: 'Payment Information',
    pleaseSelectAProduct: 'Select a product',
    viewOrderDetails: 'View Order Details',
    automaticallyJumpToOrderDetails: 'Automatically jump to order details',
    addHoming3: 'Add Co-occupant',
    getVerificationCode: 'Get Verification Code',
    pleaseSelectTheNumberOfRoomsFirst: 'Please select number of rooms first',
    theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms:
      'Reserved rooms cannot exceed available rooms',
    pleaseEnterAmount: 'Please enter amount',
    makeAReservation: 'Make Reservation',
    increaseRoomType: 'Add Room Type',
    deleteRoomType: 'Delete Room Type',
    store: 'Store',
    meituanDirectNew: 'Meituan Direct (New)',
    outOfService: 'Out of Service',
    smokeFreeOrNot: 'Non-smoking or Not',
    roomOrientation: 'Room Orientation',
    windowCondition: 'Window Condition',
    windowed: 'With Window',
    windowless: 'No Window',
    innerFenestra: 'Inner Window',
    roomCharacteristics: 'Room Features',
    airAndClean: 'Vacant Clean',
    airViscus: 'Vacant Dirty',
    dendrojing: 'Clean Room',
    astriction: 'Dirty Room',
    continuousStaySpecial: 'Long-stay Discount',
    orderEarlyAndReduceMore: 'Early Booking Discount',
    discountValue: 'Discount',
    select: 'Select',
    becameInvalid: 'Invalid',
    dateOfOperation: 'Operation Date',
    promotionalAllocation: 'Promotion Setup',
    promotionManagement: 'Promotion Management',
    operationContent2: 'Operation Content',
    turnOnAutomaticDeferral: 'Enable Auto Price Extension',
    productSetup: 'Product Setup',
    thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan99998Yuan:
      'Price must not be lower than 20  or higher than 99998000 ',
    iKnow: 'I Know',
    dataSpecification: 'Data Description',
    settings: 'Settings',
    restrictSales: 'Limit Sales',
    pleaseEnterPrice: 'Please enter price',
    modificationFailure: 'Modification Failed',
    deletionFailure: 'Deletion Failed',
    product: 'Product',
    pleaseSelectChannel: 'Channel',
    standardProduct: 'Standard Product',
    bindingSuccessful: 'Binding Successful',
    lobby: 'Lobby',
    inventoryQuantity: 'Inventory Quantity',
    uploadPictures: 'Upload Pictures',
    currentlyLimitedTo10Images: 'Limited to 10 images currently',
    pictureSizeMustBeLargerThan: 'Picture size must be larger than',
    warn3: 'Warning',
    theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck:
      'Input on this page is invalid. Please check',
    layer: 'Layer',
    untie: 'Unbind',
    cipher5: 'Password',
    pleaseEnterYourAccountNumber: 'Please enter account',
    pleaseEnterPassword4: 'Please enter password',
    obtainTheSmsVerificationCode: 'Get SMS Code',
    disposition: 'Configuration',
    passwordType: 'Password Type',
    setANewPassword: 'Set New Password',
    pleaseEnterYourNewPassword: 'Please enter new password',
    confirmPassword: 'Confirm Password',
    pleaseEnterYourPasswordAgain: 'Please enter password again',
    electronicPriceBoard: 'Digital Price Board',
    operationInstruction: 'Instructions',
    cardholder: 'Cardholder',
    contact: 'Contact',
    pleaseEnterTheCardholderName: 'Please enter cardholder name',
    cardholderNameIsRequired: 'Cardholder name is required',
    theCardholderNameMustBe2To5CharactersLong: 'Cardholder name must be 2–5 characters',
    remarksRequired: 'Remarks required',
    selectCardType: 'Select Card Type',
    windowType2: 'Window Type',
    suspensionOfSale: 'Pause Sale',
    enterMaterialName: 'Enter material name',
    modifyTarget: 'Modify Target',
    theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth:
      'Recommended target is estimated based on last year’s same period trends and last month’s data',
    dayUnit: '{day} days',
    checkInOperator: 'Check-in Operator',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    week: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun',
    },
    pleaseSelectStatus: 'Product Status',
    pleaseSelectPre: 'Show Pre-sale',
    pleaseSelectEb: 'Eb Products',
  },
  language: {
    zh: '中文',
    en: 'EN',
    zhHk: '繁体',
    th: 'ไทย',
    id: 'Indonesian',
    es: 'Español',
    vi: 'Tiếng Việt',
  },
  accountIndex: {
    scope: 'Application Scope',
    confirmDelete: 'Are you sure to delete this account set?',
    onlyDeleteDisabled: 'Only disabled accounts can be deleted',
    cancelDelete: 'Deletion cancelled',
  },
  accountsetMember: {
    accountSubject: 'Book account',
    addCash: 'Add cash',
    roomAccount: 'Room Account',
    pleaseEnterTheExternalOrderNumber: 'Please enter the external order number',
    consumptionStatement: 'Consumption statement',
    submitted: 'Submitted',
    pleaseFillInTheAmountSpent: 'Please fill in the amount spent',
    theAmountSpentMustBeGreaterThan: 'The amount spent must be greater than',
    blanked: 'Blanked',
    pleaseFillInTheRoomAccount: 'Please fill in the room account',
    pleaseSelectAnAccount: 'Select an account',
    pleaseSelectASmallItem: 'Select a small item',
    newSuccess: 'New success',
    goAndCheck: 'Go and check',
  },
  componentsCostprint8cmprint: {
    dateOfConsumption: 'Date of consumption',
  },
  componentsCostprinta4template: {
    totalConsumption: 'Total consumption',
    dateOfConsumption: 'Date of consumption',
    feeName: 'Fee name',
  },
  componentsCounter: {
    theGoodsAreOnlyInStock: 'The goods are only in stock',
    thereIsNotEnoughStockOfThisCommodity: 'There is not enough stock of this commodity',
  },
  componentsNowpayaccounthandle: {
    modifyTheBookSuccessfully: 'Modify the book successfully',
    bookModification: 'Book modification',
    pleaseEnterABookName: 'Please enter a book name',
    pleaseSelectTheConsumerCategory: 'Select the consumer category',
    newAccountSuccessfully: 'New account successfully',
  },
  componentsRecorddetail: {
    memberInfo: 'Member Name/Card Number',
  },
  componentsRushbalance: {
    successfulWriteOff: 'Successful write-off',
  },
  componentsShoppinggoods: {
    onlyAvailable: 'Only available',
    commodityCategory: 'Commodity category',
    pleaseEnterTheProductName: 'Please enter the product name',
    noDataIsQueried: 'No data is queried',
    name3: 'Name',
    purchaseQuantity: 'Purchase quantity',
    vendibility: 'Vendibility',
    allGoods: 'All goods',
  },
  componentsAddroomer: {
    addLabel: 'Add Label',
    noCustomerProfile: 'No customer profile is available for this guest',
    guestSaveFailedRetry: 'Failed to save guest. Please try again',
    changeOccupancy: 'Change occupancy',
    increaseOccupancy: 'Increase occupancy',
    validityPeriod: 'Document Validity Period',
    startDate: 'Start Date',
    addGuest: 'Add Guest',
    atLeastOneGuest: 'Please keep at least one guest',
    guest: 'Guest',
    enterGuestName: 'Please enter the name of {name}',
    enterValidPhone: 'Please enter a valid phone number for {name}',
    selectDocumentType: 'Select the document type for {name}',
    enterDocumentNumber: 'Please enter the document number for {name}',
  },
  componentsAnnouncement: {
    noticeBoard: 'Notice board',
  },
  componentsIdentifyMembers: {
    memberInformation: 'Member information',
    pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation:
      'Please fill in the guest mobile phone number, quick identification information',
    guestsCanUpgradeToAHigherLevelMembership: 'Guests can upgrade to a higher level membership',
    l: 'L',
    unnamed: 'Unnamed',
    inRealName: 'In real name',
    points: 'Points',
    memberRightsAndInterests: 'Member rights and interests',
    patron: 'Patron',
    unfold: 'Unfold',
    unactivated: 'Unactivated',
    membershipSalesCopy: 'Membership sales copy',
    bookingDiscount: 'Booking discount',
    costPerformance: 'Cost performance',
    memberPoints: 'Member points',
    lateCheckOut: 'Late check-out',
    copywritingType: 'Copywriting type',
    afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers:
      "After the guest authenticates themselves in the 'Light stay hotel reservation' mini - program, they can receive a 18 free birthday gift coupon or participate in exclusive offers",
    afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits:
      "After the guest logs in for the first time in the 'Light stay hotel reservation' mini - program, they can activate their membership and enjoy exclusive member benefits",
    lightStayMemberLevelNonMember: 'Light stay member level: Non-member',
    lightStayMembershipLevel: 'Light stay membership level',
  },
  componentsSellcard: {
    employeeLastWeeksCardSalesList: "Employee · Last week's card sales list",
    dragLeftAndRightToViewTheTable: 'Drag left and right to view the table',
    hotelLastWeeksCardSalesList: "Hotel · Last week's card sales list",
    cardSalesRanking: 'Card sales ranking',
    employee2: 'Employee',
    numberOfCardsSold: 'Number of cards sold',
    amountOfCommission: 'Amount of commission',
  },
  componentsoneCardDialog: {
    waitingForTheCustomerToSwipeTheirCard: 'Waiting for the customer to swipe their card',
    processingPayment: 'Processing payment',
    customerPaymentSuccessful: 'Customer payment successful',
    customerPaymentFailed: 'Customer payment failed, please initiate the payment again',
  },
  customerPSearch: {
    singleStoreMembershipLevel: 'Single store membership level',
    enterYourNamePhoneNumberAndCardNumber: 'Enter your name, phone number, and card number',
  },
  customerPTable: {
    topUp: 'Top-up',
    gift: 'Gift',
    viewMembers2: 'View Members',
    modifyMembership2: 'Modify membership',
    storedValueDeduction: 'Stored value deduction',
    integralChange2: 'Integral change',
    integralQuery2: 'Integral query',
    storedValueQuery2: 'Stored value query',
    rechargeAllAccumulatedRechargeAmounts: 'Recharge: All accumulated recharge amounts',
    giftAllAccumulatedGiftAmounts: 'Gift: All accumulated gift amounts',
    consumptionAllAccumulatedConsumptionAmounts: 'Consumption: All accumulated consumption amounts',
    refundAllAccumulatedRefundAmounts: 'Refund: All accumulated refund amounts',
    distributionSettings: 'Distribution settings',
  },
  componentsNightaudit: {
    theCurrentBusinessDayIs: 'The current business day is',
    startTheNightTrial: 'Start the night trial',
    theNightTrialIsInProgressAndCannotBeClosed:
      'The night trial is in progress and cannot be closed',
    immediateFeedback: 'Immediate feedback',
    nightAuditCompleted: 'Night audit completed',
    nightTrialInProgress: 'Night trial in progress',
    nightTrialNewsNotice2: 'Night trial news notice',
    nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport:
      'Night audit failed. Please handle according to the prompt and perform the night audit again. If you encounter any problems, please contact technical support',
  },
  componentsNightauditGrayEnv: {
    nightTrialNewsNotice2: 'Night trial news notice',
    procedure: 'Procedure',
    mistake: 'Mistake',
    carryOut: 'Carry out',
    nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve:
      "Night audit failure to encounter problems can be in the morning after 8 o 'clock, as soon as possible to contact technical support to help solve",
    whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully:
      'When an error occurs, the night audit stops, please confirm it carefully',
  },
  componentsOpenPageLayout: {
    backToHomePage: 'Back to home page',
  },
  componentsShiftchoose: {
    pleaseSelectFlightSchedule: 'Select flight schedule',
    hello: '，hello!',
  },
  baseBasemultipleselect: {
    thisOptionWasNotFound: 'This option was not found',
  },
  printsettingHalfprint: {
    test: 'Test',
    print: 'Print',
    trisection: 'Trisection',
    printInThirds: 'Print in thirds',
    printInHalf: 'Print in half',
  },
  printsettingPrint: {
    print: 'Print',
  },
  printsettingSmallprint: {
    feeName: 'Fee name',
    totalConsumption: 'Total consumption',
  },
  hardwareIdcardbtn: {
    readIdentityCard: 'Read identity card',
  },
  hardwareReaddoorcard: {
    pleasePlaceYourKeyCardOnTheCardReader: 'Please place your key card on the card reader',
    effectiveTime: 'Effective Time',
    failureTime: 'Failure Time',
    readCard: 'Read card',
    failedToObtainTheLockInformationProcedure: 'Failed to obtain the lock information. Procedure',
    thisCardIsNotAGuestCardPleaseReBusinessCardPrinting:
      'This card is not a guest card, please re-business card printing',
    wheatDoorLockPlugInReadCard: 'Wheat door lock plug-in read card',
    the: 'The',
    wheatDoorLockPlugInCancellationCard: 'Wheat door lock plug-in cancellation card',
    cardReadingFailure: 'Card reading failure',
  },
  componentsFeedback: {
    selectAttachment: 'Select attachment',
    viewFeedbackLog: 'View feedback log',
    commitFailure: 'Commit failure',
    problemFeedback3: 'Problem feedback',
    pleaseEnterTheContactName4: 'Please enter the contact name',
    pleaseEnterAContactNumber3: 'Please enter a contact number',
    uploadAttachment2: 'Upload attachment',
    pleaseEnterADetailedDescriptionOfTheProblem2:
      'Please enter a detailed description of the problem',
    theUploadedFilesCannotExceed: 'The uploaded files cannot exceed',
    aMaximumOfFiveFilesCanBeUploaded2: 'A maximum of five files can be uploaded',
    aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb:
      'A maximum of five files can be uploaded. The size of each file cannot exceed 20 MB',
    pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact:
      'Please explain the problem and enter the QQ number to facilitate contact',
  },
  componentsFeedjump: {
    lightWinTreasureSmallProgram: 'Light win treasure small program',
    scanCodeUsingASmallProgram: 'Scan code using a small program',
    realTimeControlOfRoomStatus: 'Real-time control of room status',
    onlineOneClickPriceAdjustment: 'Online one-click price adjustment',
    memberDevelopmentTools: 'Member development tools',
    moreFeaturesComingOnline: 'More features coming online',
    hotelOperationCarefulAssistant: 'Hotel operation · Careful assistant',
  },
  componentsGethelp: {
    getHelp: 'Get help',
  },
  componentsGoappshop: {
    applicationMarket: 'Application market',
  },
  componentsJointrain: {
    attendTraining: 'Attend training',
  },
  componentsLeftcontent: {
    hotelOperationsManager: 'Hotel operations manager',
    cityOperationsManager: 'City operations manager',
    customerServiceHotline: 'Customer service hotline',
  },
  componentsTrain: {
    trainingCoursesAreInFullSwing: 'Training courses are in full swing',
    getDetailedTrainingNoticesAndMaterials: 'Get detailed training notices and materials',
    followThelightStaySystemServicePublicAccount:
      "Follow the 'Light stay system service' public account",
    basicCourseIntroductorySeries: 'Basic course: introductory series',
    mondayAndWednesday1430Start: 'Monday and Wednesday 14:30 start',
    advancedCourseComplexScenesCommonQuestionsRecentNewFeatures:
      'Advanced course: complex scenes + common questions + recent new features',
    friday1430Start: 'Friday 14:30 start',
  },
  merchantPCtxTab: {
    oldFinancialReconciliationSystem: 'Old financial reconciliation system',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'Light commission subsidy has been moved to Member incentive, please go to Member incentive to confirm the bill',
  },
  merchantPCtxTab1: {
    oldFinancialReconciliationSystem: 'Old financial reconciliation system',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'Light commission subsidy has been moved to Member incentive, please go to Member incentive to confirm the bill',
  },
  merchantPSearchqu: {
    enterHotelName: 'Enter hotel name',
  },
  payIndex: {
    toBePaid: 'To be paid',
    pleaseScanQrCodeToCompletePayment: 'Please scan QR code to complete payment',
    canBeClosedAfter: 'Can be closed after',
    paymentSuccess: 'Payment success',
    automaticShutdownInSeconds: 'Automatic shutdown in seconds',
    automaticPageRefresh: 'Automatic page refresh',
    duringThePayment: 'During the payment',
    paymentAnomaly: 'Payment anomaly',
    ifThePaymentIsAbnormalContactTechnicalSupport:
      'If the payment is abnormal, contact technical support',
    paymentFailure: 'Payment failure',
    payOff: 'Pay off',
    waitForTheUserToScanTheCode: 'Wait for the user to scan the code',
    currentStatusOfLehuiPayment: 'Current status of Lehui payment',
    theGunScannedTheCodeSuccessfully: 'The gun scanned the code successfully',
    theUserHasPaidSuccessfully: 'The user has paid successfully',
    ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage:
      'If the user does not pay, it can be re-recorded in the finance page',
  },
  sellCalctable: {
    maximumPromotion: 'Maximum promotion',
    nonMemberSellingPricebrestimatedSettlementPrice:
      'Non-member selling price<br>/estimated settlement price',
    ordinaryMemberSellingPricebrestimatedSettlementPrice:
      'Ordinary member selling price<br>/estimated settlement price',
    goldMemberSellingPricebrestimatedSettlementPrice:
      'Gold member selling price<br>/estimated settlement price',
    platinumMemberSellingPricebrestimatedSettlementPrice:
      'Platinum member selling price<br>/estimated settlement price',
    diamondMemberSellingPricebrestimatedSettlementPrice:
      'Diamond member selling price<br>/estimated settlement price',
  },
  sellPTableTdNew: {
    noData: 'No data',
  },
  sellPricecalc: {
    channelSellingPriceCalculator: 'Channel selling price calculator',
    selectRoomType: 'Room Type',
    pleaseSelectRoomType: 'Room Type',
    selectProduct: 'Select product',
    pleaseSelectAProductName: 'Select a product name',
    selectSaleDate: 'Select sale date',
    distributionChannel: 'Distribution channel',
    pleaseSelectTheDistributionChannelNamenotRequired:
      'Please select the distribution channel name (not required)',
    canNotExceed: 'Can not exceed',
    pleaseSelectASaleDate: 'Select a sale date',
    figure: 'Figure',
  },
  filtersIndex: {
    all: 'All',
    sinceThe: 'Since the',
    free: 'Free',
    group: 'Group',
    association: 'Association,',
    theClock: 'The clock',
    long: 'Long',
    inapplicability: 'Inapplicability',
    haveProcessed: 'Have processed',
    notProcessed: 'Not processed',
    averageSalesRate: 'Average sales rate',
    consumptionNight: 'Consumption night',
    averageHousePriceOfConsumption: 'Average house price of consumption',
    onlinePermeability: 'Online permeability',
    cancelNight: 'Cancel night',
    rejectionNight: 'Rejection night',
    channelProvision: 'Channel provision',
    theHotelProvides: 'The hotel provides',
  },
  jsonBookertypeoptions: {
    singleStoreMember: 'Single store member',
    lightLivingMember: 'Light living member',
  },
  layoutIndex: {
    collapseMenuBar: 'Collapse',
  },
  componentsNavbar: {
    shiftManagement: 'Shift Management',
    helpCenter: 'Help Center',
    logout: 'Logout',
    reportTitle: 'Shift Handover Summary Report',
    headers: {
      income: 'Income',
      expend: 'Expenditure',
      total: 'Total Amount',
    },
  },
  componentsSidemessage: {
    orderNotice: 'Order notice',
    orderMessageReceivedNotification: 'Order message received notification',
    youDoNotHaveOrderManagementPermission: 'You do not have order management permission',
    ignore: 'Ignore message',
    order: 'Order message',
    noData: 'No new information yet',
    system: 'System message',
    settlement: 'Settlement message',
    dynamic: 'News feed',
    serviceManagement: 'Service order management',
    roomService: 'Room service',
    itemBorrow: 'Borrowing',
    extendStay: 'Continuation service',
    notice: 'Notice',
    aiNoticeMsg: 'new AI notification(s)',
    manualEntry: 'Manual entry',
    confirmOrder: 'Order confirmation',
    viewOrder: 'View order',
    youDoNotHaveAccessToEbkOrderManagement: 'You do not have access to EBK order management',
    youReceive: 'You receive',
    aNewMessage: 'A new message',
    have: 'Have',
    orderMessage: 'Order message',
    aNewSystemMessage: 'A new system message',
    aNewSettlementMessage: 'A new settlement message',
  },
  componentsSoundnotice: {
    playOut: 'Play out',
    theVoicePromptsThatAMessageIsReceived: 'The voice prompts that a message is received',
  },
  nightcheckNightStart: {
    nightTrialSequence: 'Night trial sequence',
    nightAuditInstructions2: 'Night audit instructions',
  },
  nightcheckNightTip: {
    theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible:
      "The hotel has not been audited at night, in order to avoid affecting the hotel's revenue data, please start the night audit as soon as possible",
    nightAuditInstructions2: 'Night audit instructions',
    beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue:
      "Before the night audit, please be sure to check whether the hotel's accounting data is correct in advance to avoid affecting the hotel's revenue",
    pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed:
      'Please confirm that all check-in and check-out orders for the current business day have been processed',
    youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived:
      'You have set up a night audit to automatically cancel the store orders that have not arrived',
    preArrivalAutoCheckIn: 'You have set up automatic check-in for pre-arrival orders during night audit',
    preArrivalAutoNoshow: 'You have set up automatic no-show marking for pre-arrival orders during night audit',
    preDepartureAutoCheckOut: 'You have set up automatic check-out for pre-departure orders during night audit',
    preDepartureAutoExtendStay: 'You have set up automatic room extension for pre-departure orders during night audit',
    theEarliestTimeForManualNightAuditIs: 'The earliest time for manual night audit is',
    nightAuditProcess: 'Night audit process',
    hotelBusinessDaysAreNowGreaterThanNaturalDays:
      'Hotel business days are now greater than natural days',
    nightAuditReminder: 'Night audit reminder',
    hotelBusinessDay: 'Hotel business day',
    currentNaturalDay: 'Current natural day',
    viewLogs: 'View logs',
    theNightTrialWasCompleted: 'The night trial was completed',
    nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh:
      "Night audit start time can not be earlier than 21 o 'clock, can not perform night audit operation oh",
    thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure:
      'There is an ongoing night trial. Please do not repeat the procedure',
  },
  nightcheckNightTipGrayEnv: {
    theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation:
      "The current business day of the hotel is longer than the natural day, or the night audit can not start earlier than 21 o 'clock, can not perform the night audit operation",
    theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible:
      'The night trial has not been completed, please execute the night trial as soon as possible',
  },
  globalMethodsmixin: {
    hotelChangeAlert: 'Hotel change alert',
    theHotelIsCurrentlyFrom: 'The hotel is currently from',
    switchTo: 'Switch to',
  },
  regularIndex: {
    pleaseEnterTheCorrectEmailAddress: 'Please enter the correct email address',
    pleaseEnterTheCorrectIdNumber: 'Please enter the correct ID number',
    pleaseEnterTheCorrectIdNumber2: 'Please enter the correct ID number',
  },
  sidebarLogo: {
    helpCenter2: 'Help center',
  },
  modulesMember: {
    drench: 'Drench',
  },
  modulesUser: {
    client: 'Client',
    membershipManagement: 'Membership management',
    singleStoreMemberManagement: 'Single store member management',
    storeValueManagement: 'Store value management',
    singleStorePointsSetting: 'Single store points setting',
    storeValueReport: 'Store value report',
    failedToObtainOperationInformationProcedure:
      'Failed to obtain operation information. Procedure',
    billReconciliation: 'Bill reconciliation',
    paymentRecord: 'Payment record',
    expenseStatement: 'Expense statement',
  },
  utilsAddroute: {
    initializesTheReceivableFinancialMenu: 'Initializes the receivable financial menu',
  },
  utilsDoorcard: {
    initializationFailure: 'Initialization failure',
    noKeyCardReaderPlugInFound: 'No key card reader plug-in found',
    cardReadingError: 'Card reading error',
    plugIn: 'Plug-in',
    cardReadingResult: 'Card reading result',
    cardReadingFailure: 'Card reading failure',
    businessCardWriteData: 'Business card write data',
    businessCardPrintingResult: 'Business card printing result',
    businessCardFailure: 'Business card failure',
    logoutStatusCode: 'Logout status code',
    logoutFailure: 'Logout failure',
  },
  utilsDoorcardmaitian: {
    noKeyCardReaderPlugInFound: 'No key card reader plug-in found',
    cancelTheCardSuccessfully: 'Cancel the card successfully',
    readTheCardSuccessfully: 'Read the card successfully',
  },
  utilsEnum: {
    roomInNeedOfRepair: 'Room in need of repair',
    guestRequest: 'Guest request',
    hotelRowRoomDemand: 'Hotel row room demand',
    inProcess: 'In process',
    alreadyEnded: 'Already ended',
    storeOrderPreArrivalHasNotBeenChecked: 'Store order pre-arrival has not been checked',
    leaveTheRoomForInspectionToday: 'Leave the room for inspection today',
    generateRoomChargesInTheRoom: 'Generate room charges in the room',
    cleanRoomToDirtyRoom: 'Clean room to dirty room',
    switchingDay: 'Switching day',
    preArrivalNoShowRoomListPending: 'Pre-arrival no show, room list pending',
    preSeparationIsNotSeparated: 'Pre-separation is not separated',
    allRoomChargesAreGeneratedAndRecordedInTheAccount:
      'All room charges are generated and recorded in the account',
    roomChange: 'Room change',
    generateCureReport: 'Generate cure report',
    shopHourRoom: 'Shop hour room',
    onlineHourRoom: 'Online hour room',
    presaleFullDayRoomProduct: 'Presale full - day room product',
    presaleClockRoomProduct: 'Presale clock room product',
  },
  utilsFreego: {
    theCardReaderIsNotConnectedToTheComputer: 'The card reader is not connected to the computer',
    checkValueError: 'Check value error',
    passwordError: 'Password error',
    readCard: 'Read card',
    cardReaderCommunicationIsNormal: 'Card reader communication is normal',
    businessCardPrintingSoftwareIsNotOpened: 'Business card printing software is not opened',
    theReaderIsNotConnectedOrTheSoftwareIsNotOpen:
      'The reader is not connected or the software is not open',
    sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome:
      'Sorry, your browser does not support card reader, please use chrome',
  },
  utilsIdcard: {
    idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage:
      'Id card reader is connected. To scan your ID card, connect the ID card scanner to your computer. And refresh the page',
    toScanDocumentsInstallTheIdCardReaderControl:
      'To scan documents, install the ID card reader control',
    abnormalReadingIdCardPleaseRefreshAndTryAgain:
      'Abnormal reading ID card, please refresh and try again',
    noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition:
      'No ID information is read, please check whether the ID card is placed or placed in the correct position',
  },
  utilsIndex: {
    justNow: 'Just now',
    aMinuteAgo: 'A minute ago',
    hoursAgo: 'Hours ago',
    month: 'Month',
    when: 'When',
    connectionSuccessful: 'Connection successful',
    theGlobalConnectionIsClosed: 'The global connection is closed',
    yourBrowserDoesNotSupportIt: 'Your browser does not support it',
  },
  utilsLinktopage: {
    contactTheAdministratorToEnableIt: 'Contact the administrator to enable it',
    noCorrespondingLedgerFound: 'No corresponding ledger found',
    accountReceivable: 'Account receivable',
    administrativeAuthority: 'Administrative authority',
  },
  utilsRequest: {
    doNotRepeatRequests: 'Do not repeat requests',
    noFlightFoundPleaseSelectAgain: 'No flight found, please select again',
    systemErrorPleaseContactTechnicalSupport: 'System error. Please contact technical support',
    networkException: 'Network exception',
    requestTimedOutPleaseRefreshThePage: 'Request timed out, please refresh the page',
    requestTimeout: 'Request timeout',
    requestFailed: 'Request failed',
  },
  utilsSharestorage: {
    putInTheInitialMarker: 'Put in the initial marker',
  },
  vendorVLoading: {
    hardLoading2: 'Hard loading',
  },
  appdetailIndex: {
    specification: 'Specification',
    contactBusinessManager: 'Contact Business Manager',
    buyNow: 'Buy now',
    applicationIntroduction: 'Application introduction',
    workingHours: 'Working hours',
    pleaseSelectProductSpecifications: 'Select product specifications',
  },
  applistIndex: {
    fullApplication: 'All Apps',
    haveOpened: 'Active',
    haveNotOpened: 'Inactive',
    inService: 'Processing',
    contactBusinessManager: 'Contact Manager',
    workingHours: 'Working Hours',
    openImmediately: 'Open Now',
    immediateRenewal: 'Renew Now',
    expiredDays: 'Expired {days} days ago',
    daysLeftToExpire: '{days} days left',
  },
  createorderIndex: {
    goToPay: 'Go to pay',
    remaining: 'Remaining:',
    orderProduct2: 'Order product',
    purchaser2: 'Purchaser',
    specification: 'Specification',
    successfulCustomsOrder2: 'Successful customs order',
  },
  createorderPay: {
    amountPaid: 'Amount paid',
    paymentCountdown: 'Payment countdown',
    qrCodeHasExpired: 'Qr code has expired',
    updateNow: 'Update now',
    payment3: 'Payment',
    scanQRCode: 'Please scan the QR code using WeChat/Alipay to pay',
  },
  orderlistIndex: {
    orderDate: 'Order date',
    product: 'Product',
    toBePaid: 'To be paid',
    paymentSuccess: 'Payment success',
    paymentFailure: 'Payment failure',
    refunded: 'Refunded',
    partialRefund: 'Partial refund',
    goToPay: 'Go to pay',
    orderTime: 'Order time',
    orderProduct2: 'Order product',
    orderSpecification: 'Order specification',
    refundAmount: 'Refund amount',
    orderEffectiveTime: 'Order effective time',
    purchaser2: 'Purchaser',
    orderOperation: 'Order operation',
    successfulCustomsOrder2: 'Successful customs order',
  },
  commentChannelComment: {
    modifyReply: 'Modify reply',
    setAsTemplate: 'Set as template',
    selectRecommendedTemplate: 'Select recommended template',
    inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words:
      'Input reply content, no more than 10 words and no more than 500 words',
    theMaximumResponseTextIs500Characters: 'The maximum response text is 500 characters',
    areYouSureYouWantToDeleteReplies: 'Are you sure you want to delete replies',
  },
  commentCommentTempManage: {
    newTemplate: 'New template',
    goodReputation: 'Good reputation',
    delete2: 'Delete',
    templateName: 'Template name',
    replyClassification: 'Reply classification',
    replyContent2: 'Reply content',
    pleaseEnterAtLeast10Characters: 'Please enter at least 10 characters',
    keyword: 'Keyword',
    pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas:
      'Please enter the keywords that you want to match the comments separated by commas',
    pleaseEnterATemplateName: 'Please enter a template name',
    theValueCanContainNoMoreThan15Characters: 'The value can contain no more than 15 characters',
    pleaseSelectAReplyCategory: 'Select a reply category',
    pleaseEnterTheReplyContent: 'Please enter the reply content',
    '10To500CharactersInLength': '10 to 500 characters in length',
    theValueContainsAMaximumOf50Characters: 'The value contains a maximum of 50 characters',
    definitiveDeletion: 'Definitive deletion',
    deletingATemplateSucceeded: 'Deleting a template succeeded',
    creatingATemplateSucceeded: 'Creating a template succeeded',
  },
  commentComment: {
    reasonForNotPassing: 'Reason for not passing',
    setAsTemplate: 'Set as template',
    replyAgain: 'Reply again',
    reappeal: 'Reappeal',
    inComplaint: 'In complaint',
    typeOfAppeal: 'Type of appeal',
    statementOfAppeal: 'Statement of appeal',
    selectRecommendedTemplate: 'Select recommended template',
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'Input the reply content, the number of words more than 10 and 300 words',
    theMaximumResponseTextIs500Characters: 'The maximum response text is 500 characters',
    areYouSureYouWantToDeleteReplies: 'Are you sure you want to delete replies',
  },
  commentComplain: {
    onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted:
      'Once your complaint has been reviewed, the comment will be automatically deleted',
    youCanUploadUpToFivePictures: 'You can upload up to five pictures',
    launchAComplaint: 'Launch a complaint',
    typeOfAppeal: 'Type of appeal',
    statementOfAppeal: 'Statement of appeal',
    uploadCredentials: 'Upload credentials',
    pleaseFillInTheContact: 'Please fill in the contact',
    pleaseEnterTheCorrectName: 'Please enter the correct name',
    pleaseSelectTheAppealType: 'Please select the appeal type',
    theCauseOfTheComplaintMustBeAtLeast10Words:
      'The cause of the complaint must be at least 10 words',
    theMaximumCauseOfAppealIs300Words: 'The maximum cause of appeal is 300 words',
    underAppeal: 'Under appeal',
    addAppealSuccess: 'Add appeal success',
  },
  commentIndex: {
    totalEvaluation: 'Total evaluation',
    waitForReply: 'Wait for reply',
    appealed: 'Appealed',
    allRoomTypes: 'All room types',
    noReplyYet: 'No reply yet',
    toBeReviewed: 'To be reviewed',
    notPass: 'Not pass',
    alreadyPassed: 'Already passed',
  },
  commentMain: {
    deleteReplySucceeded: 'Delete reply succeeded',
    modifiedReplySucceeded: 'Modified reply succeeded',
  },
  commentPreview: {
    viewPicture: 'View picture',
  },
  commentReplyList: {
    replyDate: 'Reply date',
    commentChannel: 'Comment channel',
    review2: 'Review',
    replyContent2: 'Reply content',
    commentReply: 'Comment reply',
    modifyReply: 'Modify reply',
    deleteReply: 'Delete reply',
    meituanReview: 'MT Review',
    ctripReview: 'Ctrip Review',
    whereToComment: 'Where to comment',
    sameTripReview: 'Same trip review',
    dianpingReviews: 'Dianping reviews',
    flyingPigReview: 'Flying pig review',
    parallelComment: 'Parallel comment',
  },
  commentScore: {
    renewal: 'Renewal',
    guestImpression: 'Guest impression',
    overallGuestRating: 'Overall guest rating',
  },
  complainDetail: {
    issueDetails: 'Issue details',
    processingDetails: 'Processing details',
    serviceProblem: 'Service problem',
    healthProblem: 'Health problem',
    processor: 'Processor',
    processingTime: 'Processing time',
    communicationSituation: 'Communication situation',
  },
  complainHandle: {
    successfulProcessing: 'Successful processing',
    problemHandling: 'Problem handling',
    roomInformation: 'Room Information',
    guestInformation: 'Guest information',
    communicationSituation: 'Communication situation',
    enterAMaximumOf300Characters: 'Enter a maximum of 300 characters',
    pleaseEnterTheProcessingResult: 'Please enter the processing result',
  },
  complainIndex: {
    submissionDate: 'Submission date',
    processed: 'Processed',
    submissionTime: 'Submission time',
    feedbackProblem: 'Feedback problem',
    untreated: 'Untreated',
    viewTheResults: 'View the results',
  },
  ebkComment: {
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'Input the reply content, the number of words more than 10 and 300 words',
    theMaximumResponseTextIs300Characters: 'The maximum response text is 300 characters',
    modifiedReplySucceeded: 'Modified reply succeeded',
  },
  ebkGrade: {
    guestImpression: 'Guest impression',
  },
  ebkIndex: {
    totalEvaluation: 'Total evaluation',
    waitForReply: 'Wait for reply',
  },
  customerCompany: {
    new: 'New',
    whetherToAllowHangingAccounts2: 'Whether to allow hanging accounts',
    loginListHidesRates: 'Login list hides rates',
    confirmAction: "Confirm {action} company client '{name}'?",
  },
  customerDialog: {
    whetherToAllowHangingAccounts2: 'Whether to allow hanging accounts',
    theRegistrationFormHidesTheRoomRate: 'The registration form hides the room rate',
    addACorporateClient: 'Add a corporate client',
    changeCorporateAccount: 'Change corporate account',
    companyInformation: 'Company information',
    forShort: 'For short',
    pleaseEnterCompanyAbbreviation: 'Please enter company abbreviation',
    code: 'CODE',
    pleaseEnterTheCode: 'Please enter the code',
    legalPerson: 'Legal person',
    pleaseEnterTheLegalPersonName: 'Please enter the legal person name',
    fax: 'Fax',
    pleaseEnterTheFaxNumber: 'Please enter the fax number',
    city: 'City',
    postcode: 'Postcode',
    pleaseEnterPostalCode: 'Please enter postal code',
    pleaseEnterDiscountRatio: 'Please enter discount ratio',
    enterAMaximumOf100Characters: 'Enter a maximum of 100 characters',
    contactInformation: 'Contact information',
    pleaseEnterTheContactNumber: 'Please enter the contact number',
    pleaseEnterEmail: 'Please enter email',
    setUp: 'Set up',
    pleaseEnterYourAccountName: 'Please enter your account name',
    accountType: 'Account type',
    maximumAmount: 'Maximum amount',
    pleaseEnterDiscount: 'Please enter discount',
    pleaseEnterAnIntegerBetween0And100: 'Please enter an integer between 0 and 100',
    pleaseEnterTheCorrect11DigitMobileNumber: 'Please enter the correct 11-digit mobile number',
    pleaseEnterName: 'Please enter name',
    pleaseEnterTheContactName3: 'Please enter the contact name',
    creditAccount: 'Credit account',
    theCreditLimitCannotBeExceeded: 'The credit limit cannot be exceeded',
    enterRange: 'Please enter a number between 1 and 365',
  },
  customerIndex: {
    protocolUnitToBeDeveloped: 'Protocol unit, to be developed',
  },
  heavenlyEyeCallThePolice: {
    alarmEvent: 'Alarm event',
    shootingTime: 'Shooting time',
    theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto:
      'The following guests have not been added to the white list, select the guests that match the photo',
    stranger: 'Stranger',
    whiteAdded: 'White added',
    ignored: 'Ignored',
    whitelist: 'Whitelist',
    environmentalPhotograph: 'Environmental photograph',
    facePhoto: 'Face photo',
    pleaseSelectUser: 'Select User',
  },
  heavenlyEyeWhiteList: {
    personnelType: 'Personnel type',
    addStaff: 'Add staff',
    pleaseEnterTheRoomNumber: 'Please enter the room number',
    employee2: 'Employee',
    dweller: 'Dweller',
    avatar: 'Avatar',
    photograph: 'Photograph',
    pleaseSelectEnterName: 'Select Enter name',
    pleaseCompleteTheFormBeforeSubmitting: 'Please complete the form before submitting',
    inputLabelDuplication: 'Input label duplication',
    pleaseEnterTheLabelContent: 'Please enter the label content',
    doNotEnterLabelsInMoreThan10Words: 'Do not enter labels in more than 10 words',
    whetherToDeleteTheWhitelist: 'Whether to delete the whitelist',
    uploadImageFormat: 'Uploaded images can only be in JPG or PNG format!',
  },
  hicList: {
    dateOfPresentation: 'Date of presentation',
    dataExport: 'Data export',
    bookingChannel: 'Booking channel',
    bodyTemperature: 'Body temperature',
    healthStatus: 'Health status',
    theHealthInformationCollectionReportIsSuccessfullyExportedProcedure:
      'The health information collection report is successfully exported. Procedure',
    failedToExportTheHealthInformationCollectionReportProcedure:
      'Failed to export the health information collection report. Procedure',
  },
  hicQrCode: {
    downloadPicture: 'Download picture',
  },
  marketActivity: {
    couponType: 'Coupon type',
    couponName: 'Coupon name',
    beOffline: 'Be offline',
    terminated: 'Terminated',
    full: 'Full',
    reduction: 'Reduction',
    fromTheDateOfReceipt: 'From the date of receipt',
    withinDays: 'Within days',
    thisParameterIsValidWithinAFixedPeriod: 'This parameter is valid within a fixed period',
    restrictedRoomNight: 'Restricted room night',
    unlimited: 'Unlimited',
    oneNight: 'One night',
    discountType: 'Discount type',
    validForTimePeriod: 'Valid in period',
    instructionsForUse: 'Instructions for use',
    selectionOfParticipatingGoods: 'Selection of participating goods',
    allGoods: 'All goods',
    platform: 'Platform',
    theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully:
      'The name of the coupon will be displayed to the user, please fill it in carefully',
    denomination: 'Denomination',
    fillInTheCouponAmountdiscountAmount: 'Fill in the coupon amount (discount amount)',
    pleaseSelectTheYearMonthAndDay2: 'Please select the year, month and day',
    instructionsWillBeDisplayedToTheUserPleaseFillInCarefully:
      'Instructions will be displayed to the user, please fill in carefully',
    viewActivity: 'View activity',
    maxOut: 'Max out',
    availableForBooking1Room1NightOnly: 'Available for booking 1 room 1 night only',
    events: 'Events',
    orderNeedsToBeFull: 'Order needs to be full',
    issued: 'Issued',
    haveBeenUsed: 'Have been used',
    expired2: 'Expired',
    editCoupon: 'Edit coupon',
    addCoupon: 'Add coupon',
    pleaseSelectTheOfferType: 'Select the offer type',
    pleaseEnterExpiryDate2: 'Please enter expiry date',
    pleaseSelectExpirationDate: 'Select expiration date',
    pleaseEnterTheCouponName2: 'Please enter the coupon name',
    amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter:
      'Amount can only be entered in positive integers, please re-enter',
    successfulActivation: 'Successful activation',
    deactivated: 'Deactivated',
    pleaseConfirmWhetherYouWantToTerminate: 'Please confirm whether you want to terminate',
    terminationSuccess: 'Termination success',
    cancelledTermination: 'Cancelled termination',
    pleaseEnterTheValidityPeriod: 'Please enter the validity period',
    createACoupon: 'Create a coupon',
    unedited: 'Unedited',
    discountTemplate: 'Instant discount { money } ',
    fullReductionTemplate: 'Full { minAmount }  reduction',
    validityDaysTemplate: 'Valid for { day } days from receipt',
    activationConfirmation: 'The coupon cannot be modified after activation, confirm to activate?',
    importValidationWarning: 'Some imported hotel validations are abnormal, continue?',
  },
  marketActivitydata: {
    classificationSpecification: 'Classification specification',
    data: 'Data',
    marketingRevenue: 'Mkt Rev',
    marketingExpenses: 'Marketing expenses',
    numberOfContacts: 'Number of contacts',
    numberOfVisitors: 'Number of visitors',
    numberOfTransactions: 'Number of transactions',
    revenueDescription: '30-day reached user revenue',
    costDescription: 'Marketing costs in 30 days ',
    reachCountDescription: 'Users reached by marketing in 30 days',
    visitCountDescription: 'Reached users visiting this store in 30 days',
    orderCountDescription: 'Orders after reach in 30 days',
  },
  marketCrowddata: {
    subdivide: 'Subdivide',
    classificationSpecification: 'Classification specification',
    numberOfPeople: 'Number of people',
    membersWhoHaveStayedAtThisStore: 'Members who have stayed at this store',
    allMembers: 'All members',
    usersWhoHaveStayedInThisStoreInThePast1Year:
      'Users who have stayed in this store in the past 1 year',
    lowFrequencyMember: 'Low frequency member',
    usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months:
      'Users who have stayed in the last 1 year, but have not stayed in the last 3 months',
    loyalUser: 'Loyal user',
    usersWhoHaveStayedAtLeast3TimesInTheLast1Year:
      'Users who have stayed at least 3 times in the last 1 year',
    lostUsers: 'Lost users',
    usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year:
      'Users who have stayed in the past 2 years and have not stayed in the past 1 year',
    interestedMember: 'Interested member',
    interestedUserGroupsOfThisStore: 'Interested user groups of this store',
    inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder:
      'In the past 7 days, the user has entered the homepage of the mini program of the hotel and has not placed an order',
    localInterestUserGroups: 'Local interest user groups',
    inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated:
      'In the past 7 days, I have searched the city and hotel where the hotel is located',
    orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder:
      'Or entered other hotels in the city, but did not place an order',
    intraCityUserGroup: 'Intra-city user group',
    usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore:
      'Users who have stayed in the city in the last 30 days are not users of this store',
    createActivity: 'Create activity',
    lowFrequencyUser: 'Low frequency user',
    marketingSuggestion:
      'Suggestion: Create marketing campaigns promptly to retain users and increase orders!',
  },
  marketDatakb: {
    crowdDataBulletinBoard: 'Crowd data bulletin board',
    activityDataKanban: 'Activity data Kanban',
  },
  marketDistribution: {
    releaseTime: 'Release time',
    events: 'Events',
    releaseMode: 'Release mode',
    smsSending: 'SMS sending',
    publicAccount: 'Public account',
    stopSmsPlatformPush: 'Stop SMS platform push',
    stopThePublicAccountPush: 'Stop the public account push',
    iHaveReadAndAgree: 'I have read and agree',
    precisionMarketingRules: 'Precision marketing rules',
    pleaseReadAndAgree: 'Please read and agree',
    warmReminder: 'Warm reminder',
    issue: 'Issue',
    couponName: 'Coupon name',
    pleaseEnterTheCouponName2: 'Please enter the coupon name',
    sendingCrowd: 'Sending crowd',
    pleaseSelectTheSender: 'Select the sender',
    quantityIssued: 'Quantity issued',
    pleaseFillInTheNumberOfIssuedCards: 'Please fill in the number of issued cards',
    sendingMode: 'Send mode',
    notificationTemplate: 'Notification template',
    pleaseSelectANotificationTemplate: 'Select a notification template',
    projectedCost: 'Projected cost',
    allUsers: 'All users',
    interestedUsersOfThisStore: 'Interested users of this store',
    lostUsers: 'Lost users',
    loyalUser: 'Loyal user',
    lowFrequencyUser: 'Low frequency user',
    interestedUsersInTheSameCity: 'Interested users in the same city',
    localUser: 'Local user',
    unactivated: 'Unactivated',
    terminated: 'Terminated',
    voucherInformation: 'Voucher information',
    issuer: 'Issuer',
    pleaseEnterTheReleaseQuantity: 'Please enter the release quantity',
    couponIssuedSuccessfully: 'Coupon issued successfully',
    pleaseEnterCoupon: 'Please enter coupon',
    sendBatch: 'Send batch',
    pleaseEnterTheCorrectCoupon: 'Please enter the correct coupon',
    perPersonUnit: 'Sheets/person',
    rule1:
      '1. Marketing activities should not be created too frequently. LightStay has anti-fatigue mechanisms on the user side, limiting the number of marketing pushes/SMS users can receive within a certain period.',
    rule2:
      '2. To prevent hotels from overusing marketing pushes/SMS, which may harass users and damage brand image, this feature limits users to receive only 1 push per channel within 7 days.',
    rule3: '3. Marketing pushes/SMS delivery is not guaranteed, actual reach results may vary.',
    rule4:
      '4. Unsuccessful marketing pushes/SMS will have fees refunded, and delivery records must clearly list successes/failures.',
  },
  marketRules: {
    rulesRulesRules: 'Rules rules rules',
  },
  memberActivityManage: {
    longTerm: 'Long-term',
    customInterval: 'Custom interval',
    activeTime: 'Active time',
    addActivity: 'Add activity',
    editingActivity: 'Editing activity',
    editGear: 'Edit gear',
    addGear: 'Add gear',
    unlimited: 'Unlimited',
    rechargeAmount2: 'Recharge amount',
    enabledState: 'Enabled state',
    activeState: 'Active state',
    pleaseEditTheAddedGears: 'Please edit the added gears',
  },
  memberIntegralSetting: {
    integralRatioSetting: 'Integral ratio setting',
    points: 'Points',
    automaticCumulativePointSetting: 'Automatic cumulative point setting',
    storedValueConsumption: 'Stored-value consumption',
    nonCumulativeIntegral: 'Non-cumulative integral',
    pleaseFillInThePointsRatioSetting: 'Please fill in the points ratio setting',
    pleaseSelectTheAutomaticAccumulationPointSetting:
      'Please select the automatic accumulation point setting',
    roomAndStoredConsumption: 'Room Fee + Stored Value Consumption',
    integralRatioLimit: 'Integral ratio must be between 0.01 and 1000',
  },
  memberMemberManage: {
    pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate:
      'Please arrange member information according to the requirements in the template',
    downloadTemplate: 'Download template',
    freeCommissionPolicyTips: 'Free commission policy tips',
    downloadFailureData: 'Download failure data',
    normal: 'Normal',
    registrationTime: 'Registration time',
    entryTime: 'Entry time',
    augment: 'Augment',
    decrease: 'Decrease',
    singleStoreStoredValueBillPrinting: 'Single store stored-value bill printing',
    theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores:
      'The amount of member stored value is only available in this store and is not available in other stores',
    currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable:
      'Current members have unused balances or points, please confirm whether to disable',
    lightLivingMember: 'Light living member',
    startOfEntryDate: 'Start of entry date',
    dateOfEntry: 'Date of entry',
    membershipIntroduction: 'Membership introduction',
    memberExport: 'Member export',
    newMember: 'New Member',
    viewGrade: 'View grade',
    viewMembers2: 'View Members',
    storedValueQuery2: 'Stored value query',
    transactionType: 'Transaction type',
    registered: 'Registered',
    unregistered: 'Unregistered',
    theAmountOfThisStoredValue: 'The amount of this stored value',
    storedValueActivity: 'Stored value activity',
    eventGiftAmount: 'Event gift amount',
    currentStoredValueBalance: 'Current stored value balance',
    storageTime: 'Storage time',
    currentBalance: 'Current balance',
    topUpTheTotalAmount: 'Top up the total amount',
    totalGiftAmount: 'Total gift amount',
    totalPayment: 'Total payment',
    totalRefundAmount: 'Total refund amount',
    singleStoreMembershipLevel: 'Single store membership level',
    storePoints: 'Store points',
    storedValueAccumulation: 'Stored value accumulation',
    incorrectEmailFormat: 'Incorrect email format',
    membershipLevel: 'Membership level',
    occupation: 'Occupation',
    pleaseEnterOccupation: 'Please enter occupation',
    salespersonName: 'Salesperson Name',
    salespersonId: 'Salesperson ID',
    pleaseEnterSalespersonId: 'Please enter salesperson ID',
    pleaseEnterTheSalespersonsName: "Please enter the salesperson's name",
    pleaseSelectTheYearMonthAndDay2: 'Select the year, month and day',
    detailedAddress: 'Detailed address',
    lv: 'Lv.',
    gradeName: 'Grade name',
    variableIntegral: 'Variable integral',
    pointBalance: 'Point balance',
    transactionAmount: 'Transaction amount',
    changeType: 'Change type',
    changeOfAmount: 'Change of amount',
    pleaseEnterAnInteger: 'Please enter an integer',
    topUpActivity: 'Top-up activity',
    pleaseSelectAnActivity: 'Select an activity',
    activeGear: 'Active gear',
    rechargeAmount2: 'Recharge amount',
    pleaseEnterTheRechargeAmount: 'Please enter the recharge amount',
    amountReceivable: 'Amount receivable',
    printDocuments: 'Print documents',
    deductionAmount: 'Deduction amount',
    pleaseEnterTheAmountOfDeduction: 'Please enter the amount of deduction',
    increaseTheIntegral: 'Increase the integral',
    reduceIntegral: 'Reduce integral',
    filling: 'Filling',
    send: 'Send',
    pleaseEnterTheCorrectIdNumber: 'Please enter the correct ID number',
    pleaseEnterTheCorrectIdNumber2: 'Please enter the correct ID number',
    pleaseFillInTheIdNumber: 'Please fill in the ID number',
    operationFailure: 'Operation failure',
    youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions:
      'You do not have access rights, please contact Light live operations to add permissions',
    currentLimitSelect1FilePleaseRemoveAndAdd: 'Current limit Select 1 file, please remove and add',
    memberDataIsExportedSuccessfullyProcedure: 'Member data is exported successfully. Procedure',
    memberDataFailedToBeExportedProcedure: 'Member data failed to be exported. Procedure',
    noDataAvailableAtThisTime: 'No data available at this time',
    memberImportTemplateDownloadedSuccessfully: 'Member import template downloaded successfully',
    failedToDownloadTheMemberImportTemplate: 'Failed to download the member import template',
    modifyMembership2: 'Modify membership',
    addAMemberSuccessfully: 'Add a member successfully',
    renewMemberSuccessfully: 'Renew member successfully',
    integralChange2: 'Integral change',
    memberRecharge: 'Member recharge',
    deductionOfStoredValue: 'Deduction of stored value',
    scoreChangeSuccess: 'Score change success',
    memberRechargeSuccessfully: 'Member recharge successfully',
    theDeductionOfStoredValueIsSuccessful: 'The deduction of stored value is successful',
    integralQuery2: 'Integral query',
    pleaseEnterSalesman: 'Please enter Salesman',
    definitiveRemoval: 'Definitive removal',
    derivedInformation: 'Derived information',
    memberDataExportInformation: 'Member data export information',
    memberImportTemplate: 'Member import template',
    totalMembers: 'Total {memberTotal} members',
    xlsFormatOnly: 'Only XLS format files are supported',
    commissionRefundNotice:
      "Starting from February 1, 2021, members imported for the first time using the 'Member Import' function will receive full commission refunds when booking and staying at this hotel through the Light Living mini program!",
    idTypeAndNumber: 'ID Type/Number',
    distributionSettings: 'Distribution settings',
    setAsAPromotionalUser: 'Set as a promotional user',
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
  memberMemberReport: {
    ordinaryMember: 'Ordinary member',
    goldMember: 'Gold member',
    platinumMember: 'Platinum member',
    diamondMember: 'Diamond member',
    enterYourNamePhoneNumberAndIdNumber: 'Enter your name, phone number, and ID number',
    membership: 'Membership',
    activateStore: 'Activate store',
    ourStore: 'Our store',
    otherStores: 'Other stores',
    sourceOfDevelopment: 'Source of development',
    activationDate: 'Activation date',
    dateOfPurchase: 'Date of purchase',
    purchaseTime: 'Purchase time',
    memberNickname: 'Member nickname',
    memberName: 'Member name',
    membershipIdNumber: 'Membership ID number',
    activationTime: 'Activation time',
    currentLevelDevelopmentSource: 'Current level development source',
    currentLevelPurchaseTime: 'Current level purchase time',
  },
  memberSaveReport: {
    downloadReport: 'Download report',
    totalAmountOfStoredValue: 'Total amount of stored value',
    totalGiftAmount: 'Total gift amount',
    totalConsumptionAmount: 'Total consumption amount',
    totalAmountOfRefund: 'Total amount of refund',
    user: 'User',
    transactionType: 'Transaction type',
    storedValue: 'Stored-value',
    consumptionRefund: 'Consumption refund',
    membershipLevel: 'Membership level',
    storedValueAmount: 'Stored-value amount',
    amountOfRefund: 'Amount of refund',
    memberStoredValueReport: 'Member stored value report',
    theMemberStoredValueReportIsSuccessfullyExported:
      'The member stored value report is successfully exported',
    failedToExportTheMemberStoredValueReport: 'Failed to export the member stored value report',
    searchPlaceholder: 'Phone/Document/Name',
  },
  clientClient: {
    guestTag: 'Guest tag',
    pleaseEnterYourContactInformation: 'Please enter your contact information',
    pleaseEnterYourNationality: 'Please enter your nationality',
    pleaseEnterNationality: 'Please enter nationality',
    pleaseEnterAddress: 'Please enter address',
    age: 'Age',
    customerLabel: 'Customer label',
    modifyGuestInformation: 'Modify Guest Information',
    inputLabelDuplication: 'Input label duplication',
    pleaseEnterTheLabelContent: 'Please enter the label content',
    doNotEnterLabelsInMoreThan10Words: 'Do not enter labels in more than 10 words',
  },
  financeIndex: {
    pleaseCancelRenewFirst: 'Please cancel the renewal before proceeding with checkout',
    addAnotherItem: 'Add Item',
    checkInOrderNumber: 'Check-in No.',
    adjustFinance: 'Adjust Finance',
    batchTransfer: 'Batch Transfer',
    checkOut: 'On Account',
    pleaseEnterTheRoomNumber: 'Enter Room No.',
    pleaseEnterRoomTypeName: 'Enter Room Type',
    pleaseEnterChannel: 'Enter Channel',
    pleaseEnterCheckInTime: 'Enter Check-in Time',
    pleaseEnterYourDepartureTime: 'Enter Check-out Time',
    pleaseEnterAccount: 'Enter Subject',
    entryTime2: 'Entry Time',
    pleaseEnterTheCreditDate: 'Enter Entry Date',
    consumptionAmountyuan: 'Consumption Amount',
    pleaseEnterTheAmountSpent: 'Enter Consumption Amount',
    paymentAmountyuan: 'Payment Amount',
    pleaseEnterThePaymentAmount: 'Enter Payment Amount',
    editBill: 'Edit Bill',
    checkOut2: 'Check Out',
    cancelAccount: 'Reverse Settlement',
    partialClosing: 'Partial Settlement',
    accountAdjustment: 'Adjust Charge',
    smallGoodsAreAccountedFor: 'Post Retail Charge',
    pleaseSelectAPaymentHistory: 'Select Payment Record',
    pleaseFillInTheAmountOfPayment: 'Enter Payment Amount',
    yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting:
      'Account information is empty. Please post before printing.',
    theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect:
      'Room number cannot be empty. Please check whether the page path is correct.',
    smallwares: 'Smallwares',
    creditOrdersDoNotSupportPartialCheckout: 'Credit orders do not support partial checkout.',
    pleaseSelectTheOrderYouWantToCheckOut: 'Please select the order to check out.',
    creditBookingIsNotSupportedPleaseCheckOutDirectly:
      'Credit booking is not supported. Please check out directly.',
    pleaseSelectACover: 'Select Account Set',
    unionpayScanCode: 'UnionPay - Scan',
    checkOutSuccessfully: 'Check Out Successfully',
    securityDeposit: 'Deposit',
    warmReminder: 'Warm Reminder',
    signOut: 'Sign Out',
    cancelled: 'Cancelled',
    the: 'The',
    wheatDoorLockPlugInCancellationCard: 'Maitian Lock - Cancel Card',
    whetherTheKeyCardHasBeenCancelled: 'Has the Key Card Been Cancelled?',
    selectUnsettledAccountsWarning: 'Select "Unsettled" accounts',
    feizhuRoomFeeValidation: 'Fliggy room fee must be ≥0. Current: {roomRateFees}',
    feizhuNonRoomFeeValidation: 'Fliggy non-room fee must be ≥0. Current: {fees}',
    pleaseSelectUnsettledAccounts: 'Select unsettled accounts.',
    additionalChargeAmountEmpty: 'Additional charge amount is empty. Please retry.',
  },
  financeMangementOld: {
    accountType: 'Account type',
    creditAccount: 'Credit account',
    prepaidAccount: 'Prepaid account',
    settlementPeriod: 'Settlement period',
    maximumAmount: 'Maximum amount',
    theMaximumMustBeGreaterThanZero: 'The maximum must be greater than zero',
    theMaximumAmountCannotBeGreaterThan100Million:
      'The maximum amount cannot be greater than 100 million',
    theStartTimeCannotBeEqualToTheEndTime: 'The start time cannot be equal to the end time',
    theStartTimeCannotBeLaterThanTheEndTime: 'The start time cannot be later than the end time',
    pleaseSelectAnEndTime: 'Select an end time',
    theEndTimeCannotBeEqualToTheStartTime: 'The end time cannot be equal to the start time',
    theEndTimeCannotBeLaterThanTheStartTime: 'The end time cannot be later than the start time',
    pleaseEnterTheBillingPeriod: 'Please enter the billing period',
    settlementPeriodCanOnlyBeEnteredInNumbers: 'Settlement period can only be entered in numbers',
    newAccount: 'New account',
    pleaseFillInTheAccountName: 'Please fill in the account name',
    pleaseFillInTheCompanyName: 'Please fill in the company name',
    pleaseSelectAnAccountType: 'Select an account type',
    pleaseSelectAChannelName: 'Select a channel name',
  },
  financeMangement: {
    creditAccount: 'Credit account',
    prepaidAccount: 'Prepaid account',
    enableConfirmation:
      'After successful activation, this agreement unit will support account hanging. Confirm to enable?',
    disableConfirmation:
      'After successful deactivation, this agreement unit will no longer support account hanging. Confirm to disable?',
  },
  foodRoomAccountFinance: {
    foodSource: 'Food Source',
    foodRoomAccountLabel: 'Food Room Account',
    foodOrderNo: 'Food Order No.',
    fmisAccountSerialNo: 'FMIS Account Serial No.',
    chargedAmount: 'Charged Amount',
    notAllowedSplit: 'Food room accounts cannot be split',
    notAllowedRush: 'Food room accounts cannot be reversed',
    notAllowedTransfer: 'Food room accounts cannot be transferred',
    notAllowedPartialSettlement: 'Food room accounts do not support partial settlement',
  },
  financeMixin: {
    onlinePaymentAccountsAreNotAllowedToOpen: 'Online payment accounts are not allowed to open',
    smallCommodityAccountsCanNotBeDismantled: 'Small commodity accounts can not be dismantled',
    negativeDebtCannotBeBroken: 'Negative debt cannot be broken',
    accountsReceivableAreNotAllowedToBeDebunked:
      'Accounts receivable are not allowed to be debunked',
    debitsAreNotAllowedInThisAccount: 'Debits are not allowed in this account',
    onlinePaymentRefundAccountDoesNotAllowForChargebacks:
      'Online payment refund account does not allow for chargebacks',
    theAccountHasBeenRefundedAndCannotBeCharged:
      'The account has been refunded and cannot be charged',
    refundedAccountsCannotBeCharged: 'Refunded accounts cannot be charged',
    thisAccountIsNotAllowedToBeCharged: 'This account is not allowed to be charged',
    businessDayHasBeenSwitchedNoChargeIsAllowed:
      'Business day has been switched, no charge is allowed',
    splitBill: 'Split bill',
    refund: 'Refund',
  },
  detailcomponentsAccountlisttable: {
    onAccount: 'On account',
  },
  detailcomponentsAddjudge: {
    theRoomChargeIsExcessive: 'The room charge is excessive',
    chargeJudgment: 'Charge judgment',
    addOnOption: 'Add-on option',
    generatedRoomCharge: 'Generated room charge',
    pleaseFillInTheAdditionalRoomCharge: 'Please fill in the additional room charge',
    theAdditionalAmountCannotBe0: 'The additional amount cannot be 0',
  },
  detailcomponentsAdjustaccounts: {
    reconciliationSuccess: 'Reconciliation success',
    accountAdjustment: 'Adjust Charge',
    accountOfReconciliation: 'Account of reconciliation',
    incorrectTransferAmountFormatupToTwoDecimalPlaces:
      'Incorrect transfer amount format (up to two decimal places)',
    theTransferAmountCannotBe: 'The transfer amount cannot be',
    theTransferAmountCannotBeGreaterThan100Million:
      'The transfer amount cannot be greater than 100 million',
  },
  detailcomponentsArsuitselect: {
    receivableSet: 'Receivable set',
    creditOrderCheckoutTip: 'Credit stay orders must be posted to AR at checkout',
    nonProtocolOrderArTip: 'Only contracted accounts can charge to account',
  },
  detailcomponentsBackout: {
    closedSuccessfully: 'Closed successfully',
    cancelAccount: 'Cancel account',
    confirmationRevocation: 'Confirmation revocation',
    pleaseSelectTheBillYouWantToCancel: 'Select the bill you want to cancel',
  },
  detailcomponentsBorrow: {
    return: 'Return',
    itemBorrowingReminder: 'Item borrowing reminder',
    borrowARoom: 'Borrow a room',
    quantityBorrowed: 'Quantity borrowed',
    returnQuantity: 'Return quantity',
    loanDate2: 'Loan date',
    returnOrNot: 'Return or not',
    whetherToReturnAll: 'Whether to return all',
    amountOfCompensation: 'Amount of compensation',
    onlyNumbersGreaterThan0CanBeEntered: 'Only numbers greater than 0 can be entered',
    partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed:
      'Part of the return can only be less than the amount borrowed',
    returned: 'Returned',
    noReturn: 'No return',
    returnSuccessfully: 'Return successfully',
  },
  detailcomponentsColorblock: {
    financialType: 'Financial type',
    accountingType: 'Accounting Type',
    orderForGoods: 'Order for goods',
  },
  detailcomponentsCommon: {
    unionpayScanCode: 'Unionpay - Scan code',
    insufficientMemberBalance: 'Member balance is {balance} , please select another payee.',
  },
  detailcomponentsCreditsettletip: {
    creditSettleAlert:
      'Reminder: Feizhu credit order, actual settled room fee: {roomRate} , non-room fee: {nonRoomRate} . Please verify the amounts before submitting checkout.',
  },
  detailcomponentsDivideaccounts: {
    additionalDebits: 'Additional debits',
    totalAmount: 'Total amount',
    totalDebitsTaken: 'Total debits taken',
    totalUndismantledLoans: 'Total undismantled loans',
    successfulDismantling: 'Successful dismantling',
    borrowMoney: 'Borrow money',
    loanAmount: 'Loan amount',
    upTo150Words: 'Up to 150 words',
    closedAccount: 'Closed account',
    tenAtMost: 'Ten at most',
    theAmountOfDebitsIsNotEqualToTheTotalAmount:
      'The amount of debits is not equal to the total amount',
    theDebitAmountMustBeFilledInAndGreaterThan:
      'The debit amount must be filled in and greater than',
  },
  detailcomponentsEnteraccount: {
    breakfastType: 'Breakfast Type',
    includedBreakfast: 'Breakfast Included',
    purchasedBreakfast: 'Purchased Breakfast',
    unitPrice: 'Unit Price',
    servings: 'Servings',
    mealDate: 'Meal Date',
    selectMultipleDates: 'Select multiple dates',
    selectedDays: 'Total days: {count}',
    cashCnyReceipt: 'cash receipt',
    accountEntry: 'Payment Method',
    amountRecorded: 'Amount recorded',
    pleaseFillInTheAmountOfPayment: 'Please enter the posting amount.',
    pleaseSelectAPaymentMethod: 'Select a payment method.',
    entriesCannotBeEmpty: 'The posting subject cannot be empty.',
    theAmountRecordedCannotBe: 'The posting amount cannot be zero.',
    pleaseFillInUnitPrice: 'Please enter the unit price.',
    unitPriceCannotBeZero: 'Unit price cannot be zero.',
    pleaseFillInServings: 'Please enter the number of servings.',
    servingsCannotBeZero: 'Servings cannot be zero.',
    pleaseSelectMealDate: 'Select a meal date.',
    ArRefundCannotExceedBalance: 'AR refund amount cannot exceed AR balance.',
  },
  detailcomponentsExpandcolumn: {
    memberName: 'Member name',
    receivableSet: 'Receivable set',
    from: 'From',
    orderForGoods: 'Order for goods',
    rollOutTo: 'Roll out to',
    refundedAmount: 'Refunded: {amount} ',
  },
  detailcomponentsHangaccounts: {
    checkOut: 'Check out',
    reasonForPayment: 'Reason for payment',
  },
  detailcomponentsHourroomfeeconfirm: {
    roomRateConfirmation: 'Room rate confirmation',
    roomRate2: 'Room rate',
  },
  detailcomponentsPartsettle: {
    partialClosing: 'Partial closing',
    pleaseFillInTheAmountOfPayment: 'Please fill in the amount of payment',
    pleaseSelectAPaymentHistory: 'Select a payment history',
  },
  detailcomponentsPreauthcheck: {
    authorizedSettlement: 'Authorized settlement',
  },
  detailcomponentsPreauthtemplate: {
    cancelAuthorizationPleaseWait: 'Cancel authorization please wait',
    succeededInCancelingAuthorization: 'Succeeded in canceling authorization',
    thereIsAnOutstandingPreAuthorizationRecordInTheRoom:
      'There is an outstanding pre-authorization record in the room',
    confirmThatYouWantToCancelAuthorization: 'Confirm that you want to cancel authorization',
    roomPaymentRequired: 'Room requires {action} amount:',
    orderCanceledWarning: 'Order has been canceled, cannot {action}',
    roomCheckedInWarning: 'Room has been checked in, cannot {action}',
    roomCheckedOutWarning: 'Room status is "checked out", cannot {action}',
  },
  detailcomponentsRefundtip: {
    refundReminder: 'Refund reminder',
    whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid:
      'When using an online refund, the amount will be refunded to the account from which the guest paid',
    whenUsingAOneCardRefundSystem:
      'When a refund is processed using the prepaid card, the amount will be refunded to the customer ‘s payment account.',
  },
  detailcomponentsSmallwarecost: {
    smallwares: 'Smallwares',
    smallGoodsEnteredTheAccountSuccessfully: 'Small goods entered the account successfully',
    smallGoodsAreAccountedFor: 'Small goods are accounted for',
    payOrNot: 'Pay or not',
    pleaseEnterTheExternalOrderNumber: 'Please enter the external order number',
    pleaseSelectASmallItem: 'Select a small item',
    insufficientMemberBalance: 'Member balance is {balance} , please select another payee.',
  },
  detailcomponentsTransferaccounts: {
    transferMoney: 'Transfer money',
    transferToAccount: 'Transfer to account',
    pleaseSelectValidTransferAccount: 'Select a valid transfer account',
    transferSuccess: 'Transfer successful',
    batchTransferSuccess: 'Batch transfer successful',
  },
  mangementMember: {
    orderType: 'Order Type',
    receivableOrders: 'Receivable Orders',
    totalAmountNotApproved: 'Total amount not approved',
    approvedTotalAmount: 'Approved total amount',
    amountAvailable: 'Amount available',
    amountSpent: 'Amount spent',
    whetherToWriteOffAllTheReceivables: 'Whether to write off all the receivables',
    whetherToReverseWriteOffAllTheReceivables: 'Whether to reverse write off all the receivables',
    cancelAfterVerification: 'Cancel after verification',
    reverseWriteOff: 'Reverse write-off',
    depositInAdvance: 'Deposit in advance',
    dateOfPosting: 'Date of Posting',
    pleaseEnterTheOrderNumber: 'Please enter the order number',
    completeWriteOff: 'Complete write-off',
    completeReverseWriteOff: 'Complete reverse write-off',
    batchWriteOff: 'Batch write-off',
    batchReverseWriteOff: 'Batch reverse write-off',
    records: 'Records',
    advanceCredit: 'Advance credit',
    thePrepaidAmountMustBeGreaterThanZero: 'The prepaid amount must be greater than zero',
    theAmountInAdvanceCannotBeGreaterThan100Million:
      'The amount in advance cannot be greater than 100 million',
    checkTheDepartureDateUpToOneMonth: 'Check the departure date up to one month',
    noAccountPleaseCreateANewOne: 'No account, please create a new one',
    allWereSuccessfullyWrittenOff: 'All were successfully written off',
    allWriteOffsFailed: 'All write-offs failed',
    noWriteOffIsAllowedOnTheDayReceivableIsGenerated:
      'No write-off is allowed on the day receivable is generated',
    pleaseSelectTheItemsYouWantToWriteOff: 'Please select the items you want to write off',
    prepaymentAmountRequired: 'Please fill in the prepayment amount',
    prepaymentAmountFormatError: 'Prepayment amount format is incorrect (up to two decimal places)',
  },
  mangementTablerow: {
    paidInAmount: 'Paid-in amount',
  },
  mangementVerificatemodal: {
    successfulWriteOff: 'Successful write-off',
    cancelAfterVerification: 'Cancel after verification',
    reverseWriteOff: 'Reverse write-off',
    generationTime: 'Generation time',
    amountWrittenOff2: 'Amount written off',
    pleaseFillInTheWriteOffAmount: 'Please fill in the write-off amount',
    theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff:
      'The amount to be written off cannot be greater than the amount that can be written off',
  },
  mangementVerifyrecordsmodal: {
    records: 'Records',
    lot: 'Lot',
  },
  merchantChargeList: {
    accumulatedUncreditedNightsInArrearsDuringTheContractPeriod:
      'Accumulated uncredited nights in arrears during the contract period',
    hideZeroAmounts: 'Hide all 0 amount entries',
  },
  merchantCheckBill: {
    confirmationCheck: 'Confirmation check',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'After confirmation, settlement will be made in accordance with this bill',
    appealChannel: 'Appeal channel',
    causeOfAppeal: 'Cause of appeal',
    youCanEnterUpTo150Words: 'You can enter up to 150 words',
    accountName: 'Account name',
    roomBillCheck: 'Room bill check',
    memberIncentiveCheck: 'Member incentive check',
    confirmed: 'Confirmed',
    reasonForAdjustment: 'Reason for adjustment',
    deductibleTarget: 'Deductible target',
    currentDeduction: 'Current deduction',
    deductible: 'Deductible',
    confirmationTime: 'Confirmation time',
    rejectionTime: 'Rejection time',
    liveLightlyInTheDirectCamp: 'Live lightly in the direct camp',
    new: 'New',
    appealSuccessfully: 'Appeal successfully',
    checkSuccessfully: 'Check successfully',
    currDeductionDesc:
      '1. Positive current deduction represents Qingzhu deducting merchant amount. 2. Negative current deduction represents refund to merchant.',
    qzMerchantSettleDesc:
      'Qingzhu settlement with merchants = Total order amount - Current deduction',
  },
  merchantInfoManage: {
    changeLetter: 'Change letter',
    note: 'Note',
    paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount:
      'Payment can only be made after the modification of the receiving account is approved. If the current settlement payment is to be paid, the payment will still be made according to the original account',
    groundsForRejection: 'Grounds for rejection',
    downloadTheAttachmentTemplate2: 'Download the attachment template',
    viewingModificationLogs2: 'Viewing Modification Logs',
    thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution:
      'This settlement information is used for room fee settlement and can only be modified by the hotel owner. Please add it with caution',
    thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired:
      'This account is used for the settlement of room charges, and can only be modified by the hotel owner. Please modify it carefully, upload the change letter and affix the official seal as required',
    modifyLog2: 'Modify log',
    beforeModification3: 'Before modification',
    receivablesAccountManagement2: 'Receivables account management',
    bankAccountName4: 'Bank account name',
    letterOfRequestForChange2: 'Letter of request for change',
    pleaseEnterYourBankName2: 'Please enter your bank name',
    pleaseUploadTheRequestForChange2: 'Please upload the request for change',
    afterModification2: 'After modification',
    afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile:
      'After downloading the application change letter, you need to print it out, sign and seal it, and then upload the picture or PDF file',
    onlyJpgPngAndPdfFilesCanBeUploaded: 'Only jpg, png, and pdf files can be uploaded',
  },
  merchantMerchantHelper: {
    smallProgramSettlementRules: 'Small program settlement rules',
    settlementOfPaymentProblems: 'Settlement of payment problems',
    smallProgramSettlementRulesCommonProblems: 'Small program settlement rules common problems',
    frequentlyAskedQuestionsAboutSettlementPayments:
      'Frequently asked questions about settlement payments',
    q1SettlementCriteria: 'Q1: What kind of bills can be settled?',
    a1SettlementCriteria:
      'Our settlement criteria are: order status is completed and check-out status.',
    q2PmsCancellation: 'Q2: What to do if PMS bill is canceled?',
    a2PmsCancellation:
      'If PMS status is canceled, our settlement standard is: when the guest requests cancellation and refund, contact customer service team to initiate refund process.',
    q1AuditTime: 'Q1: When is the settlement audit time?',
    a1AuditTime:
      'Direct settlement bills for next week will be uploaded to the settlement system before Friday. Merchants only need to confirm the bill when applying for payment next Thursday.',
    q2PaymentTime: 'Q2: When will payment be made after merchant confirms the bill?',
    a2PaymentTime:
      'Merchants who have confirmed bills will receive payments on Thursday. Previously failed payments will also be reattempted from Thursday to Friday.',
    q3CheckPayment: 'Q3: How to check if payment has been made?',
    a3CheckPayment: 'Merchants can check payment status in the payment records interface.',
    q4RejectedStatement: 'Q4: What if the statement is rejected? When will payment be made?',
    a4RejectedStatement:
      'Rejected statements will be re-reviewed by headquarters. If adjustments are completed before Thursday, payment will be made on Thursday. Unconfirmed bills will be processed next Thursday.',
  },
  merchantRemitRecord: {
    roomChargePaymentRecords: 'Room charge payment records',
    memberIncentiveRecord: 'Member incentive record',
    fundsToBeRemitted: 'Funds to be remitted',
    remitting: 'Remitting',
    remittedMoney: 'Remitted money',
    paymentFailure2: 'Payment failure',
    collectionAccount: 'Collection account',
    payee: 'Payee',
    statusUpdateTime: 'Status update time',
    paymentTime: 'Payment time',
    timeToInitiateAPayment: 'Time to initiate a payment',
  },
  merchantSettleInfo: {
    pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard:
      'Please scan the QR code of your cloud account to bind your bank card',
    bindBankCard: 'Bind bank card',
    completeInformation: 'Complete information',
    bankAccountName4: 'Bank account name',
    idNumber: 'Id Number',
    pleaseEnterYourBankName2: 'Please enter your bank name',
    pleaseEnterYourIdNumber2: 'Please enter your ID number',
    idNumberFormatIsIncorrectPleaseReEnter: 'Id number format is incorrect, please re-enter',
    phoneNumberFormatIsIncorrectPleaseReEnter: 'Phone number format is incorrect, please re-enter',
    pleaseUpload: 'Please upload',
    internalUserHidden: 'Internal users cannot view',
    amountPendingPayment: 'Amount {amount} will be paid later',
  },
  billCheckBillDetails: {
    channelDetails: 'Channel details',
    whereToConnectDirectly: 'Where to connect directly',
    drench: 'Drench',
    cityWide: 'City-wide',
    whereToGo: 'Where to go',
    distribution: 'Distribution',
    tradeCaravan: 'Trade caravan',
    statementOfAccount: 'Statement of account',
    qzSettleFormula:
      'Qingzhu settlement with merchants = Settlement amount + Merchant refunds + Merchant discounts + Merchant public welfare amount',
    merchantDiscountNote:
      "When a refund occurs for current orders, the merchant's discount amount will be 0",
  },
  billCheckBill: {
    turnDown: 'Turn down',
    ticketReceived: 'Ticket received',
    forThePublic: 'For the public',
    forPrivacy: 'For privacy',
    expenseDetail: 'Expense detail',
    confirmationCheck: 'Confirmation check',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'After confirmation, settlement will be made in accordance with this bill',
    perfectInformation: 'Perfect information',
    causeOfAppeal: 'Cause of appeal',
    youCanEnterUpTo150Words: 'You can enter up to 150 words',
    creditDetails: 'Credit details',
    roomNightCreditDetails: 'Room night credit details',
    invoiceManagement: 'Invoice management',
    sellersName: "Seller's name",
    invoiceNumber: 'Invoice number',
    invoiceDate: 'Invoice date',
    invoiceAmount2: 'Invoice amount',
    electronicInvoiceOrNot: 'Electronic invoice or not',
    invoiceFile: 'Invoice file',
    reasonForRejectingInvoice: 'Reason for rejecting invoice',
    theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0:
      'The total amount of the order includes the amount of the previous bill and the merchant settlement amount less than 0',
    quantityDueForTheCurrentPeriod: 'Quantity due for the current period',
    actualAmountOfDeductionForTheCurrentPeriod: 'Actual amount of deduction for the current period',
    amountDeductedForTheNightOfThePeriod: 'Amount deducted for the night of the period',
    uncreditedQuantityForTheCurrentPeriod: 'Uncredited quantity for the current period',
    pleaseEnter150WordsOrLess: 'Please enter 150 words or less',
    pleaseEnterTheInvoiceHoldersInformation: "Please enter the invoice holder's information",
    pleaseEnterTheInvoiceNumber: 'Please enter the invoice number',
    pleaseEnterExpiryDate2: 'Please enter expiry date',
    pleaseSelectTheInvoiceType: 'Select the invoice type',
    pleaseSelectWhetherToEInvoice: 'Select whether to e-invoice',
    pleaseUploadTheInvoicePhoto: 'Please upload the invoice photo',
    pleaseFillInTheAmount: 'Please fill in the amount',
    specialTicket: 'Special ticket',
    ordinaryTicket: 'Ordinary ticket',
    expenseItem: 'Expense item',
    amountIncurred: 'Amount incurred',
    source: 'Source',
    instructions: 'Instructions',
    confirmationTime: 'Confirmation time',
    groupReceiptStatus: 'Group receipt status',
    rejectionTime: 'Rejection time',
    whetherTheInvoiceHasBeenEntered: 'Whether the invoice has been entered',
    feeDetails: 'Fee details',
    fileUpload: 'Upload file',
    uploadAMaximumOf5Images: 'Upload a maximum of 5 images',
    appealSuccessfully: 'Appeal successfully',
    checkSuccessfully: 'Check successfully',
    theSizeOfTheUploadedCompressedPackageCannotExceed:
      'The size of the uploaded compressed package cannot exceed',
    onlyTheUploadFormatIsSupported: 'Only the upload format is supported',
    theCompressedPackageFileCannotBeLargerThan: 'The compressed package file cannot be larger than',
    amountOfDeductionForTheCurrentPeriod: 'Amount of deduction for the current period',
    theMerchantNeedsToInvoiceTheAmount: 'The merchant needs to invoice the amount',
    billingDetails: 'Billing details',
    currentAdrAmount: 'Current ADR amount',
    settlementSystemUpgrade:
      "To meet the bank's requirements for fund settlement, improve settlement efficiency, and enhance settlement qualification information, the group is upgrading the settlement system and now requires supplementary qualification information requested by the bank!",
    confirmPreviousBills:
      'Please confirm previous bills first, otherwise new billing period bills cannot be displayed',
    paperInvoiceInstructions:
      'Paper invoices must be sent with prepaid shipping. Cash on delivery will be rejected. Invoice recipient: Qingzhu Distribution E-Invoice; Tel: 15901580289. For paper invoices, Qingzhu will review them after receipt.',
    uploadFormatRestrictions:
      'Note: Supports one of PDF, images, Word, compressed files, or OFD formats. PDF/OFD: max 5 files, 3MB each; Images: max 5 files (JPG/JPEG/PNG), 3MB each; Word: max 1 file, 20MB; Compressed files (RAR/ZIP/7Z): max 1 file, 20MB.',
    cumulativeUndeductedNights:
      'Accumulated undeducted room nights during contract period (before current period deduction)',
    invoiceDuplicate:
      'Duplicate invoice number detected. Please verify the number. If correct, specify the reason for reuse in remarks.',
    pdfSizeExceeded: 'PDF file size cannot exceed 3MB!',
    ofdSizeExceeded: 'OFD file size cannot exceed 3MB!',
    wordSizeExceeded: 'Word file size cannot exceed 20MB!',
    singleFormatOnly: 'Only one file format is supported!',
  },
  billCheckMemberDetails: {
    memberIncentiveDetails: 'Member Incentive Details',
    memberIncentiveStatement: 'Member incentive statement',
  },
  billDeductionDetails: {
    feeDetails: 'Fee details',
    statementDetailsSheet: 'Statement details sheet',
  },
  billRemitRecord: {
    collectionAccount: 'Collection account',
    payee: 'Payee',
    statusUpdateTime: 'Status update time',
    timeToInitiateAPayment: 'Time to initiate a payment',
    paymentTime: 'Payment time',
  },
  billCheckDetails: {
    channelOrderDetails: 'Channel order details',
    merchantRefunds: 'Merchant refunds',
    merchantConcession: 'Merchant concession',
    channelOrderNumber: 'Channel order number',
    reasonForAdjustment3: 'Reason for adjustment',
    adjustmentType: 'Adjustment type',
    originalOrderPrice: 'Original order price',
    memberDiscount: 'Member discount',
    skimpingOnCommission: 'Skimping on commission',
    payChannelCommission: 'Pay channel commission',
    amountOfMerchantWelfare: 'Amount of merchant welfare',
    refundNight: 'Refund night',
    totalRefundAmount: 'Total refund amount',
    stayEasyAndRefundCommission: 'Stay easy and refund commission',
    subsidy: 'Subsidy',
    saleCardOrderNumber: 'Sale card order number',
    membershipLevel: 'Membership level',
    dateOfRegistration: 'Date of registration',
    referrer: 'Referrer',
    amountPaid: 'Amount paid',
    merchantsShareTheAmount: 'Merchants share the amount',
    employeeShareAmount: 'Employee share amount',
    shareAmount: 'Share amount',
    rebateRatio: 'Rebate ratio',
    commissionRebate: 'Commission rebate',
    distributionSubchannel: 'Distribution subchannel',
    channelCost: 'Channel cost',
    lightSettlementWithMerchantsOrder: 'Qingzhu settlement with merchants (Order)',
    lightUndertakeDiscounts: 'Qingzhu undertakes discounts',
  },
  billDedetails: {
    currentAmountReceivable: 'Current amount receivable',
    amountOfDeductionForTheCurrentPeriod: 'Amount of deduction for the current period',
    remainingAmountOfDeduction: 'Remaining amount of deduction',
    pleasureManagementFee: 'Pleasure management fee',
    brandManagementFee: 'Brand management fee',
    mastersCommission: "Master's commission",
    otherExpenses: 'Other expenses',
    openingDate: 'Opening date',
    preferentialPolicy: 'Preferential policy',
    managementFeeStartDate: 'Management fee start date',
    thisPeriodOfBusinessSelfPromotion: 'This period of business self-promotion',
    enjoyCommissionRate: 'Enjoy commission rate',
    enjoyManagementFeeForThisPeriod: 'Enjoy management fee for this period',
    currentAdjustmentExpense: 'Current adjustment expense',
    reasonsForAdjustingExpensesInTheCurrentPeriod:
      'Reasons for adjusting expenses in the current period',
    notPaidInThePreviousPeriod: 'Not paid in the previous period',
    currentReceivable: 'Current receivable',
    currentPaid: 'Current paid',
    balanceDue: 'Balance due',
    brandCommissionRate: 'Brand commission rate',
    currentBrandManagementFee: 'Current brand management fee',
    monthlyRate: 'Monthly rate',
    currentObjective: 'Current objective',
    totalPmsRevenueForThePeriod: 'Total PMS revenue for the period',
    totalPmsReceivableForThePeriod: 'Total PMS receivable for the period',
  },
  chargeIndex: {
    expenseItem: 'Expense item',
    totalAmountPayable: 'Total amount payable',
    cashPayable: 'Cash payable',
    creditPayable: 'Credit payable',
    deductionAdjustment: 'Deduction adjustment',
    deductible: 'Deductible',
    residualCredit: 'Residual credit',
    managementFeeStartDate: 'Management fee start date',
    currentObjective: 'Current objective',
    currentPeriodAdjustment: 'Current period adjustment',
    notPaidInThePreviousPeriod: 'Not paid in the previous period',
    currentReceivable: 'Current receivable',
    currentPaid: 'Current paid',
    balanceDue: 'Balance due',
  },
  commonIndex: {
    accountName: 'Account name',
    collectionAccountType: 'Collection account type',
    distributionRoomBillReconciliation: 'Distribution room bill reconciliation',
    memberIncentiveCheck: 'Member incentive check',
    directSellingRoomFeePaymentRecords: 'Direct selling room fee payment records',
    distributeRoomChargePaymentRecords: 'Distribute room charge payment records',
    memberIncentiveRecord: 'Member incentive record',
    confirmed: 'Confirmed',
    reasonForAdjustment: 'Reason for adjustment',
    settlementGrounds: 'Settlement grounds',
    operationDetails: 'Operation details',
    merchantRefunds: 'Merchant refunds',
    merchantConcession: 'Merchant concession',
    amountOfMerchantWelfare: 'Amount of merchant welfare',
    americanOrder: 'American order',
    flyingPigOrder: 'Flying pig order',
    lightLiveMiniProgramOrder: 'Light live mini program order',
    memberShareAmount: 'Member share amount',
    theAmountOfCrossStoreRefund: 'The amount of cross-store refund',
    lightlyAdjustTheAmount: 'Lightly adjust the amount',
    reasonForAdjustment3: 'Reason for adjustment',
    fundsToBeRemitted: 'Funds to be remitted',
    remitting: 'Remitting',
    remittedMoney: 'Remitted money',
    paymentFailure2: 'Payment failure',
    lightSettlementWithMerchantsOrder: 'Qingzhu settlement with merchants (Order)',
  },
  infoInfoManage: {
    note: 'Note',
    theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture:
      'The application change letter needs to be printed out and signed with the official seal after downloading. If the print is 2 pages, please affix the seal and upload the picture',
    submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade:
      'Submit and modify the audit process of the receiving account. Only after the audit is passed can the payment be made. The rejected account will not be made',
    beforeModification3: 'Before modification',
    pleaseBePatientWhileTheInformationIsBeingReviewed:
      'Please be patient while the information is being reviewed',
    groundsForRejection: 'Grounds for rejection',
    downloadTheAttachmentTemplate2: 'Download the attachment template',
    forPrivacy: 'For privacy',
    forThePublic: 'For the public',
    auditStatus: 'Audit status',
    viewingModificationLogs2: 'Viewing Modification Logs',
    pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress:
      'Please upload your bank card information as soon as possible to avoid affecting your payment progress',
    modifyLog2: 'Modify log',
    receivablesAccountManagement2: 'Receivables account management',
    collectionAccountType: 'Collection account type',
    pleaseSelectACollectionAccountType: 'Select a collection account type',
    bankAccountName5: 'Bank account name',
    recipientsCellPhoneNumber: "Recipient's cell phone number",
    pleaseEnterTheRecipientsMobilePhoneNumber: "Please enter the recipient's mobile phone number",
    payeeIdNumber: 'Payee ID number',
    pleaseEnterThePayeeIdNumber: 'Please enter the payee ID number',
    payeeIdCardFront: 'Payee ID card front',
    reverseOfPayeeIdCard: 'Reverse of payee ID card',
    uploadContractAttachment: 'Upload contract attachment',
    letterOfRequestForChange2: 'Letter of request for change',
    pleaseEnterTheBankAccountName: 'Please enter the bank account name',
    pleaseEnterTheLegalPersonName: 'Please enter the legal person name',
    legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter:
      'Legal person name can only be entered in Chinese characters, please re-enter',
    phoneNumberFormatIsIncorrectPleaseReEnter: 'Phone number format is incorrect, please re-enter',
    pleaseEnterYourIdNumber2: 'Please enter your ID number',
    idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter:
      'Id number format is wrong, can only enter numbers and uppercase letters, please re-enter',
    pleaseEnterAUnifiedSocialCreditCode: 'Please enter a unified Social credit code',
    onlyNumbersAndLettersAreSupportedPleaseReEnter:
      'Only numbers and letters are supported. Please re-enter',
    pleaseUploadTheRequestForChange2: 'Please upload the request for change',
    frontOfIdentityCard: 'Front of identity card',
    reverseOfIdCard: 'Reverse of ID card',
    businessLicense: 'Business license',
    pleaseUploadTheContractAttachment: 'Please upload the contract attachment',
    afterModification2: 'After modification',
    corporateName: 'Corporate name',
    unifyTheSocialCreditCode: 'Unify the social credit code',
    legalPersonMobilePhoneNumber: 'Legal person mobile phone number',
    pleaseEnterTheFrenchPhoneNumber: 'Please enter the French phone number',
    legalPersonIdNumber: 'Legal person ID number',
    pleaseEnterTheCorporateIdNumber: 'Please enter the corporate ID number',
    corporateIdentityCardFront: 'Corporate identity card front',
    reverseOfCorporateIdentityCard: 'Reverse of corporate identity card',
    pleaseUpload: 'Please upload',
    fileUpload: 'Upload file',
    uploadAMaximumOf2Images: 'Upload a maximum of 2 images',
    theSizeOfTheUploadedProfilePictureCannotExceed:
      'The size of the uploaded profile picture cannot exceed',
    uploadPictureFormatOnlySupported: 'Upload picture format only supported',
    onlyJpgJpegAndPngFilesCanBeUploaded: 'Only jpg, jpeg, and png files can be uploaded',
    onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto:
      'Only jpg, jpeg, png files can be uploaded. Please upload the change letter as a photo',
    pleaseWaitFileUploadIsNotComplete: 'Please wait, file upload is not complete',
    contractStampPageRequired: 'Contract stamp page (required)',
    otherPagesOptional: 'Other pages (optional, up to 2 uploads)',
    contractStampInstructions:
      '2. Contract stamp page: Must contain payee account information page with official seal, upload proper stamped contract page;',
    individualMobileNote: "Note: For individual businesses, fill in operator's mobile number",
    individualNameNote: "Note: For individual businesses, fill in operator's name",
    individualIdNote: "Note: For individual businesses, fill in operator's ID number",
    individualRegNumberNote: 'Note: For individual businesses, fill in registration number',
    maxTwoImages: 'Maximum 2 images can be uploaded',
    recipientLegalMobile: 'Recipient/Legal Person Mobile',
    recipientLegalIdNumber: 'Recipient/Legal Person ID Number',
  },
  invoicingAddInvoicingApplication: {
    billingApplication: 'Billing application',
    expenseType: 'Expense type:',
    totalAmountApplied: 'Total amount applied',
    theApplicationAmountIsIncorrect: 'The application amount is incorrect',
    status: 'Status:',
    causeOfRejection: 'Cause of rejection:',
    billingInformation: 'Billing information:',
    pleaseEnterPhoneNumber: 'Please enter phone number',
    dutyNumber: 'Duty number',
    pleaseEnterYourTaxId: 'Please enter your tax ID',
    pleaseEnterYourAccountBank: 'Please enter your account bank',
    pleaseEnterTheAddress: 'Please enter the address',
    openABankAccount: 'Open a bank account',
    pleaseEnterYourBankAccountNumber: 'Please enter your bank Guest Account',
    pleaseEnterEmail: 'Please enter email',
    pickUpTelephone: 'Pick-up telephone',
    pleaseEnterTheReceivingPhoneNumber: 'Please enter the receiving phone number',
    mailingAddress: 'Mailing address',
    pleaseEnterYourMailingAddress: 'Please enter your mailing address',
    addressee: 'Addressee',
    pleaseEnterTheRecipient: 'Please enter the recipient',
    repudiationPeriod: 'Repudiation period:',
    claimPeriod: 'Claim period:',
    pleaseEnterTheAmountRequested: 'Please enter the amount requested',
    theNumberCannotExceed15Digits: 'The number cannot exceed 15 digits',
    pleaseEnterTheCorrectNumber: 'Please enter the correct number',
    paymentPeriod: 'Payment period',
    availableAmount: 'Available amount',
    amountApplied2: 'Amount applied',
    pleaseSelectTheBillingType5: 'Select the billing type',
    receipt: 'Receipt',
    pleaseEnterTitle: 'Please enter title',
    theCurrentlySelectedFeeTypeDoesNotHaveBillingDataPleaseSelectAgain:
      'The currently selected fee type does not have billing data, please select again',
    theTotalApplicationAmountNeedsToBeGreaterThan:
      'The total application amount needs to be greater than',
    invoicingTypeAndFeeTypeDoNotCorrespondTheReceiptCanOnlyMatchTheDepositAndQualityDeposit:
      'Invoicing type and fee type do not correspond, the receipt can only match the deposit and quality deposit',
    thePageIsAutomaticallyClosed5SecondsAfterSubmission:
      'The page is automatically closed 5 seconds after submission',
    generalInvoice: 'General Invoice (E-invoice)',
    specialInvoice: 'Special Invoice (E-invoice)',
  },
  invoicingInvoicingApplication: {
    applicationDate: 'Application date',
    billingApplication: 'Billing application',
    expenseType: 'Expense type',
    amountApplied2: 'Amount applied',
    expressNumber: 'Express number',
    alreadyRequested: 'Already requested',
  },
  preauthorizationIndex: {
    turn: 'Turn',
    increaseAuthorization: 'Increase Authorization',
    authorizationFailure: 'Authorization Failure',
    settlementTime: 'Settlement time',
    preAuthorizationDetailsLightWinTreasureHotelManagementSystem:
      'Pre-authorization - Light Win Treasure Hotel Management System',
    declined: 'Declined',
    flyingPigCreditDoesNotSupportPreAuthorization:
      'Flying Pig credit does not support pre-authorization',
    newAuthorization: 'New authorization',
    cancelAuthorizationPleaseWait: 'Cancel authorization please wait',
    succeededInCancelingAuthorization: 'Succeeded in canceling authorization',
    pleaseWaitForTheSettlementAuthorization: 'Please wait for the settlement authorization',
    confirmThatYouWantToCancelAuthorization: 'Confirm that you want to cancel authorization',
    orderStatusWarning: 'Order {status}, cannot {action}',
    roomStatusWarning: 'Room is occupied, cannot {action}',
    roomCheckoutWarning: "Room status is 'checked out', cannot {action}",
  },
  componentsAuthsettle: {
    payment3: 'Payment',
    paidInAmount: 'Paid-in amount',
    settlementSuccess: 'Settlement success',
    authorizedSettlement: 'Authorized settlement',
    accountEntry: 'Payment Method',
    pleaseFillInTheAuthorizedAmount: 'Please fill in the authorized amount',
    theActualAmountReceivedMustBeGreaterThan0: 'The actual amount received must be greater than 0',
    theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount:
      'The actual amount received cannot be greater than the authorized amount',
  },
  componentsBanklist: {
    bankOfChina: 'Bank of China',
    industrialAndCommercialBankOfChina: 'Industrial and Commercial Bank of China',
    industrialAndCommercialBankOfChina3: 'Industrial and Commercial Bank of China',
    agriculturalBankOfChina: 'Agricultural Bank of China',
    agriculturalBankOfChina3: 'Agricultural Bank of China',
    chinaConstructionBank: 'China Construction Bank',
    chinaConstructionBank3: 'China Construction Bank',
    postalSavingsBankOfChina: 'Postal Savings Bank of China',
    postalSavingsBank: 'Postal savings Bank',
    bankOfCommunications: 'Bank of Communications',
    chinaMerchantsBank: 'China Merchants Bank',
    shanghaiPudongDevelopmentBank: 'Shanghai Pudong Development Bank',
    shanghaiPudongDevelopmentBank3: 'Shanghai Pudong Development Bank',
    chinaCiticBank: 'China CITIC Bank',
    everbrightBank: 'Everbright Bank',
    chinaMinshengBank: 'China Minsheng Bank',
    minshengBank: 'Minsheng Bank',
    guangdongDevelopmentBank: 'Guangdong Development Bank',
    guangfaBank: 'Guangfa Bank',
    pingAnBank: 'Ping An Bank',
    industrialBank: 'Industrial Bank',
    huaxiaBank: 'Huaxia Bank',
    bankOfShanghai: 'Bank of Shanghai',
    bankOfBeijing: 'Bank of Beijing',
    bohaiBank: 'Bohai Bank',
    zheshangBank: 'Zheshang Bank',
    huishangBank: 'Huishang Bank',
    hsbc: 'HSBC',
    hangSengBank: 'Hang Seng Bank',
    hengfengBank: 'Hengfeng Bank',
  },
  componentsExpandcolumn: {
    bankName: 'Bank name',
    authorizationCode: 'Authorization code',
    from: 'From',
    rollOutTo: 'Roll out to',
  },
  componentsTransferaccounts: {
    transferMoney: 'Transfer money',
    transferToAccount: 'Transfer to account',
    authorizationFailure: 'Authorization failure',
  },
  componentsUpdateauthorization: {
    automaticSettlementAfterExpiration: 'Automatic settlement after expiration',
    authorizationCode: 'Authorization code',
    bankName: 'Bank name',
    pleaseFillInTheAuthorizedAmount: 'Please fill in the authorized amount',
    newAuthorization: 'New authorization',
    modifyAuthorization: 'Modify authorization',
    renewal: 'Renewal',
  },
  componentsCancelorder: {
    reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation:
      'Reminder: This order is an EB order. Please verify the OTA order status before cancellation.',
    orderCancelledSuccessfully: 'Order cancelled successfully',
    cancelAnOrder2: 'Cancel an order',
    cancellationReason: 'Cancellation reason',
    remarks5100Words: 'Remarks (5-100 words)',
    replyTextMinimum5Words: 'Reply text minimum 5 words',
    pleaseSelectACancellationReason: 'Select a cancellation reason',
    originalStayWillBeCancelled: 'The original extension will be automatically cancelled',
    cancellationRules: 'Cancellation rules',
    channelDescription: 'Channel description',
    refundScore: 'Refund points',
    refundCoupon: 'Refund coupon',
    orderMessage: 'Order message',
    pleaseEnterOrderMessage: 'Please enter an order message',
    directCancelSuccessComment: 'Order cancelled successfully',
  },
  componentsEditcontactinfo: {
    modifyAContact: 'Modify a contact',
    pleaseEnterThe11DigitPhoneNumber: 'Please enter the 11-digit phone number',
  },
  componentsEditorder: {
    modifyTheOrder2: 'Modify the order',
    selectDate1: 'Select date 1',
    selectDate2: 'Select Date 2',
    contactNumber4: 'Contact number',
    theRetentionTimeMustNotBeLessThanTheCurrentTime:
      'The retention time must not be less than the current time',
    theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime:
      'The retention time shall not be less than the estimated arrival time',
    theRetentionTimeMustNotBeLongerThanThePreDepartureTime:
      'The retention time must not be longer than the pre-departure time',
    doNotRepeatThisOperationWhileSubmittingChanges:
      'Do not repeat this operation while submitting changes',
    orderModificationSuccessful: 'Order modification successful',
  },
  componentsEditOrderV2: {
    addedRoomsOverAvailability: 'The number of added rooms cannot exceed availability',
    arrivalBeforeToday: 'The arrival date of a new room order cannot be earlier than today',
    assignedRoom: 'Assigned {room}',
    availabilityLoading: 'Loading availability for this room type. Please try again later',
    availableCount: 'Available: {count}',
    checkedInRoom: 'Checked in {room}',
    checkedOutRoom: 'Checked out {room}',
    chooseArrivalTime: 'Select arrival time',
    chooseDepartureTime: 'Select departure time',
    detailLoadFailed: 'Failed to load the new order modification data',
    detailLoadRetry: 'Failed to load the new order modification data. Please try again',
    discountLabel: '{discount}% off the rack rate',
    invalidStay: 'Please select valid arrival and departure times',
    keepOneRoom: 'At least one valid room order must remain after modification',
    latestPriceFailed: 'Failed to load the latest rates. Adjust the stay dates and try again',
    latestPriceLoading: 'Loading the latest rates. Please submit later',
    longStayAtLeastTenDays: 'The stay for a long-term booking must be at least 10 days',
    longStayAtMostOneYear: 'The stay for a long-term booking cannot exceed one year',
    longStayNoMorning: 'Early-morning rooms are not allowed for long-term bookings',
    markedCancelled: 'Marked for cancellation',
    newRoomOrder: 'New room order',
    newRoomPriceLoading: 'Loading stay dates and rates for new room orders. Please submit later',
    noReducibleRoom: 'There is no temporary or pending room order that can be reduced for this room type',
    otherStatus: 'Other status',
    phonePlaceholder: 'Enter mobile number',
    productPriceFailed: 'Failed to load hotel products and rates. Please try again',
    roomNumberValue: 'Room {room}',
    roomOrderDetails: 'Details',
    roomTypeInfo: 'Room type information',
    roomTypeNoProduct: 'No available hotel product for this room type',
    stayChangedClearRoom: 'The stay dates changed. The previous room assignment was cleared; please assign a room again',
    stayPriceRefreshFailed: 'Failed to load rates after the stay dates changed. Please try again',
    stayProductPriceFailed: 'Failed to load hotel products and rates for the selected stay. Please try again',
    stayProductUnavailable: 'No available hotel product for this room type during the selected stay',
    storeProductMissing: 'No hotel product found',
    temporaryRoomOrder: 'Temporary room order',
    unassignedSummary: '{count} room(s) awaiting assignment',
  },
  componentsEditroomorder: {
    modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder:
      'Modifying the agreed unit information will recalculate all room rates in the order',
    modifyRoomList: 'Modify room list',
    forOccupiedRoomsOnlyModifyTheRoomRatesForTheCurrentBusinessDayAndSubsequentDays:
      'For occupied rooms, only modify the room rates for the current business day and subsequent days.',
  },
  componentsEditroomprice: {
    modifyTheHousePrice: 'Modify the house price',
    theCurrentPriceCalendarCannotBeModified: 'The current price calendar cannot be modified',
    updatePriceCalendarSuccessfully: 'Update price calendar successfully',
  },
  componentsLevelup: {
    payTheBill: 'Pay the bill',
    partUpgrade: 'Part upgrade',
    confirmTheUpgrade: 'Confirm the upgrade',
    currentRoomType: 'Current room type',
    reselection: 'Reselection',
    chargeOrNot: 'Charge or not',
    currentTotalHousePrice: 'Current total house price',
    totalRateAfterUpgrade: 'Total rate after upgrade',
    priceDifference: 'Price difference',
    upgradeCause: 'Upgrade cause',
    enterAMaximumOf150Words: 'Enter a maximum of 150 words',
    pleaseChooseWhetherToCharge: 'Please choose whether to charge',
    pleaseEnterTheUpgradeReason: 'Please enter the upgrade reason',
    inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0:
      'In the case of payment, the spread cannot be less than or equal to 0',
    reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference:
      'Reminder: If you upgrade the room type between the night audit and 06:00, please manually handle the room rate difference.',
    inTheCaseOfPaymentTheDifferenceCannotBeLessThanOrEqualTo:
      'In the case of payment, the difference cannot be less than or equal to',
  },
  componentsSeeroomprice: {
    viewRoomRates: 'View room rates',
  },
  componentsStay: {
    theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate:
      'The current room type is sold out, please select another date',
    existingRoomSingleChargeCheckOut: 'Existing room single charge check out',
    theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill:
      'The account of the existing house bill is transferred to the new house bill',
    promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms:
      'Prompt: The current room is a linked room bill. After extending the stay, you need to manually add the new room bill to the linked rooms.',
    nonStoreSingleCanNotSustain: 'Non-store single can not sustain',
    youCannotRenewYourStayUntilTheCheckOutDate:
      'You cannot renew your stay until the check-out date',
    extendStayadvance: 'Extend Stay/Advance',
    originalOrder2: 'Original Order',
    continuationPrice: 'Continuation Price',
    changeTheCheckOutTime: 'Change The Check-out Time',
    selectDateTime: 'Select date time',
    continuationPriceRule: 'Continuation Price Rule',
    swapOrder: 'Swap Order',
    nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation:
      'Name and mobile phone number of the person who made the reservation',
    subscriber: 'Subscriber',
    roomAccountProcessing: 'Room account processing',
    pleaseSelectTheRenewalPriceRule: 'Please select the renewal price rule',
    checkOutTimeCannotBeLessThanTheCurrentTime:
      'Check-out time cannot be less than the current time',
    theRenewalOfStayIsSuccessful: 'The renewal of stay is successful',
    pleaseSelectANewOrder: 'Please select a new order',
    theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder:
      'The renewal of the order does not support the flying pig credit order',
    extendStayadvanceSuccess: 'Extension/Early check-out successful',
    roomNumber: 'Room No.',
    checkInPerson: 'Guest',
    checkOutTime: 'Check-out time',
    makeCard: 'Make card',
    booked: 'Post',
    close: 'Close',
  },
  componentsTools: {
    pendingClosing: 'Pending closing',
    closingSuccessful: 'Closing successful',
    failedToApplyForClosing: 'Failed to apply for closing',
    firstNightRate: 'First night rate',
    lateNightRate: 'Late night rate',
    maximumHousePrice: 'Maximum house price',
    minimumRoomRate: 'Minimum room rate',
  },
  ebkorderIndex: {
    priceDescription: 'Price description',
    merchantPromotionTotalAmountBorneByTheMerchant:
      'Merchant promotion = Total amount borne by the merchant',
    totalSellingPriceTotalOrderAmountMerchantPromotion:
      'Total selling price = Total order amount - Merchant promotion',
    totalCommissionTotalSellingPriceCommissionRate:
      'Total commission = Total selling price * Commission rate',
    totalBasePriceTotalSellingPriceTotalCommission:
      'Total base price = Total selling price - Total commission',
    userPaymentAmountActuallyPaidByTheUser: 'User payment = Amount actually paid by the user',
    totalOrder: 'Total order',
    totalSellingPrice: 'Total selling price',
    userPayment: 'User payment',
    totalCommission: 'Total commission',
    totalFloorPrice: 'Total floor price',
    merchantPromotion: 'Merchant promotion',
    viewOrder: 'View order',
    orderTransferMethod: 'Order transfer method',
    removalOfOrder: 'Removal of order',
    contactAndMobilePhoneNumber: 'Contact and mobile phone number',
    channelOrderStatus: 'Channel order status',
    orderStatus: 'Order status',
    channelOrderNumber: 'Channel order number',
    channelType: 'Channel type',
    expectedArrivalexpectedDeparture: 'Expected arrival/Expected departure',
    bookingType: 'Booking type',
    estimatedTimeOfArrival: 'Estimated time of arrival',
    orderCreationTime: 'Order creation time',
    inBooking: 'In booking',
    bookingFailed: 'Booking failed',
    bookingException: 'Booking exception',
    initialRejection: 'Initial rejection',
    canceling: 'Canceling',
    otherStates: 'Other states',
    movedOrder: 'Moved order',
    unmovedOrder: 'Unmoved order',
    createTimeDesc: 'Creation time (descending)',
    createTimeAsc: 'Creation time (ascending)',
    arriveTimeDesc: 'Arrival time (descending)',
    arriveTimeAsc: 'Arrival time (ascending)',
    ebkOrderCheckMsg: 'No data available, click to add',
  },
  ebkorderUnbindtip: {
    youDoNotHaveAMeituanAccount: 'You do not have a Meituan account',
    pleaseSetItInmoresystemSettingsebAccountAuthorization:
      'Please set it in [More] - [System settings] - [EB account authorization].',
    clickToGo: 'Click to go',
  },
  orderBoxIndex: {
    title: 'Order Box',
    businessType: 'Business Type',
    processStatus: 'Process Status',
    businessTypeCreateOrder: 'Create Order',
    businessTypeCancelOrder: 'Cancel Order',
    businessTypeCheckout: 'Check-out',
    businessTypeExtendStay: 'Extend Stay',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusProcessed: 'Processed',
    quickAccept: 'Quick Accept',
    confirmQuickAccept: 'Confirm quick accept for this order?',
  },
  invoiceInvoiceDetail: {
    personage: 'Personage',
    firm: 'Firm',
    headerType: 'Header type',
    invoiceAmount2: 'Invoice amount',
    pleaseEnterTheInvoiceAmount: 'Please enter the invoice amount',
    pleaseEnterTheInvoiceNumber2: 'Please enter the invoice number',
    invoiceGroup: 'Invoice group',
    selectRoomList: 'Select room list',
    orderAmount: 'Order amount',
    pleaseEnterTheInvoiceTitleToSearch: 'Please enter the invoice title to search.',
    pleaseEnterYourTaxIdentificationNumber: 'Please enter your tax identification number',
    unitAddress: 'Unit address',
    pleaseEnterTheAddressOfTheUnit: 'Please enter the address of the unit',
    telephoneNumber: 'Telephone number',
    bankOfDeposit2: 'Bank of deposit',
    pleaseEnterYourBank: 'Please enter your bank',
    bankAccount: 'Bank account',
    pleaseEnterYourBankAccount: 'Please enter your bank account',
    pleaseEnterYourEmailAddress: 'Please enter your email address',
    invoiceMailingAddress: 'Invoice mailing address',
    pleaseEnterTheInvoiceMailingAddress: 'Please enter the invoice mailing address',
    billingNote: 'Billing note',
    pleaseEnterYourBillingRemarks: 'Please enter your billing remarks',
    pleaseSelectTheBillingType5: 'Select the billing type',
    pleaseSelectAHeaderType: 'Select a header type',
    fillInAtLeastOneEMailAndMailingAddress: 'Fill in at least one E-mail and mailing address',
  },
  invoiceInvoiceList: {
    toBeInvoiced: 'To be invoiced',
    pleaseEnterYourTaxIdentificationNumber: 'Please enter your tax identification number',
    pleaseEnterTheInvoiceNumber2: 'Please enter the invoice number',
    newInvoice: 'New invoice',
    invoiceType: 'Invoice Type',
    invoiceAmount: 'Invoice Amount',
    billingTime: 'Billing time',
  },
  invoiceRoomInvoiceAssociationSearch: {
    roomListInvoiceList2: 'Room List Invoice List',
    namePhoneNumberRoomNumber: 'Name, phone number, room number',
  },
  invoiceRoomInvoiceList: {
    roomListInvoiceList2: 'Room List Invoice List',
    accumulatedInvoiceAmount: 'Accumulated Invoice Amount',
    toBeInvoiced: 'To be invoiced',
    newInvoice: 'New invoice',
    invoiceType: 'Invoice Type',
    invoiceAmount: 'Invoice Amount',
    billingTime: 'Billing time',
  },
  orderListBaseinfo: {
    getThePhoneNumber: 'Get the phone number',
    preSaleVoucherNumber: 'Pre-sale voucher number',
    contractNumber: 'Contract number',
    invoice: 'Invoice',
    promotionalActivity: 'Promotional activity',
    estimatedSettlementAmount: 'Estimated Settlement Amount',
    pack: 'Pack',
    selfServiceReservation: 'Self-service reservation',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'The invoice for this order is provided by the sales channel to the guest',
    thisOrderIsInvoicedByYourHotelToTheGuest: 'This order is invoiced by your hotel to the guest',
    theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill:
      'The amount is for reference only, the specific settlement amount is subject to the bill',
    systemRemark: 'System Remark',
    sellerRemark: 'Merchant Remark',
  },
  orderListCheckIn: {
    handleSuccessfully: 'Handle successfully',
    viewCheckInInformation: 'View check-in information',
    handleAgain: 'Handle again',
    handlingFailure: 'Handling failure',
    theNameCannotBeBlank2: 'The name cannot be blank',
    theIdTypeCannotBeEmpty: 'The ID type cannot be empty',
    theIdNumberCannotBeEmpty: 'The ID number cannot be empty',
    pleaseArrangeTheRoomFirst: 'Please arrange the room first',
    checkInData: 'Check-in data',
  },
  orderListDetail: {
    checkInStatus: 'Check-in Status',
    total: 'Total',
    chargedToAccount: 'Charged to Account',
    natureTraffic: 'Organic traffic',
    natureOrderTip: 'This order comes from a direct channel of Qingzhu (organic traffic).',
    preCheckInForm: 'Pre-check-in form',
    continuationOrder: 'Continuation order',
    liveOnCredit: 'Live on credit',
    preSaleVoucherReservationForm: 'Pre-sale voucher reservation form',
    meituanEbOrder: 'Meituan EB order',
    ctripEbOrder: 'Ctrip EB order',
    flash: 'Flash',
    fullGuarantee: 'Full guarantee',
    roomListInformation: 'Room List Information',
    automaticRowHouse: 'Auto-Assign Rooms',
    bulkCheckIn: 'Bulk check-in',
    unterracedHouse: 'Unassigned Room',
    upgrades: 'Upgrades',
    prefabricatedKeyCard: 'Prefabricated key card',
    modifyTheOrder2: 'Modify the order',
    cancelAnOrder2: 'Cancel an order',
    rejectAnOrder: 'Reject an order',
    pleaseArrangeTheRoomBeforePreformingTheKeyCard:
      'Please arrange the room before preforming the key card',
    theListingHasBeenCancelled: 'The listing has been cancelled',
    noRoomingAllowedAfterThePreDepartureTime: 'No rooming allowed after the pre-departure time',
    allListingsAreAlreadyFurnished: 'All listings are already furnished',
    theAutomaticPlatoonSucceeded: 'The automatic platoon succeeded',
    someRowhousesAreSuccessful: 'Some rowhouses are successful',
    smartCheckInBusinessHasNotOpenedTheFunction:
      'Smart check-in business has not opened the function',
    thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal:
      'This order is a renewal order, check-in may affect the original room renewal',
    thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom:
      'This order is a renewal order, which may affect the continuation of the original room',
    exceedDepartureDate:
      'The scheduled departure date has been exceeded. Room upgrade is not allowed.',
    theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom:
      'The current time has exceeded the check-out time, cannot upgrade the room',
    cancelingTheCurrentRowSucceededProcedure: 'Canceling the current row succeeded. Procedure',
    orderAcceptedSuccessfully: 'Order accepted successfully',
    successfulRejection: 'Successful rejection',
    thisActionWillCancelTheListingWhetherToContinue:
      'This action will cancel the listing, whether to continue',
  },
  orderListGiftinfodetail: {
    packageName: 'Package name',
    packageValue: 'Package value',
    wayOfGiving: 'Way of giving',
    dateOfPresentation2: 'Date of presentation',
    packageDetails: 'Package details',
    oneDeliveryPerRoom: 'One delivery per room',
    complimentaryOnceADayPerRoom: 'Complimentary once a day per room',
  },
  orderListOrderDetail: {
    orderDetails: 'Order Details',
    finance3: 'Finance',
    preAuthorizationDetail: 'Pre-authorization',
  },
  orderListOrderList: {
    durationOfResidence: 'Duration of residence',
    bookingTime: 'Booking time',
    preCheckInForm: 'Pre-check-in form',
    housePig: 'House pig',
    presaleTicket: 'Presale ticket',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'Name, mobile phone number, order number, channel number query',
    multipleSearch: 'Comprehensive search',
    selfServiceReservation: 'Self-service reservation',
    rejectAnOrder: 'Reject an order',
    individualTraveler: 'Individual traveler',
    team2: 'Team',
    estimate: 'Estimate',
    firstDayPrice: 'First day price',
    areYouSureYouWantToTakeTheOrder: 'Are you sure you want to take the order',
    orderAcceptedSuccessfully: 'Order accepted successfully',
    booked: 'Booked',
    refused: 'Refused',
    extendStayCheckInImpact:
      'This order is an extended stay. Proceeding with check-in may affect the original stay.',
    exceededDepartureCannotUpgrade:
      'Exceeded the departure date 6 AM, room type upgrade is not allowed.',
    exceededCheckoutCannotUpgrade:
      'Current time has exceeded the checkout time, room upgrade not supported.',
    exceededDepartureCannotArrangeRoom: 'Cannot arrange rooms after the departure time.',
    preArrivalNotArrived: 'Pre-arrival no show',
    noshow: 'No-show',
  },
  orderListNoShow: {
    title: 'No-show',
    noshowReason: 'No-show reason',
    remarkPlaceholder: 'Remarks (5-100 characters)',
    remarkMinLength: 'Remarks must be at least 5 characters',
    pleaseSelectNoshowReason: 'Please select a no-show reason',
  },
  orderListPricedetail: {
    channelCost: 'Channel cost',
    eventDiscount: 'Event discount',
    guestActivityDiscount: 'Guest activity discount',
    memberDiscount: 'Member discount',
    guestMembershipDiscount: 'Guest membership discount',
    sameTripExclusiveOffer: 'Same trip exclusive offer',
    guestTongchengExclusiveDiscount: 'Guest Tongcheng exclusive discount',
    guestPurchasePrice: 'Guest purchase price',
    activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests:
      "Activity discount and hotel selling price explanation: There will be a difference between the guests of this channel and the settlement bill. You can click 'Price prompt' to view the actual amount paid by the guests.",
    priceDetails: 'Price details',
    memberBenefits: 'Member benefits',
    jointMemberBenefits: 'Joint member benefits',
  },
  orderListPromotiondetail: {
    eventDetails2: 'Event details',
    preferentialRules: 'Preferential rules',
  },
  orderListPromotiondetailnew: {
    eventDetails2: 'Event details',
    dateCondition: 'Date condition',
    bookingConditions: 'Booking conditions',
    preferentialRules: 'Preferential rules',
    participationDate: 'Participation date',
  },
  orderListRefuse: {
    areYouSureYouWantToDeclineThisOrder: 'Are you sure you want to decline this order',
    confirmationRejection: 'Confirmation rejection',
    successfulRejection: 'Successful rejection',
    theOrderWillBeClosedAtTheSameTime: 'The order will be closed at the same time',
    overbookingSetup: 'Overbooking setup',
  },
  orderListTip: {
    useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage:
      "Use WeChat to scan the 'check-in QR code' at the front desk to open the order inquiry page.",
    fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm:
      "Fill in the booking person's name, mobile phone number and check-in date to check the booking form",
    selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation:
      'Select the booking form that needs to be checked in, and select the room where you want to add people to fill in the information',
    atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests:
      "At this point, you can view the room alert in the pre - order details. After filling in the information of all the guests, click the 'Check - in' button to check in the guests.",
    atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully:
      'At this point, you can see in the list details that the person has been added successfully',
    off: 'Off',
    theUserHasCompletedTheProcedure: 'The user has completed the procedure',
    pleaseGuideTheGuestsTocheckInInTheFollowingWay:
      "Please guide the guests to 'check in' in the following way.",
    afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification:
      "After the guests fill in and submit, the page will display 'Please bring your ID to the front desk for verification'.",
    pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows:
      'Please guide the guests to add additional guests as follows.',
  },
  groupOrderAddroomer: {
    validityPeriod: 'Validity period',
    addmodifyCheckInGuests: 'Add/Modify check-in guests',
    pleaseEnterAddress: 'Please enter address',
    startDate: 'Start date',
    currentSubscript: 'Current subscript',
  },
  groupOrderIndex: {
    bulkCheckIn: 'Bulk check-in',
    automaticRowHouse: 'Auto-Assign Rooms',
    checkInAddition: 'Check-in addition',
    pleaseSelectTheRoomYouWantToCheckIn: 'Please select the room you want to check in',
    theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn:
      'The empty and dirty room you selected is confirmed to check in',
    checkInSuccessful: 'Check-in successful',
    roomNoLongerAvailablePleaseChangeToAnotherRoomNumber:
      'Room no longer available, please change to another room number',
    theRoomIsOccupiedPleaseChangeToAnotherRoomNumber:
      'The room is occupied, please change to another room number',
    pleaseArrangeTheRoomBeforeChoosing: 'Please arrange the room before choosing',
    allListingsAreAlreadyFurnished: 'All listings are already furnished',
    theAutomaticPlatoonSucceeded: 'The automatic platoon succeeded',
    pleaseListTheRoomFirstAndThenAddTheGuest: 'Please list the room first and then add the guest',
    succeededInCancelingTheRowHouse: 'Succeeded in canceling the row house',
  },
  presalecouponsPredetail: {
    ticketName: 'Ticket name',
    presaleTicket: 'Presale ticket',
    saleOrderNumber: 'Sale order number',
    purchaseTime: 'Purchase time',
    advanceOrder: 'Advance order',
    availableProduct: 'Available product',
    commodityContent: 'Commodity content',
    ruleInformation: 'Rule information',
    availableTime: 'Available time',
    checkInTime2: 'Check-in time',
    markUpRule: 'Mark-up rule',
    cancellationRules: 'Cancellation rules',
    paymentInformation: 'Payment information',
    crossedPrice: 'Crossed price',
    chineseFood: 'Chinese food',
    dinner2: 'Dinner',
    goWhereTheDirectConnection: 'Go where the direct connection',
    bookedBedtotalBedHours: 'Booked bed/Total bed hours',
    raiseAPrice: 'Raise a price',
    meituanDirectNew: 'Meituan direct new',
    officialWebsiteDirect: 'Official website direct',
    ctripSingleStore: 'Ctrip Single Store',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
  },
  presalecouponsPrelist: {
    dateOfPayment: 'Date of payment',
    productId: 'Product ID',
    sellOrderNumber: 'Sell order number',
    noAppointment: 'No appointment',
    completeWriteOff: 'Complete write-off',
    completeReverseWriteOff: 'Complete reverse write-off',
    refunded: 'Refunded',
    orderNumber2: 'Order number',
    timeOfPayment: 'Time of payment',
    bookedBedtotalBedHours: 'Booked bed/Total bed hours',
  },
  hardwareParking: {
    parkingLotManagement: 'Parking Lot Management',
    parkingLotDescription: 'Supports automatic license plate recognition for entry and exit',
    settings: 'Settings',
    parkingLotConfig: 'Parking Lot Config',
    currentDevice: 'Current Device',
    unboundDeviceTip: 'No parking lot device is bound to the current hotel',
    sidPlaceholder: 'Please enter SID',
    secretKeyPlaceholder: 'Please enter SecretKey',
    enableStatus: 'Enable Status',
    hotelNotBoundWarning: 'No parking lot device is bound to the current hotel',
    enterSidAndSecretKey: 'Please enter SID and SecretKey',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    configFailed: 'Configuration failed',
    parkingDeviceEnabled: 'Parking lot device enabled',
    parkingDeviceDisabled: 'Parking lot device disabled',
    fetchHardwareRelationFailed: 'Failed to get hardware binding relationship',
    fetchConfigFailed: 'Failed to get parking lot config',
  },
  roomOrderListVehicleDialog: {
    title: 'License Plate No.',
    platePlaceholder: 'Please enter license plate no.',
    add: 'Add',
    plateNo: 'License Plate No.',
    enterPlateWarning: 'Please enter license plate no.',
    enterPlateFormatWarning: 'Invalid license plate format',
    addSuccess: 'Added successfully',
    deleteConfirm: 'Are you sure you want to delete this license plate no.?',
    deleteSuccess: 'Deleted successfully',
  },
  roomOrderListDetail: {
    vehiclePlateNo: 'License Plate No.',
    saveFailed: 'Save failed',
    cancelStay: 'Cancel extension',
    systemRemark: 'System Remark',
    merchantRemark: 'Merchant Remark',
    downloadIdPhoto: 'Download ID photo',
    uploadedToPolice: 'Uploaded to police system',
    reuploadToPolice: 'Re-upload to police system',
    cancelStaySuccess: 'Cancel extension successful',
    enterNumber: 'Please enter a number',
    enterRemarkContent: 'Please enter remark content',
    uploaded: 'Uploaded',
    notUploaded: 'Not uploaded',
    originalStayOrder: 'Original stay order',
    newStayOrder: 'New stay order',
    continued: 'Cont.',
    extendStayReminder: 'Extension reminder: the displayed rate is for the first extension day',
    roomChangeReminder: 'Friendly reminder: please double-check details, then sign to confirm',
    extendStayFirstDayTip: 'Extension room shows the first-day price',
    reminderDoubleCheck: 'Please double-check all details before signing',
    liveOnCredit: 'Live on credit',
    duration: 'Duration',
    invoice: 'Invoice',
    roomInformation2: 'Room Information',
    numberOfGuests: 'Number of Guests',
    doorLockCode: 'Door lock code',
    generatePassword: 'Generate password',
    resetPassword: 'Reset password',
    passwordInvalidation: 'Password invalidation',
    idNumber2: 'Id Number',
    guestAddress: 'Guest Address',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'The invoice for this order is provided by the sales channel to the guest',
    thisOrderIsInvoicedByYourHotelToTheGuest: 'This order is invoiced by your hotel to the guest',
    originalOrder2: 'Original Order',
    swapOrder: 'Swap Order',
    faceCollection: 'Face collection',
    invoice2: 'Invoice',
    sendPassword: 'Send Password',
    upgradeTheRoom: 'Upgrade The Room',
    extendStayadvance: 'Extend Stay/Advance',
    transferToFullDayRoom: 'Convert to Daily Room',
    decamping: 'Remove Guest',
    increaseCohabitation: 'Increase Cohabitation',
    checkInSlip4: 'Check-in Slip',
    reinstatement: 'Reinstatement',
    renewalOrder2: 'Renewal order',
    roomChangeConfirmationForm3: 'Room change confirmation form',
    conferenceCorps: 'Conference corps',
    tourParty: 'Tour party',
    confirmNeedToResumeCheckIn: 'Confirm need to resume check-in',
    operationReminder: 'Operation reminder',
    reinstatedCheckInSuccessful: 'Reinstated check-in successful',
    fullDayRoomTransfersAreNotSupportedForOnlineOrders:
      'Full day room transfers are not supported for online orders',
    whetherToCancelTheRowRoomAndTransferToTheFullDay:
      'Whether to cancel the row room and transfer to the full day',
    areYouSureYouWantToChangeToAFullDayRoom: 'Are you sure you want to change to a full - day room',
    checkOutTimeWillBeChangedTo2: 'Check-out time will be changed to',
    theRoomIsIn: 'The room is in...',
    existingRowHouse: 'Existing row house',
    conversionToFullDayRoomSuccessful: 'Conversion to full day room successful',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'Flying pig credit live orders do not support joint housing',
    generatePassword2: 'Generate password',
    passwordGeneratedSuccessfully: 'Password generated successfully',
    areYouSureYouWantToResetYourCurrentPassword:
      'Are you sure you want to reset your current password',
    resetPassword2: 'Reset password',
    resetPasswordSuccessfully: 'Reset password successfully',
    areYouSureYouWantToInvalidateYourCurrentPassword:
      'Are you sure you want to invalidate your current password',
    thePasswordIsInvalid: 'The password is invalid',
    thePasswordIsInvalidProcedure: 'The password is invalid. Procedure',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'The current time has passed the check-out time, the room cannot be changed',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'The current time has passed the check-out time, the room upgrade is not supported',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'The current time has passed 6:00 check-in date, the room upgrade is not supported',
    theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder:
      'The guest has applied for online renewal, and may not be able to renew the order',
    flyingPigCreditOrdersCanNotBeSustained2: 'Flying pig credit orders can not be sustained',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'It has passed the check-out date and cannot be extended',
    successfulRoomExchange2: 'Successful room exchange',
    upgradedRoomTypeData: 'Upgraded room type data',
    theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified:
      "The other rooms in the order have checked out, and the 'customer type' cannot be modified",
    theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms:
      'The guest has applied for online renewal and confirmed the need to continue changing rooms',
  },
  roomOrderListGroupRoomDetail: {
    contactNumber4: 'Contact number',
    aTotalOf: 'A total of',
    occupancyStatus: 'Occupancy status',
    onAccount2: 'On account',
    rollOut: 'Roll-out',
    setAsMaster: 'Set as master',
    rescission: 'Rescission',
    teamRegistrationSheet: 'Team registration sheet',
    numberOfRooms: 'Number of rooms',
    confirmToCancelTheHouseRelationship: 'Confirm to cancel the house relationship',
    successfullyDisconnectingTheHouse: 'Successfully disconnecting the house',
    rollOutSuccess: 'Roll-out success',
    setTheMasterOrderToSucceed: 'Set the master order to succeed',
  },
  roomOrderListMinusroomer: {
    residentGuest: 'Resident guest',
    reduceRoommateSuccess: 'Reduce roommate success',
    decamping: 'Remove Guest',
    pleaseSelectTheNumberOfPeopleYouWantToReduce:
      'Please select the number of people you want to reduce',
    keepAtLeastOneOccupantInTheRoom: 'Keep at least one occupant in the room',
  },
  roomOrderListRelativeRoom: {
    roomOrder: 'Room Orders',
    reservationOrder: 'Reservations',
    pendingCheckIn: 'Pending Check-in',
    pleaseSelectARoomOrder: 'Please select a room order',
    linkRoomNumber: 'Linked Room No.',
    inTheRoom: 'In-House',
    residentialTeam: 'Residential team',
    flyingPigCreditDoesNotSupportHousing: 'Flying pig credit does not support housing',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'Direct channels do not support the establishment of joint houses and teams with store channels',
    guestsNameMobilePhoneNumberAndRoomNumber: "Guest's name, mobile phone number and room number",
    teamNameBookingPersonNameMobilePhoneNumber:
      'Team name, booking person name, mobile phone number',
    pleaseSelectATeam: 'Please select a team',
    joinTheTeamSuccessfully: 'Join the team successfully',
    joinTheRoomSuccessfully: 'Join the room successfully',
  },
  roomOrderListRollin: {
    flyingPigCreditDoesNotSupportHousing: 'Flying pig credit does not support housing',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'Direct channels do not support the establishment of joint houses and teams with store channels',
    transferIn: 'Transfer-in',
    namePhoneNumberRoomNumber2: 'Name, phone number, room number',
    succeededInJoiningTheHouse: 'Succeeded in joining the house',
  },
  roomOrderListRoomOrderDetail: {
    twinRooms: 'Twin Rooms',
    roomList: 'Room List',
    noRoomListingInformationAvailable: 'No room listing information available',
    manage: 'Manage',
    fullState: 'Full State',
    finance3: 'Finance',
    preAuthorizationDetail: 'Pre-authorization',
    houseDetails: 'House details',
    listingDetails: 'Listing Details',
    thereAreNoOccupants: 'There are no occupants',
  },
  roomOrderListRoomOrderList: {
    durationOfResidence: 'Stay Duration',
    bookingTime: 'Booking time',
    room2: 'Room',
    doNotGift: 'Do not gift',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'Name, mobile phone number, order number, channel number query',
    multipleSearch: 'Comprehensive search',
    bonusPoints: 'Bonus points',
    subscriber: 'Subscriber',
    subscriberNumber: 'Subscriber number',
    areYouSureYouWantToGiveAwayPoints: 'Are you sure you want to give away points',
    rewardPointsSuccessfully: 'Reward points successfully',
    guestphone: 'Guest/Phone',
    actualCheckoutTime: 'Actual check-out time',
  },
  faceFacedialog: {
    faceCollection: 'Face collection',
    faceCollectionSuccess: 'Face collection success',
    faceCollectionFailure: 'Face collection failure',
    takeAPicture: 'Take a picture',
    upload: 'UPLOAD',
    upCross: 'Up cross',
    uploadingPhotosPleaseCloseLater: 'Uploading photos, please close later',
    pleaseTakeAPictureFirst: 'Please take a picture first.',
    collectionSuccess: 'Collection success',
    collectionFailedPleaseTryAgain: 'Collection failed, please try again',
  },
  printtemplateChangeroom: {
    theOriginal: 'The original',
    changeDate: 'Change date',
    roomRateUpgrade: 'Room rate upgrade:',
    roomRate: 'Room rate:',
  },
  printtemplateChangeroomprintsmall: {
    changeDate: 'Change date',
    checkOutTime: 'Check-out',
    theOriginal: 'The original',
  },
  printtemplateGroupordertableprint: {
    position: 'Position',
  },
  printtemplateStayinprint: {
    confidentiality: 'Confidentiality',
  },
  printtemplateStaymore: {
    departureDate: 'Departure date',
    newDepartureDate: 'New departure date',
  },
  printtemplateStaymoreprint: {
    departureDate: 'Departure date',
    newDepartureDate: 'New departure date',
  },
  noticeOrdernotice: {
    messageCenter: 'Message center',
    orderInformation: 'Order information',
    dynamic: 'News feed',
    settlement: 'Settlement message',
    system: 'System message',
    noData: 'No new information yet',
    dynamicInformation: 'Dynamic information',
    systemInformation: 'System information',
    nightTrialFailTitle: 'Night audit failure',
    nightTrialFailContent: 'Night audit failed, please handle it promptly.',
  },
  noticeServicemanage: {
    serviceManagement: 'Service order management',
    roomService: 'Room service',
    itemBorrow: 'Borrowing',
    extendStay: 'Continuation service',
  },
  operatelogLog: {
    nightAuditLog: 'Night audit log',
    downloadLog: 'Download log',
    downloadSuccessfully: 'Download successfully',
  },
  operatelogNightauditlog: {
    nightTrialMethod: 'Night trial method',
    nightTrialResult: 'Night trial result',
    manualNightAudit: 'Manual night audit',
    automaticNightAudit: 'Automatic night audit',
    nightAuditFailure: 'Night audit failure',
    successfulNightAudit: 'Successful night audit',
    nightTrialDate: 'Night trial date',
    nightAuditRecord: 'Night audit record',
  },
  operatelogWorkingday: {
    variableMode: 'Variable mode',
  },
  financeAccountsreceivableaging: {
    bookName: 'Book name',
    totalAmountReceivable: 'Total amount receivable',
    amountPayable030Days: 'Amount payable (0-30 days)',
    amountPayable3160Days: 'Amount payable (31-60 days)',
    amountPayable6190Days: 'Amount payable (61-90 days)',
    amountToBeCollected91DaysOrMore: 'Amount to be collected (91 days or more)',
    typeOfExchange: 'Type of exchange',
    originalRoomNumber: 'Original room number',
    existingRoomNumber: 'Existing room number',
    currentHouseType: 'Current house type',
    roomChangeTime: 'Room change time',
    changeRoomsAfterCheckIn: 'Change rooms after check-in',
    originalRoomRate: 'Original room rate',
    spotRate: 'Spot rate',
  },
  financeAdjustmentCash: {
    financialStatement: 'Financial statement',
    occurrenceTime: 'Occurrence time',
    reconciliationStatement: 'Reconciliation statement',
  },
  financeAr: {
    channelReconciliationReport: 'Channel reconciliation report',
    writeOffStatus: 'Write-off status',
    amountOnCredit: 'Amount on credit',
    estimatedSettlementPrice: 'Estimated settlement price',
    unapprovedAmount: 'Unapproved amount',
    guestInvoiceRequirement: 'Guest invoice requirement',
    roomNumbername: 'Room number/name',
  },
  financeBreakfastStatistic: {
    flatBreakfast: 'Flat breakfast',
    advancePurchase: 'Advance purchase',
    availableBreakfasts: 'Available breakfasts',
    verifiedBreakfasts: 'Verified breakfasts',
    breakfastAmount: 'Breakfast amount',
    breakfastStatisticsReport: 'Breakfast statistics report',
    breakfastStatisticsReportxls: 'Breakfast statistics report.xls',
  },
  financeInventoryInOut: {
    inOutDate: 'In/Out date',
    storageType: 'In/Out type',
    storageTypeOut: 'Out-store',
    fileName: 'Inventory in-out report',
    columns: {
      inStoragePrice: 'In amount',
      outStoragePrice: 'Out amount',
    },
  },
  financeHousekeeping: {
    cleaningDate: 'Cleaning date',
    cleanType: 'Cleaning type',
    cleaner: 'Cleaner',
    status: 'Work order status',
    dailyCleaningAndLinen: 'Daily cleaning + change linen',
    dailyCleaning: 'Daily cleaning',
    dispatchTime: 'Dispatch time',
    cleanTime: 'Cleaning time',
    checkRoomTime: 'Room Check',
    recleaningReason: 'Reason for re-cleaning',
    checkerName: 'Check supervisor',
    statuses: {
      toBeCleared: 'To be cleaned',
      finishCleaning: 'Finished cleaning',
      noCleaning: 'No cleaning required',
      cancelOrder: 'Cancel dispatch',
      unauditedRoom: 'To be checked',
      wardRoundRejection: 'Room check rejected',
    },
  },
  settingHousekeeping: {
    cleaners: 'Cleaner',
    selectCleaners: 'Select cleaners',
    onDutyConfig: 'Cleaner on-duty time configuration',
    roomAssign: 'Room assignment',
    assignMode: {
      free: 'Free assignment',
      byFloor: 'Assign by floor',
      byRoom: 'Assign by room',
    },
    viewAssign: 'View assignment',
    cleanerPrefix: 'Cleaner:',
    autoDispatchConfig: 'Room cleaning auto-dispatch configuration',
    autoDispatch: {
      off: 'Turn off auto-dispatch',
      on: 'Turn on auto-dispatch',
    },
    autoDispatchRoomType: 'Auto-dispatch room type',
    leaveRoom: 'Checkout room',
    stayRoom: 'Stay-in room',
    dispatchRule: 'Cleaner dispatch rule',
    rules: {
      byTotal: 'Average by total processed work orders',
      byPending: 'Average by pending work orders',
    },
    leaveCleanType: 'Checkout room clean type',
    stayCleanType: 'Stay-in room clean type',
    dispatchTimeForStay: 'Dispatch time for stay-in',
    afterCleanCheck: 'Require room check after cleaning',
    needCheck: {
      no: 'No',
      yes: 'Yes',
    },
    dialog: {
      assignRelation: 'Assignment relation',
      selectFloor: 'Select floor',
    },
    messages: {
      selectCleaners: 'Select cleaners',
      dutyTimeInvalid: 'End time must be greater than start time',
    },
  },
  financeBreakfastDetails: {
    mealDate: 'Meal date',
    includeWaitingForCheckIn: 'Include waiting-to-check-in?',
    title: 'Breakfast details report',
    columns: {
      guestNum: 'Guests',
      roomContainsBreakfastNum: 'Room-included breakfast',
      buyBreakfastNum: 'Purchased breakfast',
      useBreakfastNum: 'Write-off',
    },
  },
  financeChannelConsume: {
    typeOfCompany: 'Type of company',
    roomNights: 'Room nights',
  },
  financeCheckout: {
    checkOutBusinessDay: 'Check-out business day',
    helpOneself: 'Help oneself',
    team2: 'Team',
    checkOutStatement: 'Check-out statement',
  },
  financeCreatedCompanyAccountOfAge: {
    scale: 'Scale',
    aged180DaysOrMore: 'Aged 180 days or more',
    agingStatementOfCreditCompany: 'Aging statement of credit company',
    accountAge030Days: 'Account age 0~30 days',
    accountAge3160Days: 'Account age 31~60 days',
    accountAge6190Days: 'Account age 61~90 days',
    accountAge91180Days: 'Account age 91~180 days',
  },
  financeDemandAccount: {
    collectTheRoomChargeInAdvance: 'Collect the room charge in advance',
    estimatedArrears: 'Estimated arrears',
    collectionStatement: 'Collection statement',
  },
  financeHangAccount: {
    accountStatus: 'Account status',
    businessDayOfHangingAccount: 'Business day of hanging account',
    hangTheAccountOperator: 'Hang the account operator',
    currentBalance: 'Current balance',
    closingTime: 'Closing time',
    noteOfHangingAccount: 'Note of hanging account',
    temporaryDebitStatement: 'Temporary debit statement',
    membercompany: 'Member/company',
  },
  breakfastVerification: {
    checkedInRoomList: 'Checked-in rooms',
    roomNo: 'Room No.',
    breakfastCount: 'Breakfasts',
    verified: 'Verified',
    buyBreakfast: 'Buy breakfast',
    verificationRecord: 'Verification records',
    verificationTime: 'Verification time',
    cardReading: 'Reading card',
    swipeCardVerification: 'Swipe to verify',
    breakfastVerification: 'Breakfast verification',
    pendingBreakfast: 'Breakfasts to verify',
    verificationCount: 'Verification quantity',
    confirmVerification: 'Confirm',
    noRoomRead: 'No room information was read',
    cardReadFailed: 'Failed to read card. Please check the room card or card reader.',
    noPendingBreakfast: 'No breakfasts pending verification for this room',
    verificationCountPositive: 'Verification quantity must be greater than 0',
    verificationCountExceedsPending: 'Verification quantity cannot exceed pending breakfasts',
    verificationSuccess: 'Verified successfully',
  },
  buyBreakfastDialog: {
    title: 'Buy breakfast',
    entryAccount: 'Posting account',
    count: 'Quantity',
    totalAmount: 'Total amount',
    payVerificationCode: 'Payment verification code',
    positiveMoney: 'Enter an amount greater than 0 with up to 2 decimal places',
    positiveInteger: 'Enter an integer greater than 0',
    priceRequired: 'Enter unit price',
    countRequired: 'Enter quantity',
    roomOrderNoMissing: 'Room order number not found. Breakfast cannot be purchased.',
    selectAccountSet: 'Select account set',
    onlinePaymentFailed: 'Online payment failed',
    paymentIncomplete: 'Payment is incomplete. Breakfast posting was not created.',
    buySuccess: 'Breakfast purchased successfully',
  },
  financeBreakfastVerificateDetail: {
    title: 'Breakfast verification detail report',
  },
  readDoorCardRoom: {
    lockNotConfigured: 'Door lock is not configured or not enabled',
    getLockInfoFailed: 'Failed to get door lock information',
    readCardTimeout: 'Card reading timed out. Please check the card reader.',
    emptyCard: 'This is a blank card. Please issue a card first.',
    notGuestCard: 'This card is not a guest card. Please issue it again.',
    readCardServiceFailed: 'Failed to read card. Please contact support to check whether the hardware service is available.',
    readCardFailed: 'Failed to read card. Please check the room card or card reader.',
    noRoomInfo: 'No room information was read',
    unsupportedLockReadMode: 'The current door lock card reading mode is not supported',
  },
  financePreauth: {
    authorizationStatus: 'Authorization status',
    authorizationDate: 'Authorization date',
    settlementDate: 'Settlement date',
    expirationDate: 'Expiration date',
    preAuthorizationStatement: 'Pre-authorization statement',
    settlementTime: 'Settlement time',
  },
  financeRedeemDetail: {
    dateType: 'Date type',
    writeOffDate: 'Write-off date',
    dateOfPosting: 'Date of Posting',
    dateOfEntry2: 'Date of entry',
    bookType: 'Book type',
    businessDayOfHangingAccount: 'Business day of hanging account',
    hangTheAccountOperator: 'Hang the account operator',
    theRoomNumberIsCharged: 'The room number is charged',
    writeOffTheAmountCredited: 'Write off the amount credited',
    writeOffTheEntryTime: 'Write off the entry time',
    writeOffTheAccountOperator: 'Write off the account operator',
    amountWrittenOff2: 'Amount written off',
    writeOffTime: 'Write-off time',
    writeOffTheOperator: 'Write off the operator',
    channelWriteOffDetailReport: 'Channel write-off detail report',
  },
  financeRushCash: {
    financialStatement: 'Financial statement',
    occurrenceTime: 'Occurrence time',
    debitStatement: 'Debit statement',
  },
  financeSellRank: {
    agreementUnitConsumptionRankingTable: 'Agreement unit consumption ranking table',
  },
  financeTodayGuestBalance: {
    roomFee3: 'Room fee',
    balanceSheetForGuestsInResidence: 'Balance sheet for guests in residence',
  },
  financeTransferCash: {
    turnOutOfRoom: 'Turn out of room',
    bookkeepingTime: 'Bookkeeping time',
    turnIntoARoom: 'Turn into a room',
    transferTime: 'Transfer time',
    transferStatement: 'Transfer statement',
  },
  financeZeroRoomFee: {
    zeroRoomRateReport: 'Zero room rate report',
  },
  incomeBaseprice: {
    totalRevenue: 'Total revenue',
    roomNight: 'Room night',
    storeRevenue: 'Store revenue',
    interstoreNight: 'Interstore night',
    directRevenuebasePrice: 'Direct revenue (base price)',
    straightInternight: 'Straight internight',
    miniProgramRevenuebasePrice: 'Mini program revenue (base price)',
    smallProgramNight: 'Small program night',
    xinmeituanDirectRevenuebasePrice: 'Xinmeituan direct revenue (base price)',
    newUnitedStatesGroupStraightInternight: 'New United States group straight internight',
    ctripDirectRevenuebasePrice: 'Ctrip Direct revenue (base price)',
    ctripDirectConnectionBetweenNight: 'Ctrip direct connection between night',
    directRevenuebasePrice2: 'Direct revenue (base price)',
    theSameJourneyDirectlyConnectedToTheNight: 'The same journey directly connected to the night',
    qunarDirectRevenuebasePrice: 'Qunar Direct Revenue (base price)',
    whereToGoStraightToTheNight: 'Where to go straight to the night',
    tiktokDirectRevenuebasePrice: 'Tiktok Direct Revenue (base price)',
    tiktokStraightBetweenNight: 'Tiktok straight between night',
    flyingPigDirectRevenuebasePrice: 'Flying pig direct revenue (base price)',
    flyingPigsStraightInternight: 'Flying pigs straight internight',
    baiduMapRevenuebasePrice: 'Baidu Map revenue (base price)',
    baiduMapNight: 'Baidu map night',
    jingdongDirectRevenuebasePrice: 'Jingdong Direct revenue (base price)',
    jingdongDirectConnectionBetweenNight: 'Jingdong direct connection between night',
    lightResidentialAndCommercialTravelRevenuebasePrice:
      'Light residential and commercial travel revenue (base price)',
    lightStayBusinessNights: 'Light stay business nights',
    lightHomeDistributionRevenuebasePrice: 'Light home distribution revenue (base price)',
    lightNightInTheDistributionRoom: 'Light night in the distribution room',
    storeAdr: 'Store ADR',
    usGroupEbRevenue: 'Us group EB revenue',
    usGroupEbNight: 'Us group EB night',
    meituanEbadr: 'Meituan EBADR',
    ctripEbRevenue: 'Ctrip EB revenue',
    ctripEbNight: 'Ctrip EB night',
    ctripEbadr: 'Ctrip EBADR',
    flyingPigEbRevenue: 'Flying pig EB revenue',
    flyingPigEbNight: 'Flying pig EB night',
    ebadrTheFlyingPig: 'EBADR the Flying Pig',
    douyinGroupPurchaseEbRevenue: 'Douyin group purchase EB revenue',
    douyinGroupPurchaseEbNight: 'Douyin group purchase EB night',
    douyinGroupPurchaseEbadr: 'Douyin group purchase EBADR',
    directAdrbasePrice: 'Direct ADR (base price)',
    miniProgramAdrbasePrice: 'Mini program ADR (base price)',
    newMeituanDirectAdrbasePrice: 'New Meituan Direct ADR (base price)',
    directRouteAdrbasePrice: 'Direct Route ADR (base price)',
    sameRouteDirectAdrbasePrice: 'Same route direct ADR (base price)',
    whereToDirectAdrbasePrice: 'Where to Direct ADR (base price)',
    tiktokDirectAdrbasePrice: 'Tiktok Direct ADR (Base price)',
    flyingPigDirectAdrbasePrice: 'Flying Pig Direct ADR (Base price)',
    baiduMapAdrbasePrice: 'Baidu Map ADR (base price)',
    jingdongDirectLinkAdrbasePrice: 'Jingdong Direct Link ADR (base price)',
    lightResidentialAndBusinessAdrbasePrice: 'Light Residential and Business ADR (Base price)',
    lightLiveDistributionAdrbasePrice: 'Light Live Distribution ADR (Base price)',
  },
  incomeExpense: {
    consumptionAccountStatisticsReport: 'Consumption account statistics report',
    accountId: 'Account ID',
    roomNumbername: 'Room number/name',
  },
  incomeGuestSourceDetail: {
    selfUseRoom: 'House Use Room',
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'Room night data is based on the queried business day statistics',
    calculationMode: 'Calculation',
    guestCheckInDetailsReport: 'Guest check-in details report',
    freeRoom: 'Free room',
    teamRoom: 'Team room',
    singleRoom: 'Single room',
    roomRate2: 'Room rate',
  },
  incomeHandleover: {
    shiftSummaryStatisticsReport: 'Shift summary statistics report',
    income: 'Income',
    disburse: 'Disburse',
    totalAmount: 'Total amount',
    shiftSummaryReport: 'Shift summary report',
  },
  incomeManageSingle: {
    category: 'Category',
    today: 'Today',
    accumulatedThisMonth: 'Accumulated this month',
    lastMonthCumulative: 'Last month cumulative',
    monthlyGrowthRate: 'Monthly growth rate',
    currentYearAccumulation: 'Current year accumulation',
    accumulatedInTheSamePeriodOfLastYear: 'Last year same period (Acc.)',
    annualGrowthRate: 'Annual growth rate',
    operatingStatementsingleDay: 'Operating Statement (Single day)',
    operatingStatementOneDayxlsx: 'Operating statement One day.xlsx',
    orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights:
      'Order source bed nights: include free rooms and self - used room nights',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'Rental rate (excluding self - used rooms and free rooms) = rented bed nights (excluding self - used rooms and free rooms) / total number of rooms',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'Total room fee income (including commission): excluding free rooms and self - used rooms',
    youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission:
      "You have not opened the 'customer check-in details' report viewing permission",
    averageRoomRate:
      'Average room rate (excluding self-use rooms and free rooms) = Total room revenue / Rented room nights (excluding self-use rooms and free rooms)',
    revparFormula: 'RevPAR = Total room revenue / Total number of rooms',
    totalRevenueFormula:
      'Total operating revenue = Total room revenue + All other income (including commission, excluding membership recharge)',
  },
  incomeManageTotal: {
    generalLedger: 'General ledger',
    totalAverageRoomRateyuan: 'Total Average Room rate ',
    rentalTotalRoomNightroom: 'Rental Total Room Night (Room)',
    fullDayRoomNightroom: 'Full Day Room Night (Room)',
    longBagRoomNightroom: 'Long Bag Room Night (Room)',
    hourRoomNightroom: 'Hour Room Night (Room)',
    teamRoomNightroom: 'Team Room Night (Room)',
    freeRoomNightroom: 'Free Room Night (Room)',
    privateRoomNightroom: 'Private Room night (Room)',
    totalRoomRateyuan: 'Total room Rate ',
    smallCommoditiesyuan: 'Small commodities ',
    mealFeeyuan: 'Meal fee ',
    serviceChargeyuan: 'Service charge ',
    membershipFeermb: 'Membership Fee ',
    otherExpensesyuan: 'Other expenses ',
    totalRevenue: 'Total revenue ',
    totalRevenueWithTax: 'Total Revenue (Tax Included)',
    roomNightsroom: 'Room nights (room)',
    averageRoomRateyuan: 'Average room rate ',
    totalRoomRateyuan2: 'Total room rate ',
    operatingStatementcumulative: 'Operating statement (cumulative)',
    theQueryTimeRangeCannotBeLongerThanOneYear:
      'The query time range cannot be longer than one year',
    totalOccupancyRate: 'Total occupancy rate(%)',
    fullDayOccupancyRate: 'Full day occupancy rate(%)',
    hourlyOccupancyRate: 'Hourly occupancy rate(%)',
    lettingRate: 'Letting rate(%)',
    internightRatio: 'Internight rate(%)',
    totalRevpar: 'Total REVPAR',
    cumulativeOperatingStatementxls: 'Cumulative operating statement.xls',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'Rental rate (excluding self - used rooms and free rooms) = rented bed nights (excluding self - used rooms and free rooms) / total number of rooms',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'Total room fee income (including commission): excluding free rooms and self - used rooms',
    averageRoomRate:
      'Average room rate (excluding self-use rooms and free rooms) = Total room revenue / Rented room nights (excluding self-use rooms and free rooms)',
    totalRevenueFormula:
      'Total operating revenue = Total room revenue + All other income (including commission, excluding membership recharge)',
  },
  incomeOperatingIncome: {
    yesterdaysBalance: "Yesterday's balance",
    todaysBalance: "Today's balance",
    statisticalStatementOfBusinessIncome: 'Statistical statement of business income',
    totalconsumptionTotalPaymentTotal: 'Total=consumption total-payment total',
    yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal:
      "Yesterday's balance=the hotel's cumulative consumption total from the previous business day minus payment total",
    todaysBalancetotalyesterdaysBalance: "Today's balance=total+yesterday's balance",
  },
  incomeOverduty: {
    category: 'Category',
    firstLevelSubject: 'First-level subject',
    description: 'Description',
    shiftStatisticsReport: 'Shift statistics report',
  },
  incomePayExpense: {
    cashPaymentStatement3: 'Cash payment statement',
    abstract: 'Abstract',
  },
  incomePayment: {
    paymentAccountStatisticsReport: 'Payment account statistics report',
    submitted: 'Submitted',
    earlyMorningWatch: 'Early morning watch',
    roomNumberName: 'Room number. - Name',
    dateRangeCannotExceedThreeMonths: 'The query date range cannot exceed 3 months',
  },
  incomeRoomTypeReport: {
    totalRoomRate: 'Total room rate',
    numberOfOutages: 'Number of outages',
    numberOfNightsForRent: 'Number of nights for rent',
    roomTypeReport: 'Room type report',
    theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime:
      'The end time of the business day cannot exceed the current time',
    theSelectionPeriodCannotBeLongerThan31Days:
      'The selection period cannot be longer than 31 days',
  },
  incomeSellercount: {
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'Room night data is based on the queried business day statistics',
    calculationMode: 'Calculation',
    salesPerformanceStatement: 'Sales performance statement',
    roomFee3: 'Room fee',
  },
  incomeSmallwaredetail: {
    detailedSalesReportOfSmallGoods: 'Detailed sales report of small goods',
  },
  incomeSmallwaresummary: {
    summaryReportOfSmallCommoditySales: 'Summary report of small commodity sales',
    averageUnitPrice: 'Average unit price',
  },
  kanbanIndex: {
    yesterday: 'Yesterday',
    last7Days: 'Last 7 days',
    lastWeek: 'Last week',
    last30Days: 'Last 30 days',
    lastMonth: 'Last month',
    managementProfile: 'Management profile',
    flowConversion: 'Flow conversion',
    serviceIndicator: 'Service indicator',
    competitiveCircleAnalysis: 'Competitive circle analysis',
    writeAReport: 'Write a report',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'The time dimension is consistent with the screening date, and the booking amount is calculated according to the actual amount paid by the guest',
    operationPersonnelManagementOverviewSuggestions2:
      'Operation personnel management overview suggestions',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'The time dimension is consistent with the screening date, and contains the data summary of all platforms of Meituan, Ctrip and Feizhu',
    operationPersonnelFlowConversionSuggestions2: 'Operation personnel flow conversion suggestions',
    theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'The time dimension is the end date and the day before the start date of the current selected date, including the data summary of all platforms of Meituan, Ctrip and Feizhu',
    operationPersonnelServiceIndicatorsSuggestions2:
      'Operation personnel service indicators suggestions',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip:
      'The time dimension is consistent with the screening date, and contains the data summary of all platforms of Meituan and Ctrip',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'Operational personnel competition circle analysis and suggestions',
    amountOfExposure: 'Amount of exposure',
    pageView: 'Page view',
    orderQuantity: 'Order quantity',
    myExposureCount: 'My exposure count',
    numberOfPeopleExposedInThePreviousIssue: 'Number of people exposed in the previous issue',
    myExposureConversionRate2: 'My exposure conversion rate',
    previousExposureConversionRate2: 'Previous exposure conversion rate',
    myNumberOfViewers: 'My number of viewers',
    numberOfVisitorsInTheLastIssue: 'Number of visitors in the last issue',
    myConversionRate2: 'My conversion rate',
    conversionRateOfLastPeriodTransaction2: 'Conversion rate of last period transaction',
    paymentOrderNumber: 'Payment order number',
    myPaymentOrderNumber: 'My payment order number',
    previousPaymentOrderNumber: 'Previous payment order number',
  },
  kanbanReportManage: {
    reportTitle: 'Report title',
    reportWriter: 'Report writer',
    reportDate: 'Report date',
    reportNumber: 'Report number',
    draft: 'Draft',
    haveReleased: 'Have released',
    reportTime: 'Report time',
    exportDaily: 'Export daily',
  },
  kanbanSeeKanban: {
    dataBoard: 'Data Board',
    managementProfile: 'Management profile',
    operationPersonnelManagementOverviewSuggestions2:
      'Operation personnel management overview suggestions',
    flowConversion: 'Flow conversion',
    operationPersonnelFlowConversionSuggestions2: 'Operation personnel flow conversion suggestions',
    serviceIndicator: 'Service indicator',
    operationPersonnelServiceIndicatorsSuggestions2:
      'Operation personnel service indicators suggestions',
    competitiveCircleAnalysis: 'Competitive circle analysis',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'Operational personnel competition circle analysis and suggestions',
    theProportionOfSalesAmount: 'The proportion of sales amount',
    salesRoomNightProportion: 'Sales room night proportion',
    noProposal: 'No proposal',
  },
  componentsDataReport: {
    compose: 'Compose',
    dataReport: 'Data report',
    reportType: 'Report type',
    pleaseSelectAReportType: 'Select a report type',
    dailyOperationReport: 'Daily operation report',
    weeklyOperationsReport: 'Weekly operations report',
    monthlyOperatingReport: 'Monthly operating report',
    runCustomReports: 'Run custom reports',
    reportTitle: 'Report title',
    analysisDate: 'Analysis date',
    businessDataAnalysisDimension: 'Business data analysis dimension',
    businessAnalysisAndSuggestion: 'Business analysis and suggestion',
    trafficAnalysisSuggestion: 'Traffic analysis suggestion',
    serviceIndicatorSuggestion: 'Service indicator suggestion',
    competitiveCircleAnalysisSuggestion: 'Competitive circle analysis suggestion',
    previewReport: 'Preview report',
    saveReport: 'Save report',
    saveReleaseReport: 'Save release report',
    pleaseEnterTheTitleOfTheReport: 'Please enter the title of the report',
    pleaseEnterBusinessAnalysisSuggestions: 'Please enter business analysis suggestions',
    pleaseEnterTrafficAnalysisSuggestions: 'Please enter traffic analysis suggestions',
    pleaseEnterTheServiceIndicatorSuggestion: 'Please enter the service indicator suggestion',
    pleaseEnterTheCompetitionCircleAnalysisSuggestion:
      'Please enter the competition circle analysis suggestion',
  },
  componentsFlowLine: {
    myExposureConversionRate2: 'My exposure conversion rate',
    previousExposureConversionRate2: 'Previous exposure conversion rate',
    myConversionRate2: 'My conversion rate',
    conversionRateOfLastPeriodTransaction2: 'Conversion rate of last period transaction',
    exposureToViewConversionRate: 'Exposure to view conversion rate',
    browseToTheConversionRateOfTheTransaction: 'Browse to the conversion rate of the transaction',
  },
  componentsRatioPieChart: {
    directConnection3: 'Direct connection',
  },
  competeCChannelData: {
    lostOrders: 'Lost orders',
    single: 'Single',
    numberOfLostNights: 'Number of lost nights',
    lossAmount: 'Loss amount',
    distanceFromMe: 'Distance from me',
    mark: 'Mark',
    startingPrice: 'Starting price',
    theProportionOfLostOrders: 'The proportion of lost orders',
    drainType: 'Drain type',
    orderConversionRate: 'Order conversion rate',
    viewTheProportionOfUsers: 'View the proportion of users',
    finalPurchaseRatio: 'Final purchase ratio',
  },
  flowFChart: {
    browseToTheConversionRateOfTheTransaction: 'Browse to the conversion rate of the transaction',
    exposureToViewConversionRate: 'Exposure to view conversion rate',
  },
  flowFTable: {
    myHotel: 'My hotel',
    monthOnMonth: 'Month-on-month',
    onlinePaymentSingular: 'Online payment singular',
    single: 'Single',
  },
  flowFlowTable: {
    payForOrderQuantity: 'Pay for order quantity',
    exposureConversionRate: 'Exposure conversion rate',
    transactionConversionRate: 'Transaction conversion rate',
  },
  reportManageLog: {
    dataReportOperationLogs: 'Data report operation logs',
    logNumber: 'Log number',
    operationName: 'Operation name',
  },
  serveindexServeAnnularChart: {
    scoreDistributionGraph: 'Score distribution graph',
    article: 'Article',
    numberOfCommentsWithChart: 'Number of comments with chart',
    newBadReviewsThisPeriod: '条  New bad reviews this period: {num}条',
    unrepliedBadReviews: '  Unreplied bad reviews: {num}条',
  },
  serveindexServeRadarChart: {
    radarMap: 'Radar map',
  },
  serveindexServelist: {
    basicScore: 'Basic score',
    awardPoints: 'Award points',
    penaltyPoint: 'Penalty point',
  },
  situationSChannelTable: {
    salesNight: 'Sales night',
    averageSalesRate: 'Average sales rate',
    consumptionNight: 'Consumption night',
    averageHousePriceOfConsumption: 'Average house price of consumption',
    cancelNight: 'Cancel night',
    cancellationRate: 'Cancellation rate',
    noSingleRoomNights: 'No single room nights',
    rejectRate: 'Reject Rate',
    onlinePermeability: 'Online permeability',
    channelOnlineStatus: 'Channel online status',
    lightHoldTheDirectConnection: 'Light hold the direct connection',
  },
  situationSGrid: {
    onAYearOnYearBasis: 'On a year-on-year basis',
    chainRatio: 'Chain ratio',
    cancellationRate: 'Cancellation rate',
    rejectRate: 'Reject Rate',
    theBookingAmountIncludesCancelledAndRejectedOrders:
      'The booking amount includes cancelled and rejected orders',
    reservationAmountCancelAndRejectOrders: 'Reservation amount Cancel and reject orders',
    accessSource: 'Access source',
    onlineChannelConsumptionBedNightstotalAvailableInventory:
      'Online channel consumption bed nights/total available inventory',
    advanceBookingBedNightstotalSalesBedNights: 'Advance booking bed nights/total sales bed nights',
    cancelBedNightssalesBedNights: 'Cancel bed nights/sales bed nights',
    rejectBedNightssalesBedNights: 'Reject bed nights/sales bed nights',
  },
  situationSalePieChart: {
    salesRoomNightProportion: 'Sales room night proportion',
    theProportionOfSalesAmount: 'The proportion of sales amount',
  },
  orderDiscontinuedrooms: {
    operationalDowntime: 'Operational downtime',
    disableStartEndTime: 'Disable start end time',
    releaseTime2: 'Release time',
    inactiveRoomReport: 'Inactive room report',
    deactivationOperator: 'Deactivation operator',
    releaseOperator: 'Release operator',
    normalExchange: 'Normal exchange',
    freeUpgrade: 'Free upgrade',
    chargeEscalation: 'Charge escalation',
  },
  orderGuest: {
    reportType2: 'Report type',
    sameDayCheckIn: 'Same-day check-in',
    sameDayCheckOut: 'Same-day check-out',
    dailyArrivalsAndDepartures: 'Daily arrivals and departures',
    contractCompany: 'Contract company',
    firstDayRate: 'First-day rate',
    nation2: 'Nation',
    roomListRemarks: 'Room list remarks',
    guestStatement: 'Guest statement',
  },
  orderRoomChange: {
    unterracedHouse: 'Unassigned Room',
    typeOfExchange: 'Type of exchange',
    normalExchange: 'Normal exchange',
    freeUpgrade: 'Free upgrade',
    chargeEscalation: 'Charge escalation',
    originalRoomNumber: 'Original room number',
    existingRoomNumber: 'Existing room number',
    currentHouseType: 'Current house type',
    roomChangeTime: 'Room change time',
    changeRoomsAfterCheckIn: 'Change rooms after check-in',
    originalRoomRate: 'Original room rate',
    spotRate: 'Spot rate',
  },
  checkInIndex: {
    viewListingDetails: 'View listing details',
    message: 'Message',
    individualStepIntoSuccess: 'Individual step into success',
    automaticallyRedirectsToListingDetails: 'Automatically redirects to listing details',
    successfulCodeScanning: 'Successful code scanning',
    thereIsNoCorrespondingProductForTheCurrentRoomType:
      'There is no corresponding product for the current room type',
    memberBalanceIs: 'Member balance is',
    pleaseSelectAnotherRecipient: 'Select another recipient',
  },
  checkInNewindex: {
    committedParameter: 'Committed parameter',
    individualStepIntoSuccess: 'Individual step into success',
  },
  checkInRoomerItem: {
    moreInformation: 'More information',
    number: 'Number',
  },
  componentsBookertypesearch: {
    pleaseEnterTheMemberInformationYouWantToQuery:
      'Please enter the member information you want to query',
    enterTheInformationAboutTheProtocolUnitToBeQueried:
      'Enter the information about the protocol unit to be queried',
  },
  componentsDepositsection: {
    selectPaymentMethod: 'Select payment method',
  },
  componentsOpenpagetemplate: {
    conditionOfTheHouse2: 'Room Status',
  },
  componentsProductsection: {
    noProductAvailableOnBookingDateForThisRoomType:
      'No product available on booking date for this room type',
  },
  componentsRoomerItem: {
    moreInformation: 'More information',
    genderBirthday: 'Gender - Birthday',
    nationalityNationality: 'Nationality - nationality',
    pleaseEnterTheFullAddress2: 'Please enter the full address',
    validityPeriod: 'Validity period',
  },
  utilsLehuimixin: {
    viewListingDetails: 'View listing details',
    automaticallyRedirectsToListingDetails: 'Automatically redirects to listing details',
    successfulCodeScanning: 'Successful code scanning',
    callbackRoute: 'Callback route',
    checkInSuccessful: 'Check-in successful',
    listingDetails: 'Listing Details',
    orderDetails: 'Order Details',
  },
  utilsUtils: {
    noProductAvailableOnBookingDateForThisRoomType:
      'No product available on booking date for this room type',
    thisRoomTypeIsSoldOutWithinTheBookingDate: 'This room type is sold out within the booking date',
    noPriceIsSetForThisRoomTypeDuringTheBookingDate:
      'No price is set for this room type during the booking date',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'Member balance is insufficient, please choose another payment method',
  },
  componentsAuthcode: {
    laterOn: 'Later on',
    verificationCodeSentSuccessfullyPleaseNoteThatCheck:
      'Verification code sent successfully, please note that check',
  },
  componentsBookingcommonmixin: {
    reset: 'Reset',
  },
  componentsBookingmixin: {
    nineHours: 'Nine hours',
    tenHours: 'Ten hours',
    elevenHours: 'Eleven hours',
    twelveHours: 'Twelve hours',
    hourStore: 'Hour - Store',
    noRoomTypesAvailable: 'No room types available',
    houseList: 'House list',
    totalPrice: 'Total price',
  },
  componentsLimitinput: {
    insufficientStock: 'Insufficient stock',
  },
  componentsMembersearch: {
    memberInformationDoesNotExistOrHasBeenDisabled:
      'Member information does not exist or has been disabled',
    pleaseEnterTheMemberInformationYouWantToQuery3:
      'Please enter the member information you want to query',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'Member balance is insufficient, please choose another payment method',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed:
      "The member's mobile phone number is incorrect, and the stored value payment cannot be used",
    memberNamephoneNumbermembershipNumber: 'Member name/phone number/membership number',
  },
  componentsPaytip: {
    memberPaymentFailure: 'Member payment failure',
    pleaseReEnterTheAccount: 'Please re-enter the account',
  },
  futureIndex: {
    roomTypeSummary: 'Room Type Summary',
    roomDetail: 'Room Detail',
  },
  futureSummary: {
    soldNumberavailableNumberoverSoldNumberdisabledNumber:
      'Sold number/available number (over - sold number)/disabled number',
    totalNumberOfRoomsPhysicalTotalNumberOfRooms:
      'Total number of rooms: physical total number of rooms',
    availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber:
      'Available number: total number of rooms - sold number - disabled number + full - day room over - sold number',
    disabledNumberNumberOfDisabledRoomsInTheHotel:
      'Disabled number: number of disabled rooms in the hotel',
    soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom:
      "Sold number: rooms booked on the day + rooms currently occupied on the day without today's departure and clock room",
  },
  groupbookingIndex: {
    discountPricePlaceholder: 'Please enter the discounted price',
    searchMemberPlaceholder: 'Please enter member name or phone number',
    remarkPlaceholder: 'Please enter remarks',
    pleaseEnterTeamName: 'Please enter the team name',
    memberBalanceNotEnough: 'Member balance is {balance} , please select another payment method',
    bookingRoomCannotBeZero: 'The number of booked rooms cannot be 0',
    roomTypeStockNotEnough: ' room type stock is insufficient',
    pleaseEnterContractNo: 'Please enter contract number',
    pleaseEnterPhone: 'Please enter phone number',
    groupBooking: 'Group booking',
    contractNumber: 'Contract number',
    teamBookingSuccessful: 'Team booking successful',
  },
  longbookingIndex: {
    singleRoom: 'Single room',
  },
  longbookingProductionlist: {
    houseList: 'House list',
    inAddition: 'In addition',
  },
  onlinedataIndex: {
    chainRatio: 'Chain ratio',
    onAYearOnYearBasis: 'On a year-on-year basis',
    theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel:
      'The direct connection channel has not been opened. In order to prevent the loss of orders, please contact the operation manager as soon as possible to open the direct connection channel',
    relevance: 'Relevance',
    onlineRevenue: 'Online revenue',
    onlineNight: 'Online night',
    channelProportion: 'Channel proportion',
    channelOnlineStatus: 'Channel online status',
    directConnection3: 'Direct connection',
    temporarilyWithoutAuthority: 'Temporarily without authority',
    totalOnlineRevenue: 'Total online revenue',
    onlineTotalNight: 'Online total night',
    online: 'Online',
    thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement:
      'This EB account is not bound, please bind EB account in EB account management',
  },
  realTimeIndex: {
    allBuildings: 'All Buildings',
    allFloors: 'All Floors',
    depositShort: 'Dep',
    balanceShort: 'Bal',
    preAuthShort: 'Pre-auth',
    totalShort: 'Total',
    roomRateShort: 'Rate',
    powerOff: 'Power Off',
    powerOn: 'Power On',
    new2: 'NEW',
    al: 'AL',
    openChannelsForDirectConnection: 'Open channels for direct connection',
    createRoomType: 'Create room type',
    createARoom: 'Create a room',
    renewalOrder2: 'Renewal order',
    roomChangeConfirmationForm3: 'Room change confirmation form',
    checkInSlip4: 'Check-in Slip',
    whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2:
      'When extending your stay, the room price displayed is for the first day of the extended stay. When checking out early or changing the expected departure time, the price displayed is for the last night.',
    friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3:
      'Friendly reminder: Please make sure to double - check all the details and then sign for confirmation. After changing rooms, remember to take your personal belongings from the original room.',
    continuationRoomsShowTheFirstDayPrice2: 'Continuation rooms show the first day price',
    friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3:
      "Friendly reminder: Please double - check all the details and sign for confirmation. Don't forget to take your personal belongings.",
    liveLightlyInTheDirectCamp: 'Live lightly in the direct camp',
    whereToConnectDirectly: 'Where to connect directly',
    baiduMap: 'Baidu map',
    jingdong: 'Jingdong',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'Flying pig credit live orders do not support joint housing',
    flyingPigCreditOrdersCanNotBeSustained2: 'Flying pig credit orders can not be sustained',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'It has passed the check-out date and cannot be extended',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'The current time has passed the check-out time, the room upgrade is not supported',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'The current time has passed 6:00 check-in date, the room upgrade is not supported',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'The current time has passed the check-out time, the room cannot be changed',
    successfulRoomExchange2: 'Successful room exchange',
    successfulDisposal: 'Successful disposal',
    cleanAndSuccessful: 'Clean and successful',
    deactivateSuccessfully: 'Deactivate successfully',
    temporaryPassword: 'Temporary password',
    thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse:
      'This password is valid for 30 minutes and expires immediately after use',
    quickSearch: 'Room number',
    batchModify: 'Bulk Update Room Status',
    ignore: 'Ignore',
    goAndOperate: 'Go and operate',
    bookingInfo: 'Pending Arrival Booking Info',
    orderNo: 'Order No.',
    channelName: 'Channel Name',
    bookerName: 'Booker Name',
    arrivalTime: 'Arrival Time',
    roomRate: 'Room Rate',
  },
  realTimeServicemsg: {
    dateOfService: 'Date of service',
    applicationTime2: 'Application time',
    serviceType: 'Service type',
    serviceTime: 'Service time',
    serviceSuccess: 'Service success',
    serviceFailure: 'Service failure',
    serviceCompletion: 'Service completion',
    theRoomRequestHasBeenServiced: 'The room request has been serviced',
  },
  componentsCommon: {
    roomBalance: 'Room balance',
    depositWithPreAuth: 'Deposit (incl. Pre-authorization)',
    madeCardCount: 'Cards Made',
    stayOver: 'Stay over',
    checkOut4: 'Check out',
    temporaryPassword: 'Temporary password',
    sendPassword: 'Send Password',
    muck: 'Muck',
    setAside: 'Set aside',
    deactivate: 'Deactivate',
    faceEast: 'Face east',
    faceWest: 'Face west',
    faceSouth: 'Face south',
    faceNorth: 'Face north',
    decorativeFalseWindow: 'Decorative false window',
    stayAwayFromElevators: 'Stay away from elevators',
    nearTheStairs: 'Near the stairs',
    closeToTheRoad: 'Close to the road',
    windowWall: 'Window wall',
    bedTypeDescription: 'Bed type description',
    guestControl: 'guestControl',
    latestCheckIn: 'Latest Stay',
    noHistoricalCheckInInfo: 'No previous stay information is available for this room',
    temporaryMakeCard: 'Temporary Make Card',
  },
  componentsEmpty: {
    searchNull: 'Search null',
  },
  componentsGrouphandle: {
    batchModify: 'Bulk Update Room Status',
    pleaseSelectAnActiveArea: 'Select an active area',
    selectStartDate: 'Select start date',
    selectEndDate: 'Select end date',
    emptyCleanToEmptyDirty: 'Vacant Clean to Vacant Dirty',
    emptyDirtyToEmptyClean: 'Vacant Dirty to Vacant Clean',
    stayCleanAndTurnDirty: 'Occupied Clean to Occupied Dirty',
    stayDirtyAndTurnClean: 'Occupied Dirty to Occupied Clean',
    batchOutage: 'Bulk Out of Order',
    batchDeactivation: 'Bulk Reactivate',
    pleaseEnterTheStartTime: 'Please enter the start time',
    pleaseEnterTheEndTime: 'Please enter the end time',
    pleaseSelectTheRoomForBatchOperation: 'Select the room for batch operation',
    batchOperationSuccessful: 'Batch operation successful',
    whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms:
      'Whether to confirm the deactivation, Bulk Reactivate includes (row) rooms',
  },
  componentsHourcheckinconfirm: {
    checkInTimeConfirmation: 'Check-in time confirmation',
    continuousHousing: 'Continuous housing',
    theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime:
      'The arrival time has been exceeded, please confirm the guest check-in time',
    itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing:
      'It has been occupied, please manually arrange the room after further processing',
  },
  componentsOperationlog: {
    operationRecord: 'Operation record',
  },
  componentsStopservice: {
    successfulDeactivation: 'Successful deactivation',
    selectStartDate: 'Select start date',
    selectEndDate: 'Select end date',
    noteAtLeast3Words: 'Note at least 3 words',
    startMustAfterNow: 'The start date must be greater than or equal to the current date',
    endMustAfterStart: 'The end date must be later than the start date',

  },
  serviceHandle: {
    accept: 'Accept',
    turnDown2: 'Turn down',
    serviceProcessing: 'Service processing',
    whetherToProcess: 'Whether to process',
    reasonForRefusal: 'Reason for refusal',
    pleaseEnterTheReasonForTheRejection: 'Please enter the reason for the rejection',
    accepted: 'Accepted',
    denialOfService: 'Denial of service',
  },
  sankebookingArrangeroom: {
    noRoomAvailablePleaseConfirmAndTryAgain: 'No room available, please confirm and try again',
    upgradeNumberOfRooms: 'Upgrade number of rooms',
    pleaseEnterRoomChangeRemarks: 'Please enter room change remarks',
    conditionOfTheHouse2: 'Room Status',
    pleaseSelectTheRoomYouWantToUpgrade: 'Please select the room you want to upgrade',
    thereAreCurrentlyNoRoomTypesAvailableForUpgrade:
      'There are currently no room types available for upgrade',
    theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms:
      'The number of row rooms cannot be greater than the number of reserved rooms',
    thisRoomTypeIsNotOnline: 'This room type is not online',
    hourProductPleaseSelectAnotherRoomType: 'Hour product, please select another room type',
    thisRoomType: 'This room type',
    productsAreSoldOutPleaseChooseAnotherRoomType:
      'Products are sold out, please choose another room type',
    noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType:
      'No price is set for the hour product, please select another room type',
    yourUpgradedRoomTypeIsAllThatIsLeft: 'Your upgraded room type is all that is left',
    pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades:
      'Please change to another room type or reduce the number of room upgrades',
  },
  sankebookingIndex: {
    channelOrderRoomType: 'Channel order room type',
    operationPrompt: 'Operation prompt',
    furtherBooking: 'Further booking',
    thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat:
      'This order has already been booked, please do not repeat',
    floorPriceModel: 'Floor price model',
    sellingPriceModel: 'Selling price model',
    theNumberOfReservedRoomsCannotBe: 'The number of reserved rooms cannot be',
    reservationNumber: 'Reservation number',
    inAddition: 'In addition',
    useEbInformation: 'Use eb information',
    useEbOrderInformation: 'Use EB order information',
    theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking:
      'The number of booking rooms is inconsistent with the number of channel orders, whether to continue booking',
    thisOrderCannotBeBooked: 'This order cannot be booked',
  },
  activityData: {
    dailySpecial: 'Daily special',
    keepPricesLow: 'Keep prices low',
    motivateUsersToBuyMore: 'Motivate users to buy more',
    earlyRush: 'Early rush',
  },
  activitySelfHelp: {
    selfHelpPromotionDescription: 'Self-help promotion description',
    promotionalOffersAreAllBorneByTheMerchantDifferentChannelsOfSettlementMethodsAreDifferent:
      'Promotional offers are all borne by the merchant, different channels of settlement methods are different',
    inCaseOfFalsePromotionTheConsequencesShallBeBorneByTheMerchant:
      'In case of false promotion, the consequences shall be borne by the merchant',
    onceCreatedThePromotionWillTakeEffectAcrossAllChannels:
      'Once created, the promotion will take effect across all channels',
    promotionType: 'Promotion type',
    promotionalProduct: 'Promotional product',
    effectiveChannel: 'Effective channel',
    promotionStatus: 'Promotion status',
    noRegistrationIsAvailable: 'No registration is available',
    dailySpecial: 'Daily special',
    tonightSpecial: 'Tonight special',
    firstStayDiscount: 'First-stay discount',
    travelSpecial: 'Travel special',
    festivalCoverage: 'Festival coverage',
    studentOnly: 'Student only',
    batchOffLine: 'Batch off line',
    thereAreNoRegisteredActivities: 'There are no registered activities',
    thereAreNoCanceledEvents: 'There are no canceled events',
    pleaseSelectThePostPromotionOperationBatchOfflineFeature:
      'Please select the post-promotion operation Batch offline feature',
    massMerchantsSelfPromotionOffline: 'Mass merchants self-promotion offline',
    allChannels: 'All channels',
  },
  componentsActivitydetail: {
    discount: 'Discount',
    promotionInfo:
      'The activity will take effect immediately after successful submission. During the activity, hotels can modify or withdraw, but completed orders will follow the existing rules. The original price of the room types participating in the activity must not be higher than the prices on other channels, or they may not be displayed.',
    offerDetails:
      'The price of the room type participating in the promotion should not be higher than other channels to gain more exposure opportunities. It is recommended that merchants involve the lowest-priced room types in the activity to gain more traffic entry exposure opportunities.',
    backToActivityList: 'Back to activity list',
    quantitySold: 'Quantity sold',
    sellLowEachNight: 'Sell low each night',
    pleaseSelectAnEventProduct: 'Select an event product',
    noRoomTypeInformationAvailable: 'No room type information available',
    productsHaveBeenSelectedForTheEvent: 'Products have been selected for the event',
    selectOffer: 'Select offer',
    iHaveReadAndAgree: 'I have read and agree',
    activityRelatedClause: 'Activity related clause',
    selectedOffer: 'Selected offer',
    signUpNow: 'Sign up now',
    activeTime: 'Active time',
    activityProfile: 'Activity profile',
    activityRequirement: 'Activity requirement',
    preferentialDetails: 'Preferential details',
    specialSpecification: 'Special specification',
    entryAndExitRules: 'Entry and exit rules',
    costAttribution: 'Cost attribution',
    midAutumnFestival: 'Mid-Autumn Festival',
    specialProduct: 'Special product',
    areYouSureYouWantToCommitYourChanges: 'Are you sure you want to commit your changes',
    pleaseSelectTheRoomTypeToParticipateInTheEvent:
      'Please select the room type to participate in the event',
    pleaseSelectDiscount: 'Please select discount',
    pleaseReadAndAgreeToTheTermsOfTheEvent: 'Please read and agree to the terms of the event',
    successfulRegistration: 'Successful registration',
  },
  componentsSelfactivitylist: {
    expired: 'Expired',
    copyPromotion: 'Copy promotion',
    promotionType: 'Promotion type',
    marginOfPreference: 'Margin of preference',
    eventDate: 'Event date',
    beOffline: 'Be offline',
    merchantsPushThemselvesOffline: 'Merchants push themselves offline',
    offlineSuccess: 'Offline success',
    areYouSureYouWantToDeleteTheActivity: 'Are you sure you want to delete the activity',
  },
  componentsActivitycontent: {
    activityRequirement: 'Activity requirement',
    quantitySold: 'Quantity sold',
    signUpNow: 'Sign up now',
    cancelRegistration: 'Cancel registration',
    reEnroll: 'Re-enroll',
    areYouSureYouWantToCancelYourRegistration: 'Are you sure you want to cancel your registration',
  },
  componentsSelfactivitylog: {
    inquire: 'Inquire',
    back: 'Back',
  },
  componentsDialog: {
    rule: 'Rule',
    new: 'New',
    content: 'Content',
    activityRelatedClause: 'Activity related clause',
  },
  componentsSelfactivitydetail: {
    dateRange: 'The next two weeks',
    timePeriod: 'The past two weeks',
    discountInfo:
      'Enabling automatic extension will automatically extend the promotion 30 days before the end date, creating a new promotion. If the promotion end date is less than 30 days from the current date, the promotion will be extended to 30 days.',
    chooseToParticipateInPromotionalProducts: 'Choose to participate in promotional products',
    noRoomTypeInformationAvailable: 'No room type information available',
    selectedProductsForPromotion: 'Selected products for promotion',
    selectTheChannelWhereThePromotionIsEffective:
      'Select the channel where the promotion is effective',
    allChannels: 'All channels',
    designatedChannel: 'Designated channel',
    noEffectiveChannelInformationIsAvailable: 'No effective channel information is available',
    youHaveSelectedTheChannelWhereThePromotionTakesEffect:
      'You have selected the channel where the promotion takes effect',
    activeConfiguration: 'Active configuration',
    setForAtLeast2Days: 'Set for at least 2 days',
    setThisParameterForAtLeast1Day: 'Set this parameter for at least 1 day',
    discount: 'Discount',
    theDiscountValueIsSetToAtLeast95Off: 'The discount value is set to at least 95% off',
    theMinimumAmountOfImmediateReductionIsSetAt5:
      'The minimum amount of immediate reduction is set at $5',
    immediateReductionPromotionIsNotEffectiveForCtrip:
      'Immediate reduction promotion is not effective for Ctrip',
    thePromotionIsValidOnlyOnCtrip: 'The promotion is valid only on Ctrip',
    thePromotionIsOnlyEffectiveOnCtripAndTongcheng:
      'The promotion is only effective on Ctrip and Tongcheng',
    link: 'Link',
    advanceBooking: 'Advance booking',
    preferentialMode: 'Preferential mode',
    firstStayDiscount: 'First-stay discount',
    automaticExtension: 'Automatic extension',
    saleTime: 'Sale time',
    theFollowingDay: 'The following day',
    theIntervalShallNotBeLessThan30Days: 'The interval shall not be less than 30 days',
    areYouSureYouWantToCommitYourChanges: 'Are you sure you want to commit your changes',
    pleaseSelectTheRoomTypeToParticipateInTheEvent:
      'Please select the room type to participate in the event',
    pleaseSelectAnEventCheckInDate: 'Please select an event check-in date',
    pleaseFillInTheDiscountAmount: 'Please fill in the discount amount',
    atLeast95OffUpTo30Off: 'At least 95% off, up to 30% off',
    theDiscountAmountIsAtLeast5AndUpTo500: 'The discount amount is at least $5 and up to $500',
    pleaseFillInTheNumberOfConsecutiveDays: 'Please fill in the number of consecutive days',
    theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days:
      'The number of consecutive days must be greater than or equal to 1 day and less than or equal to 10 days',
    pleaseFillInTheAdvanceBookingDays: 'Please fill in the advance booking days',
    pleaseFillInTheSaleTime: 'Please fill in the sale time',
    congratulationsOnYourPromotionCreation: 'Congratulations on your promotion creation',
    congratulationsOnYourSuccessfulCopyPromotion:
      'Congratulations on your successful copy promotion',
    back: 'Back',
  },
  componentsSelfactivitytemp: {
    createNow: 'Create now',
  },
  productOversaleSetting: {
    timePeriod: 'Time period',
    numberSold: 'Number sold',
    oversold: 'Oversold',
    oversoldQuantity: 'Oversold quantity',
    oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay:
      'Oversold cannot be greater than the remaining physical room capacity of the hotel on that day',
    oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay:
      'Oversold stock is activated when the actual physical stock of the room type is sold out for the day',
    pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout:
      'Please open the automatic overbooking setting in More - System Settings - Basic Settings - Direct connection order to avoid automatic rejection of overbooking order timeout',
    timeSelectionIsOutOfRange: 'Time selection is out of range',
    configurationSuccessful: 'Configuration successful',
    theSetOverbookingQuantityMustBeGreaterThanOrEqualTo:
      'The set overbooking quantity must be greater than or equal to',
  },
  productDelayprice: {
    holidayFactorRange:
      'The holiday factor can be a decimal between 1 and 5, with up to one decimal place.',
    holidayPricingRule:
      'After setting the holiday factor, the price for statutory holidays in mainland China will become a multiple of the regular daily price. For example, if the factor is 2 and the regular daily price is 100 , the system will automatically set the holiday price to 2 * 100 = 200 .',
    holidayFactor:
      'After setting the holiday factor, the price for statutory holidays in mainland China will become a multiple of the regular daily price.',
    priceCopy: 'Copy the price for 2 months',
    open: 'Open',
    deferredProduct: 'Deferred product',
    allDayRoomProducts: 'All day room products',
    deferralOnlyAppliesToProductsWithFullDayOccupancyType:
      'Deferral only applies to products with full-day occupancy type',
    priceExtensionTime: 'Price extension time',
    holidayCoefficient: 'Holiday coefficient',
    statutoryHolidayPricesAreWeekdays: 'Statutory holiday prices are weekdays',
    times: 'Times',
    automaticDeferralDescription: 'Automatic deferral description',
    theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem:
      'The system copies the price of the most recent week to a future date without a price, and dates that already have a price will not be overwritten by the system',
    thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken:
      'The price source of the automatic price extension is the price of the week before the automatic price extension date, in case of holidays, it is skipped and the price of the previous week is taken',
    turnOffAutomaticDeferral: 'Turn off automatic deferral',
  },
  productManageSetting: {
    advanceSale: 'Advance sale',
    needChannelConnection:
      'This product can only be created after enabling direct channel connection. Do you confirm to enable direct channel connection?',
    confirmChangeProductType:
      'Changing the product type will clear all product release channels and product rules. Do you confirm the operation?',
    limitSale: 'Limited Sale (rooms)',
    checkInDay: 'Check-in day',
    beforeCheckIn: 'Before check-in',
    atLatest: 'At latest',
    theHourlyIncreaseCannotBeGreaterThanThePrice:
      'The hourly increase cannot be greater than the price',
    physicalRoomType: 'Physical room type',
    earliestCheckInTime: 'Earliest check-in time',
    latestCheckOutTime: 'Latest check-out time',
    howLongNoAdditionalRoomChargeminutes: 'How long no additional room charge (minutes)',
    howLongIsTheFullDayRoomChargehours: 'How long is the full day room charge (hours)',
    cancelRule: 'Cancel rule',
    paymentPolicy: 'Payment policy',
    validForOnlineSalesOnly: 'Valid for online sales only',
    releaseChannel: 'Release channel',
    productRegulation: 'Product regulation',
    effectiveDate: 'Effective date',
    effectiveChannel: 'Effective channel',
    priceyuan: 'Price ',
    inputPrice: 'Input price',
    extraChargePerHourrmb: 'Extra charge per hour',
    forSaleOnly: 'For sale only',
    inputSpace: 'Input space',
    enjoyHotelStayLight: 'Enjoy Hotel Stay light',
    pleaseEnterTheNumberOfRooms: 'Please enter the number of rooms',
    additionalRule: 'Additional rule',
    cancel2: 'Cancel',
    found: 'Found',
    containing: 'Containing',
    early: 'Early',
    withoutBreakfast: 'Without breakfast',
    liveLightAndEnjoy: 'Live light and enjoy',
    pleaseEnterTheNumberOfRestrictedRooms: 'Please enter the number of restricted rooms',
    confirmToDeleteThisRule: 'Confirm to delete this rule',
    nonDeletable: 'Non-deletable',
    areYouSureToKeepItForSale: 'Are you sure to keep it for sale',
    areYouSureToCreateASale: 'Are you sure to create a sale',
    areYouSureYouWantToLeave: 'Are you sure you want to leave',
  },
  productPriceAudit: {
    houseType: 'House type',
    allRejectedSuccessfully: 'All rejected successfully',
    pass: 'Pass',
    turnDown: 'Turn down',
    revisedPrice: 'Revised price',
    rangeOfVariation: 'Range of variation',
    priceChanger: 'Price changer',
    auditor: 'Auditor',
    auditTime: 'Audit time',
    toBeReviewed: 'To be reviewed',
    passTheExamination: 'Pass the examination',
    expired2: 'Expired',
    successfulAudit: 'Successful audit',
    successfullyRejected: 'Successfully rejected',
  },
  productPriceCalendarNew: {
    open: 'Open',
    iss: '?',
    remainingContractReservedRooms: 'Remaining Contract Reserved Rooms',
    roomsCannotBeLower: 'Rooms Cannot BeLower',
    Thenumberofremainingcontractreservedroomsforthisproduct:
      'The number of remaining contract reserved rooms for this product is not 0. The application for room closure has been submitted, please wait for review',
    cannotCloseRoom:
      'The number of remaining contract reserved rooms for this product is not 0, and the room cannot be closed. Please contact the channel business manager to close the room.',
    confirmModification: 'Confirm modification',
    EBDeepOperationFailed: 'EB deep operation failed',
    syncCurrentPageEBData: 'Sync current page EB data',
    previousTwoWeeks: 'Previous two weeks',
    monday: 'Monday',
    nextTwoWeeks: 'Next two weeks',
    batchChangeInventory: 'Bulk Update Inventory',
    theReckoner: 'The Reckoner',
    preSaleFullDayRoom: 'Pre-sale full day room',
    presaleHourRoom: 'Presale hour room',
    underRevision: 'Under revision',
    viewIsNotSupported: 'View is not supported',
    dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute:
      'Data synchronization is underway. Please query the data again after 1 minute',
    lightLiveDistributionChannelPriceCannotBeSet:
      'Light live distribution channel price cannot be set',
    smallProgramChannelPriceCanBeAdjustedToUpdate:
      'Small program channel price can be adjusted to update',
    switchRoomSetup: 'Switch room setup',
    notModify: 'Not modify',
    roomSetting: 'Room setting',
    unlimitedSale: 'Unlimited sale',
    reserveRoomSetup: 'Reserve room setup',
    pleaseSelectRoomType: 'Room Type',
    pleaseSelectCheckInType: 'Check-In Type',
    notShowPreSaleProduct: 'NO',
    showPreSaleProduct: 'YES',
    notShowEbProduct: 'NO',
    showEbProduct: 'YES',
    allCheckInTypes: 'All',
    holiday: 'Holiday',
    packItAllUp: 'Coll',
    expandAll: 'Exp',
    date3: 'Date',
    extraChargeForMoreThan1Hour: 'Extra charge for more than 1 hour',
    theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms:
      'The number of reserved rooms can be increased, at most not more than the current inventory, at least not less than the number of remaining contracted reserved rooms',
    offLineProduct2: 'Off-line product',
    onlineProduct2: 'Online product',
    allProducts3: 'All products',
    showFloor: 'Show floor',
    theReservePriceIsNotDisplayed: 'The reserve price is not displayed',
    directChannel4: 'Direct channel',
    goWhereTheDirectConnection: 'Go where the direct connection',
    unboundChannel: 'Unbound channel',
    synchronizationFailure: 'Synchronization failure',
    theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate:
      'The start date of the last two weeks cannot be less than the current date',
    pleaseSelectTheCurrentStartEndDate: 'Please select the current start end date',
    pleaseEnterTheNumberOfReservedRooms: 'Please enter the number of reserved rooms',
    pleaseEnterLimitedNumber: 'Please enter limited number',
    maintenancePrice: 'Maintenance price',
    priceNotMaintained: 'Price not maintained',
    modifyProductPrice: 'Modify product price',
    modifyProductInventory: 'Modify product inventory',
    confirmOrNot: 'Confirm or not',
    theCurrentRateExceedsTheThresholdSetByTheHotel5:
      'The current rate exceeds the threshold set by the hotel',
    areYouSureYouWantToContinue: 'Are you sure you want to continue',
    definiteModification: 'Definite modification',
    ebChannel: 'Eb channel',
    ebMeituan: 'Eb meituan',
    ebCtrip: 'Eb ctrip',
    ebTiktok: 'Eb tiktok',
    ebBaiduMap: 'Eb baidu map',
    ebFeizhu: 'Eb feizhu',
  },
  productPriceCalendar: {
    is: '?',
    houseType: 'House type',
    allProducts: 'All products',
    onlineProduct: 'Online product',
    offLineProduct: 'Off-line product',
    theReckoner: 'The Reckoner',
    preSaleFullDayRoom: 'Pre-sale full day room',
    presaleHourRoom: 'Presale hour room',
    noDataAvailable: 'No data available',
    viewIsNotSupported: 'View is not supported',
    channelPricesCannotBeSet: 'Channel prices cannot be set',
    smallProgramChannelPriceCanBeAdjustedToUpdate:
      'Small program channel price can be adjusted to update',
    switchRoom: 'Switch room',
    limitedSalesNumber: 'Limited sales number',
    unlimitedSale: 'Unlimited sale',
    packUpAllProducts: 'Pack up all products',
    expandAllProducts: 'Expand all products',
    modifyProductPrice: 'Modify product price',
    extraChargeForMoreThan1Hour: 'Extra charge for more than 1 hour',
    enjoyHotelStayLight: 'Enjoy Hotel Stay light',
    pleaseEnterLimitedNumber: 'Please enter limited number',
    maintenancePrice: 'Maintenance price',
    priceNotMaintained: 'Price not maintained',
    cancel2: 'Cancel',
    amendTheSalesRestrictionRules: 'Amend the sales restriction rules',
    confirmOrNot: 'Confirm or not',
    successful: 'Successful',
    areYouSureYouWantToContinue: 'Are you sure you want to continue',
    theCurrentRateExceedsTheThresholdSetByTheHotel:
      'The current rate exceeds the threshold set by the hotel',
    thisPriceChangeIsBeyondThePresetRangePleaseContactTheStoreManagerForPriceChangeReview:
      'This price change is beyond the preset range, please contact the store manager for price change review',
    definiteModification: 'Definite modification',
  },
  pcncomponentDataexplain: {
    totalAvailableRooms: 'Total 10 available rooms (including 3 overbooking rooms)',
    ebPriceSoldRemaining:
      'Room price (EB selling price) / Sold room quantity / Remaining room quantity',
    ebPriceSoldCloseStatus:
      'Room price (EB selling price) / Sold room quantity / Room closing status',
    ebBasePriceReservedUnlimited:
      'EB base price / Remaining reserved room quantity (including contracted reserved rooms and temporary reserved rooms) / Unlimited sales',
    hourRoomProductsShowHourRoomIdentification: 'Hour room products show hour room identification',
    ctripEbPrepaidProductsShowThePrepaidLogo: 'Ctrip EB prepaid products show the prepaid logo',
    ctripEbCashProductsShowTheCashLogo: 'Ctrip EB Cash products show the cash logo',
    whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective:
      'When the product price is changed or the housing status is not immediately effective in the audit, the identification in the audit is displayed, and the identification in the audit is hidden after the audit passes the modification and becomes effective',
    underRevision: 'Under revision',
    thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure:
      'The price or inventory has data that is being modified. The identifier is displayed when the modification result is not obtained. The identifier is hidden only after success or failure',
    ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus:
      'If the product fails to change the price or change the room status, the failure identifier will be displayed, and the identifier will be hidden only after the next operation succeeds in changing the price or changing the room status',
    theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged:
      'The product fails to be obtained. Contact the operation manager to check whether the product has been changed',
    statusDeclaration: 'Status declaration',
    whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState:
      'When the limited number of sales is 0, the room is full, and it cannot be sold after closing the room. Only the relevant room will stop selling in the unlimited number state',
  },
  pcncomponentBatchUpdateStock: {
    cannotCloseRoomTip:
      'When EB product remaining retained rooms are not 0, the room cannot be closed.',
    roomSettingTip:
      'Room quantity adjustment refers to limit quantity for all products under the room type. For direct and EB products, the inventory uses the smaller of limit quantity and physical stock.',
    infiniteQuantityTip:
      'Infinite quantity corresponds to EB Meituan “unlimited”, Fliggy “unlimited”, Ctrip “freesale”, and direct channel “no limit sale”.',
    notModify: 'Not modify',
    roomSetting: 'Room setting',
    restrictedSalesIncrease: 'Restricted sales increase',
    restrictedSalesReduction: 'Restricted sales reduction',
    directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory:
      'Directly connected products only support to modify the switching room status, do not support to modify the inventory',
    batchChangeInventory: 'Batch change inventory',
    productSelection: 'Product selection',
    whetherToDisplayPreSaleProducts: 'Whether to display pre-sale products',
    channelSelection: 'Channel selection',
    paymentType: 'Payment type',
    selectionWeek: 'Selection week',
    switchRoomSetup: 'Switch room setup',
    open: 'Open',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain:
      'Some products failed to modify, the following are failed products, please get the latest price inventory and modify again',
    pleaseSelectADateRange: 'Please select a date range',
    pleaseSelectAWeek: 'Please select a week',
    pleaseEnterTheNumberOfRestrictedRooms: 'Please enter the number of restricted rooms',
    pleaseEnterTheNumberOfRestrictedAdditionalRooms:
      'Please enter the number of restricted additional rooms',
    pleaseEnterTheNumberOfRestrictedReducedRooms:
      'Please enter the number of restricted reduced rooms',
    successful: 'Successful',
  },
  pcncomponentPriceunified: {
    weekend: 'Weekend',
    officialWebsiteDirect: 'Official website direct',
    dateCannotRepeat: 'Date ranges cannot overlap',
    displayNextPage: 'Display next page',
    priceCannotBeLessThan20: 'The selling price cannot be less than or equal to 20',
    lowSellingPriceTip:
      'The following products have low selling prices, please confirm before proceeding',
    priceExceedsThresholdTip:
      'The current price exceeds the preset range, please contact the manager for review',
    selectProduct: 'Select product',
    weekdays: 'Weekdays',
    noDifference: 'No distinction',
    distinguish: 'Distinguish',
    bulkAdjustment: 'Bulk adjustment',
    increase: 'Increase',
    reduce: 'Reduce',
    weekdayWeekend: 'Weekday/Weekend',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'Some products failed to be modified. The following are failed items. Please fetch the latest price/inventory and try again.',
    selectionWeek2: 'Selection week',
    weekendPrice: 'Weekend Price',
    repricingDate: 'Repricing Date',
    effectiveWeek: 'Effective Week',
    maxFiveDates: 'Up to 5 date ranges allowed',
    priceChangeModeTip:
      'The price change mode can choose to modify the selling price + commission or the base price. In the selling price + commission mode, only Ctrip products support commission modification and can be adjusted upwards. In the base price mode, only Ctrip products can be modified.',
    sellPriceCommission: 'Selling price + Commission',
    ebChannel: 'EB Channel',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Feizhu',
    houseType: 'House type',
    splitPricing: 'Split pricing',
    uniformPriceChange: 'Uniform price change',
    productSelection: 'Product selection',
    paymentType: 'Payment type',
    selectionWeek: 'Selection week',
    thePreviousStepReselectTheProduct: 'The previous step reselect the product',
    methodOfRepricing: 'Method of repricing',
    separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches:
      'Separate price changes can set the price of each product, and unified price changes can be added and reduced in batches',
    priceModel: 'Price model',
    priceBeforeModification: 'Price before modification',
    extraChargeAfterOneHour: 'Extra charge after one hour',
    commission: 'Commission',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain:
      'Some products failed to modify, the following are failed products, please get the latest price inventory and modify again',
    directChannel: 'Direct channel',
    goWhereTheDirectConnection: 'Go where the direct connection',
    value: 'Value',
    successful: 'Successful',
    theCurrentRateExceedsTheThresholdSetByTheHotel:
      'The current rate exceeds the threshold set by the hotel',
    thisPriceChangeIsBeyondThePresetRangePleaseContactTheStoreManagerForPriceChangeReview:
      'This price change is beyond the preset range, please contact the store manager for price change review',
  },
  pcncomponentTable: {
    houseType: 'House type',
    noDataAvailable: 'No data available',
    passTheVerification: 'Pass the verification',
    verificationFail: 'Verification fail',
  },
  pcncomponentLog: {
    revisedPrice3: 'Revised price',
    pleaseEnterTheRevisedPrice: 'Please enter the revised price',
    pleaseSelectAStandardProduct: 'Select a standard product',
    operationContent: 'Operation content',
    straight: 'Straight',
  },
  giftPro: {
    bindUnbind: 'Bind/Unbind',
    giftValueInfo: 'The gift package value is for display only and does not incur actual costs.',
    thePackageCanOnlyBeConfiguredWithAllDayRoomProducts:
      'The package can only be configured with all-day room products',
    eachProductCanBeConfiguredWithOnlyOnePackage:
      'Each product can be configured with only one package',
    theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts:
      'The gift package is only valid for Meituan Direct connection products',
    packageDescription: 'Package description',
    allProducts2: 'All products',
    modifiedGiftPack: 'Modified gift pack',
    packageName: 'Package name',
    giftPackageGiving: 'Gift package giving',
    packageType: 'Package type',
    packageStatus: 'Package status',
    activeProduct: 'Active product',
    createPackage: 'Create package',
    packageValue: 'Package value',
    packageEffectiveDate: 'Package effective date',
    upperLimit1500: 'Upper limit 1500',
    upperLimit: 'Upper limit',
    packageDetails: 'Package details',
    maximum80Characters: 'Maximum 80 characters',
    wayOfGiving: 'Way of giving',
    thePackageValueCannotBeEmpty: 'The package value cannot be empty',
    oneDeliveryPerRoom: 'One delivery per room',
    complimentaryOnceADayPerRoom: 'Complimentary once a day per room',
    pleaseEnterThePackageName: 'Please enter the package name',
    pleaseSelectTheGiftMethod: 'Select the gift method',
    pleaseSelectAPackageType: 'Select a package type',
    pleaseSelectPackageDetails: 'Select package details',
    pleaseSelectAnEffectiveProduct: 'Select an effective product',
    pleaseSelectAnEffectiveDate: 'Select an effective date',
    whetherToDropTheGiftPackage: 'Whether to drop the gift package',
    giftBagOffLine: 'Gift bag off line',
    offlineSuccess: 'Offline success',
    offlineFailure: 'Offline failure',
    methodOfCancellation: 'Method of cancellation',
    createdSuccessfully: 'Created successfully',
    creationFailure: 'Creation failure',
  },
  giftLog: {
    packageOperationLog: 'Package operation log',
  },
  tiktokpresalecouponList: {
    deleteConfirm:
      'The product cannot be restored after deletion. Are you sure you want to delete?',
    shelveConfirm:
      'The product cannot be sold after being taken off the shelf. Are you sure you want to take it off the shelf?',
    unrestrictedInventory: 'Unrestricted inventory',
    theRemovalHasBeenCancelled: 'The removal has been cancelled',
    productId: 'Product ID',
    product: 'Product',
    createACoupon: 'Create a coupon',
    listing: 'Listing',
    delist: 'Delist',
    auditFailure: 'Audit failure',
    soldInventory: 'Sold inventory',
    modifiedPricePool: 'Modified price pool',
    copy: 'Copy',
    exportListOfPreSaleTickets: 'Export list of pre-sale tickets',
    itemDeletion: 'Item deletion',
    goodsOffTheProductionLine: 'Goods off the production line',
    removedSuccessfully: 'Removed successfully',
  },
  tiktokpresalecouponDetail: {
    name: 'Name',
    totalGoodsPrice: 'Total Goods Price (Strikethrough Price)',
    uploadImageTips:
      'Upload 1 - 5 images. Image size: within 5MB. Recommended resolution: 375*280px. Image aspect ratio: 4:3.',
    unavailableCheckInDates: 'Unavailable check-in dates: ',
    otherInStoreOffers:
      'You can enjoy other in-store offers (please consult the merchant for details).',
    createACoupon: 'Create a coupon',
    support: 'Support',
    nonsupport: 'Nonsupport',
    putUp: 'Put up',
    bindAvailableProducts: 'Bind available products',
    bindAtLeastOneProduct: 'Bind at least one product',
    meal: 'Meal',
    addMeal: 'Add meal',
    courteousReception: 'Courteous reception',
    addItem: 'Add item',
    unlimitedInventory: 'Unlimited inventory',
    stockLimit: 'Stock limit',
    whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate:
      'When Automatic extension is enabled, the product will be automatically extended for 30 days after the expiration date',
    namedDate: 'Named date',
    specifiedDays: 'Specified days',
    fromTheDateOfPurchase: 'From the date of purchase',
    availableWithinDays: 'Available within days',
    unavailableWeek: 'Unavailable week',
    unavailableHolidays: 'Unavailable holidays',
    unavailableDate: 'Unavailable date',
    subjectToAMarkup: 'Subject to a markup',
    noMarkup: 'No markup',
    allStores: 'All stores',
    addMarkupRules: 'Add markup rules',
    limitOnePurchasePerOrder: 'Limit one purchase per order',
    purchaseLimitPerPerson: 'Purchase limit per person',
    maximumPurchasePerPerson: 'Maximum purchase per person',
    zhang: 'Zhang',
    noAdvanceReservationRequired: 'No advance reservation required',
    advanceReservationRequired: 'Advance reservation required',
    aheadOfSchedule: 'Ahead of schedule',
    dailyReservation: 'Daily reservation',
    beforeCheckIn: 'Before check-in',
    cannotBeCombinedWithOtherInStoreOffers: 'Cannot be combined with other in-store offers',
    theMealTypeCannotBeEmpty: 'The meal type cannot be empty',
    theNameOfTheOfferCannotBeEmpty: 'The name of the offer cannot be empty',
    ticketName: 'Ticket name',
    pleaseEnterTicketNamemaximum24Words: 'Please enter ticket name (maximum 60 words)',
    fractionalAppointment: 'Fractional appointment',
    commodityContent: 'Commodity content',
    lunch: 'Lunch',
    dinner: 'Dinner',
    preSaleTicketHeadChart: 'Pre-sale ticket head chart',
    longMapOfAdvanceTickets: 'Long map of advance tickets',
    automaticExtension: 'Automatic extension',
    reservationValidity: 'Reservation validity',
    availabilityDate: 'Availability date',
    unavailableDate2: 'Unavailable date',
    markUpPolicy: 'Mark-up policy',
    markupStore: 'Markup store',
    markupSession: 'Markup session',
    additionalChargesApply: 'Additional charges apply',
    unit: 'Unit',
    pleaseEnterTheUnit: 'Please enter the unit',
    priceyuan: 'Price ',
    purchaseRestrictionRule: 'Purchase restriction rule',
    reservationRule: 'Reservation rule',
    cancellationRules: 'Cancellation rules',
    rulesOfUse: 'Rules of use',
    otherDescriptiveInformation: 'Other descriptive information',
    pleaseEnterAdditionalExplanatoryInformation: 'Please enter additional explanatory information',
    found: 'Found',
    picturePreview: 'Picture preview',
    theNameOfTheVoucherCannotBeEmpty: 'The name of the voucher cannot be empty',
    theNameOfTheVoucherCannotExceed24Characters:
      'The name of the voucher cannot exceed 60 characters',
    pleaseSelectASaleDate: 'Please select a sale date',
    pleaseSelectTheReservationValidityPeriod: 'Please select the reservation validity period',
    pleaseSelectTheHeaderDiagram: 'Please select the header diagram',
    pleaseSelectALongMap: 'Please select a long map',
    thePurchaseLimitPerPersonCanOnlyBeANumber: 'The purchase limit per person can only be a number',
    pleaseFillInTheLengthOfStay: 'Please fill in the length of stay',
    mealPriceMustBeGreaterThan: 'Meal price must be greater than',
    theCourtesyPriceMustBeGreaterThan: 'The courtesy price must be greater than',
    theTotalPriceOfTheGoodsCannotBeEmpty: 'The total price of the goods cannot be empty',
    theTotalPriceOfTheGoodsMustBeGreaterThan: 'The total price of the goods must be greater than',
    pleaseFillInTheActualPricePaidByTheGuest: 'Please fill in the actual price paid by the guest',
    theActualPricePaidMustBeGreaterThan: 'The actual price paid must be greater than',
    theActualPricePaidByTheGuestCannotBeGreaterThanTheTotalPriceOfTheProduct:
      'The actual price paid by the guest cannot be greater than the total price of the product',
    youCanOnlyUploadPictureFiles: 'You can only upload picture files',
    pleaseUploadAtLeast1HeaderImage: 'Please upload at least 1 header image',
    pleaseUploadAtLeast1LongPicture: 'Please upload at least 1 long picture',
    pleaseEnterTheMaximumPurchasePerPerson: 'Please enter the maximum purchase per person',
    pleaseFillInTheDailyLimit: 'Please fill in the daily limit',
    confirmTheDateToDeleteThis: 'Confirm the date to delete this',
    confirmToDeleteThisProduct: 'Confirm to delete this product',
    confirmToDeleteThisMeal: 'Confirm to delete this meal',
    removeMarkupRules: 'Remove markup rules',
    confirmToRemoveThisMarkupPolicy: 'Confirm to remove this markup policy',
    newMarkupRules: 'New markup rules',
    confirmToDeleteThisOffer: 'Confirm to delete this offer',
    addProjectData: 'Add project data',
    popUpsAreClosed: 'Pop-ups are closed',
    beSureToRemoveThisRestriction: 'Be sure to remove this restriction',
    imageUploadFailed: 'Image upload failed',
    upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio:
      'Upload 1-10 pictures, image size: 5M or less; recommended resolution: 375*280px; image ratio:',
  },
  assemblyAddpriceruledialog: {
    allStores: 'All stores',
    byDate: 'By date',
    byHoliday: 'By holiday',
    addMarkupRules: 'Add markup rules',
    markupStore: 'Markup store',
    markUpPeriod: 'Mark-up period',
    pleaseEnterTheAmountOfTheIncrease: 'Please enter the amount of the increase',
    theIncreaseMustBeGreaterThan: 'The increase must be greater than',
    pleaseSelectTheIncreasePeriod: 'Select the increase period',
    pleaseSelectAFestival: 'Select a festival',
    pleaseSelectTheWeekOfIncrease: 'Select the week of increase',
  },
  assemblyAddmeals: {
    addMeal: 'Add meal',
    typeOfMeal: 'Type of meal',
    pleaseSelectTheTypeOfMeal: 'Select the type of meal',
    lunch: 'Lunch',
    dinner: 'Dinner',
    copies: 'Copies',
    pleaseEnterTheNumberOfCopies: 'Please enter the number of copies',
    theNumberOfCopiesMustBeGreaterThan: 'The number of copies must be greater than',
  },
  settingHardware: {
    hardwareManagementToBeDeveloped: 'Hardware management, to be developed',
  },
  settingMessage: {
    messageManagementToBeDeveloped: 'Message management, to be developed',
  },
  baseinfotabBase: {
    orientation: 'Orientation',
    china: 'China',
    province: 'Province',
    hotelRating: 'Hotel rating',
    detailedAddress: 'Detailed address',
    city: 'City',
    hotelPrice: 'Hotel price',
    hotelReceptionCellPhone: 'Hotel reception cell phone',
    hotelFrontDesk: 'Hotel front desk',
    areaCode: 'Area code',
    landlineNumber: 'Landline number',
    extensionNumber: 'Extension number',
    serviceStatus: 'Service status',
    ctripHotelStars: 'Ctrip hotel stars',
    noStarLevel: 'No star level',
    starLevel: '{num}-Star',
    whetherToSellItOnTheInternet: 'Whether to sell it on the Internet',
    currency: 'Currency',
    longitude: 'Longitude',
    latitude: 'Latitude',
    baiduLatitudeAndLongitude: 'Baidu latitude and longitude',
    pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits:
      'Please enter the correct phone number with a maximum of 11 digits',
    theLengthIs78Characters: 'The length is 7-8 characters',
    theLengthIs34Characters: 'The length is 3-4 characters',
    pleaseEnterAnInteger: 'Please enter an integer',
    pleaseEnterTheHotelName: 'Please enter the hotel name',
    lengthOf250ChineseCharacters: 'Length of 2-50 Chinese characters',
    theValueContains34Digits: 'The value contains 3-4 digits',
    theValueContains78Characters: 'The value contains 7-8 characters',
    pleaseEnterTheValue: 'Please enter the value',
    pleaseSelectAProvince: 'Select a province',
    pleaseSelectCity: 'Select city',
    pleaseSelectACounty: 'Select a county',
    pleaseEnterTheFullAddress2: 'Please enter the full address',
    theDetailedAddressDoesNotExceed50ChineseCharacters:
      'The detailed address does not exceed 50 Chinese characters',
    pleaseSelectHotelClass: 'Please select hotel class',
    pleaseSelectACtripHotelStar: 'Please select a Ctrip hotel star',
    selectWhetherTheExternalNetworkIsVisible: 'Select whether the external network is visible',
    pleaseSelectHotelServiceStatus: 'Select Hotel service status',
    economical: 'Economical',
    quasi1Star: 'Quasi-1-star',
    true1Star: 'True 1-star',
    quasi2Star: 'Quasi-2-star',
    true2Star: 'True 2-star',
    quasi3Star: 'Quasi-3-Star',
    true3Star: 'True 3-star',
    quasi4Star: 'Quasi-4-Star',
    true4Star: 'True 4-star',
    quasi5Star: 'Quasi-5-Star',
    true5Star: 'True 5-Star',
    inOperation: 'In operation',
    suspendBusiness: 'Suspend business',
    tencentMapLatitudeAndLongitudeCanNotBeEmpty:
      'Tencent map latitude and longitude can not be empty',
    theNameAndAddressOfTheHotelAreUnderReview: 'The name and address of the hotel are under review',
    districtcounty: 'District/County',
    tencentamapLatitudeAndLongitude: 'Tencent/Amap latitude and longitude',
    pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits:
      'Please enter the correct phone number, and the maximum is 11 digits',
  },
  baseinfotabFull: {
    hotelTimezone: 'Hotel Timezone',
    fixedRoomNumber: 'Fixed Room Number',
    businessCircle: 'Business Circle',
    hotelBuildingHeight: 'Hotel Building Height',
    subordinateBusinessCircle: 'Subordinate Business Circle',
    totalNumberOfRooms: 'Total Number of Rooms',
    hotelOpeningHours: 'Hotel Opening Hours',
    pleaseSelectADate5: 'Select a date',
    affiliatedGroup: 'Affiliated Group',
    hotelRenovationTime: 'Hotel Renovation Time',
    affiliatedBrand: 'Affiliated Brand',
    hotelTypeupToThree: 'Hotel Type (up to three)',
    hotelThemeupToThreeCanBeSelected: 'Hotel Theme (up to three can be selected)',
    settlementMethod: 'Settlement Method',
    hotelProfile: 'Hotel Profile',
    hotelTransportationLocation: 'Hotel Transportation Location',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits:
      'Please enter a number greater than or equal to 0 and no more than 3 digits',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits:
      'Please enter a number greater than or equal to 0 and no more than 2 digits',
    pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters:
      'Please enter a description of the hotel with a maximum length of 800 characters',
    pleaseEnterTheHotelTransportationLocation: 'Please enter the hotel transportation location',
    pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters:
      'Please enter the hotel transportation location in a maximum of 800 characters',
    pleaseEnterTheTotalNumberOfRooms: 'Please enter the total number of rooms',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2:
      'Please enter a number greater than or equal to 0 and no more than 3 digits',
    pleaseSelectYourBrand: 'Please select your brand',
    pleaseEnterTheHotelBuildingHeight: 'Please enter the hotel building height',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2:
      'Please enter a number greater than or equal to 0 and no more than 2 digits',
    pleaseEnterHotelRenovationTime: 'Please enter hotel renovation time',
    pleaseEnterHotelOpeningHours: 'Please enter hotel opening hours',
    pleaseEnterTheCheckoutSupportCardType: 'Please enter the checkout support card type',
    pleaseSelectHotelType: 'Select hotel type',
    pleaseSelectAHotelTheme: 'Select a hotel theme',
    bizumi: 'Bizumi',
    theBusinessCircleIsUnderReview: 'The business circle is under review',
    includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages:
      'Includes but not limited to: hotel address, hotel facilities, hotel services provided, hotel features and advantages',
    includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km:
      'Includes but not limited to: traffic facilities near the hotel, such as distance from the bus station 100 meters, distance from the high-speed train station 2.5 km',
  },
  baseinfotabInfo: {
    commission2: 'Commission',
    bookingInstructions: 'Booking instructions',
    variousFaults: 'Various faults',
    earliestCheckInTime: 'Earliest check-in time',
    latestDepartureTime: 'Latest departure time',
    hourRoomEarliestCheckInTime: 'Hour room earliest check-in time',
    hourRoomLatestCheckOutTime: 'Hour room latest check-out time',
    aMaximumOf30Characters: 'A maximum of 30 characters',
    taxTitle: 'Tax title',
    chargingStandard: 'Charging standard',
    reservationNotes: 'Reservation Notes',
    chineseDescription: 'Chinese description',
    pleaseEnterYourEarliestCheckInTime: 'Please enter your earliest check-in time',
    pleaseEnterTheLatestDepartureTime: 'Please enter the latest departure time',
    pleaseEnterTheEarliestCheckInTimeForTheHourRoom:
      'Please enter the earliest check-in time for the hour room',
    pleaseEnterTheLatestCheckOutTimeForTheHourRoom:
      'Please enter the latest check-out time for the hour room',
    pleaseSelectTheBookingInstructions: 'Please select the booking instructions',
    noMoreThan10ChineseCharactersInLength: 'No more than 10 Chinese characters in length',
    theLengthCannotExceed20Characters: 'The length cannot exceed 20 characters',
    noMoreThan20ChineseCharactersInLength: 'No more than 20 Chinese characters in length',
    noMoreThan30ChineseCharactersInLength: 'No more than 30 Chinese characters in length',
    theLengthCannotExceed60Characters: 'The length cannot exceed 60 characters',
    cutOffTheWaterSupply: 'Cut off the water supply',
    powerFailure: 'Power failure',
    elevatorFailure: 'Elevator failure',
    cantUseBankCard: "Can't use bank card",
    networkFault: 'Network fault',
    pleaseEnterTheStartTimeAndEndTime: 'Please enter the start time and end time',
    theStartTimeMustBeYoungerThanTheEndTime: 'The start time must be younger than the end time',
  },
  baseinfotabServer: {
    squareMeter: 'Square meter',
    parkingLot: 'Parking lot',
    elevator2: 'Elevator',
    pleaseEnterArea: 'Please enter area',
    internetAccessInPublicAreas: 'Internet access in public areas',
    hotelFacilities: 'Hotel Facilities',
    otherFacilities: 'Other Facilities',
    hotelService: 'Hotel service',
    otherServices: 'Other services',
    fallow: 'Fallow',
    otherLeisure: 'Other leisure',
    pleaseEnterAMaximumOf10DigitsInEnglish: 'Please enter a maximum of 10 digits in English',
    pleaseSelectParking: 'Select Parking',
    pleaseSelectTheHall: 'Select the hall',
    pleaseEnterTheHallArea: 'Please enter the hall area',
    pleaseSelectElevator: 'Select elevator',
    pleaseSelectPublicAreasToAccessTheInternet: 'Select public areas to access the Internet',
    pleaseSelectHotelFacilities: 'Select hotel facilities',
    pleaseSelectHotelServices: 'Select hotel services',
    pleaseSelectLeisure: 'Select Leisure',
    oneToFiveStars: 'One to five stars',
    true15Stars: 'True 1-5 stars',
    walkUp: 'Walk-up',
    thereIsAnElevator: 'There is an elevator',
    lobbyless: 'Lobbyless',
    haveALobby: 'Have a lobby',
    noInternetAccess: 'No Internet access',
    freeParking: 'Free parking',
    noParking: 'No parking',
    parkingLotAvailable: 'Parking lot available',
    paidParking: 'Paid parking',
    charge: 'Charge',
  },
  borrowBorrowrecord: {
    loanDate2: 'Loan Date',
    newBorrowing: 'New Borrowing',
    return: 'Return',
    cannotBeGreaterThanTheAvailableAmount: 'Cannot be greater than the available amount',
    enterItemNameAndRoomNumber: 'Enter item name or room number',
    unitPriceOfGoods2: 'Unit Price',
    quantityBorrowed: 'Borrowed Quantity',
    borrowARoom: 'Borrowed Room',
    dateOfReturn: 'Return Date',
    returnQuantity: 'Returned Quantity',
    borrowedState: 'Borrowing Status',
    amountOfCompensation: 'Compensation Amount',
    serviceSuccess: 'Service Successful',
    serviceFailure: 'Service Failed',
    reasonForRefusal: 'Reason for Refusal',
    enterAMaximumOf30Characters: 'Enter up to 30 characters',
    returnOrNot: 'Return or Not',
    hasItBeenReturned: 'Has it been returned?',
    onlyNumbersGreaterThan0CanBeEntered: 'Only numbers greater than 0 are allowed',
    theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed:
      'The returned quantity cannot be greater than or equal to the borrowed quantity',
    upTo20Characters: 'Up to 20 characters',
    pleaseEnterTheReturnQuantity: 'Please enter the return quantity',
    onLoan: 'On Loan',
    theRoomRequestHasBeenServiced: 'The room request has been serviced',
    serviceCompletion: 'Service Completed',
    returned: 'Returned',
    noReturn: 'Not Returned',
    enterAMaximumOf9Characters: 'Enter up to 9 characters',
    chooseToBorrowRoom: 'Select Room to Borrow',
  },
  businessCardIndex: {
    pleaseUploadPictures: 'Please upload pictures',
    pleaseEnterRoomType: 'Please enter room type',
    uploadBackground: 'Upload background',
    saveOperation: 'Save operation',
    uploadProfilePicture: 'Upload profile picture',
    pleaseEnterAValidNumber: 'Please enter a valid number',
    businessCardType: 'Business card type',
    currentPriceOfRoomType: 'Current price of room type',
    roomTypeOriginalPrice: 'Room type original price',
    backgroundImage: 'Background image',
    avatar: 'Avatar',
    hotelRecommendation: 'Hotel recommendation',
    roomTypeRecommendation: 'Room type recommendation',
    theNameCannotBeBlank2: 'The name cannot be blank',
    thePhoneNumberCannotBeEmpty: 'The phone number cannot be empty',
    pleaseEnterAValidPhoneNumber: 'Please enter a valid phone number',
    roomTypeNameCannotBeEmpty: 'Room type name cannot be empty',
    theCurrentPriceOfTheRoomTypeCannotBeEmpty: 'The current price of the room type cannot be empty',
    roomTypeOriginalPriceCannotBeEmpty: 'Room type original price cannot be empty',
    pleaseUploadTheBackgroundImage: 'Please upload the background image',
    pleaseUploadPhoto: 'Please upload photo',
    areYouSureYouWantToLeaveTheCurrentPage: 'Are you sure you want to leave the current page',
    pleaseSelectImageUpload: 'Please select image upload',
    theCurrentPriceOfTheRoomTypeShallNotBeLessThan:
      'The current price of the room type shall not be less than',
    roomTypeOriginalPriceMustNotBeLessThan: 'Room type original price must not be less than',
  },
  businessCardUploadavatar: {
    selectPicture: 'Select picture',
    uploadProfilePicture: 'Upload profile picture',
    pleaseSelectImageUpload: 'Please select image upload',
    onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m:
      'Only JPG and PNG images are supported, and the size of the image does not exceed 5M',
  },
  ctnhotelHotelserver: {
    applicationTime2: 'Application time',
    toDealWith: 'To deal with...',
    pleaseRenewYourStayOnTheDayOfDeparture: 'Please renew your stay on the day of departure',
    applicant: 'Applicant',
    originalExpectedArrivalDate: 'Original expected arrival date',
    originalDepartureDate: 'Original departure date',
    applicationType: 'Application type',
    renewTheNewOrderNumber: 'Renew the new order number',
    renewalDate: 'Renewal date',
  },
  ebaccountLogin: {
    accountLogin: 'Account login',
    gotTheMessage: 'Got the message',
  },
  ebaccountSetting: {
    accountBinding: 'Account binding',
    goToMaintain: 'Go to Maintain',
    priceModel: 'Price model',
    automaticOrder: 'Automatic order',
    comingSoon: 'Coming soon',
    hourlyRoomOrder: 'Hourly room order',
    orderCancellation: 'Order cancellation',
    bound: 'Bound',
    roomTypeSetting: 'Room Types',
    goToSettings: 'Go to Settings',
    lastStep: 'Last step',
    correlationState: 'Correlation state',
    bindAccount: 'Bind account',
    synchronizationTime: 'Synchronization time',
    onSale: 'On sale',
    associated: 'Associated',
    uncorrelated: 'Uncorrelated',
    bind: 'Bind',
    noDataIsQueried: 'No data is queried',
    whetherToUnbindTheAccount: 'Whether to unbind the account',
    pleaseEnterTheCommissionRate: 'Please enter the commission rate',
    channelSetting: 'Channel setting',
    floorPriceModel: 'Floor price model',
    sellingPriceModel: 'Selling price model',
    viewSettings: 'View Settings',
    orderSetup: 'Order setup',
    pleaseSelectAPriceModel: 'Select a price model',
    pleaseSelectHourRoomPickUp: 'Select hour room pick-up',
    dataSynchronization: 'Data synchronization',
    ctripRoomType: 'Ctrip room type',
    usGroupRoomType: 'Us group room type',
    lightWinTreasureRoomTypeName: 'Light win treasure room type name',
    commissionRate: 'Commission rate',
    pleaseEnterTheSmsVerificationCode: 'Please enter the SMS verification code',
    pleaseEnterTheContentInThePicture: 'Please enter the content in the picture',
    groggery: 'Groggery',
    ctripProductName: 'Ctrip product name',
    meituanProductName: 'Meituan product name',
    ctripProducts: 'Ctrip products',
    meituanProducts: 'Meituan products',
    lightWinTreasureProductName: 'Light win treasure product name',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100:
      'Commission rate is greater than or equal to 0 and less than 100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'Commission rates are numerical and reserved for two decimal places',
    pleaseSelectTheHourlyOrderSetting: 'Please select the hourly order setting',
    automaticCancellation: 'Automatic cancellation',
    manualCancellation: 'Manual cancellation',
    automaticConfirmation: 'Automatic confirmation',
    manualValidation: 'Manual validation',
    meituancom: 'Meituan.com',
    ctrip: 'Ctrip',
    pleaseEnterTheImageVerificationCode: 'Please enter the image verification code',
    pleaseSelectHotel: 'Please select Hotel',
    theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater:
      'The data synchronization is successful. Query the data again 10 minutes later',
    unbind: 'Unbind',
    whetherToUnbindTheProduct: 'Whether to unbind the product',
    pleaseSelectTheProductName: 'Select the product name',
    unbindSuccessfully: 'Unbind successfully',
    whetherToUnbindTheBindingRelationshipOfTheHouseType:
      'Whether to unbind the binding relationship of the house type',
    pleaseSelectLightWinTreasureRoomTypeName: 'Please select Light Win Treasure room type name',
    feizhu: 'Feizhu',
    notYetUnlocked: 'Not yet unlocked',
    pleaseBindTheAccountFirst: 'Please bind the account first',
    areYouSureYouWantToUnbindTheAccount: 'Are you sure you want to unbind the account',
    notYetBound: 'Not yet bound',
    pleaseConfirmTheHotelYouWantToBindTo: 'Please confirm the hotel you want to bind to',
    ctripEbAccount: 'Ctrip EB account',
    meituanEbAccount: 'Meituan EB account',
    pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid:
      'Please contact your hotel Operations manager to set up a Ctrip HotelID',
    useEbOrderInformation: 'Use EB order information',
    pleaseSelectEbOrderCancellation: 'Select EB order cancellation',
    meituanEbRoomType: 'Meituan EB room type',
    lightWinTreasureRoomTypeId: 'Light win Treasure room type ID',
    lightWinTreasureProductId: 'Light win Treasure product ID',
    pleaseSelectTheEbOrderCancellationSettings: 'Please select the EB Order cancellation Settings',
    whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually:
      'When you automatically move the order, if you do not set the room type, you will move the order manually',
    whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder:
      'When you manually move the order, you will be given priority to match the room type set, saving the time of moving the order',
    thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible:
      'This EB order setup completed, please proceed as soon as possible',
    reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager:
      'Reminder: If you need to set or add a room type, please contact your operational manager',
    orderSetupCompletedPleaseProceedAsSoonAsPossible:
      'Order setup completed, please proceed as soon as possible',
    yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      "Your 'Ctrip travel' EBK account 'is not bound', and you will not be able to",
    associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible:
      'Association. To avoid affecting EB moving orders, please bind as soon as possible',
    yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo:
      "Your 'Ctrip travel' EBK account 'has expired', and you will not be able to",
    associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe:
      "Association. To avoid affecting EB moving orders, please 'unbind' and re - bind after the",
    yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      "Your 'Meituan' EBK account 'is not bound', and you will not be able to",
    automaticallyCreditedToArAccount: 'Automatically credited to AR account',
    noticeOfMovingOrderEb: 'EB automatically accepts the order after the transfer is successful',
    checkInSuccessNoticeEb: 'Check-in notification',
    meituanMovingOrderDeductsPublicGoods: 'Meituan moving order deducts public goods',
    meituanMovingOrderServiceRate: 'Meituan operating service rate %',
    yourctripTravelEbkAccounthasExpired:
      'Your "Ctrip travel" EBK account has expired, and you will not be able to',
    yourmeituanEbkAccounthasExpired:
      'Your "Meituan" EBK account has expired, and you will not be able to',
  },
  ebmanagementIndex: {
    accountBinding: 'Account binding',
    commissionRate: 'Commission rate',
    theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously:
      'The account is bound successfully, and the in-depth operation is started simultaneously',
    whetherToUnbindTheAccount: 'Whether to unbind the account',
    pleaseEnterTheCommissionRate: 'Please enter the commission rate',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'The time dimension is consistent with the screening date, and the booking amount is calculated according to the actual amount paid by the guest',
    pleaseEnterTheSmsVerificationCode: 'Please enter the SMS verification code',
    pleaseEnterTheContentInThePicture: 'Please enter the content in the picture',
    groggery: 'Groggery',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100:
      'Commission rate is greater than or equal to 0 and less than 100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'Commission rates are numerical and reserved for two decimal places',
    pleaseSelectHotel: 'Please select Hotel',
    pleaseEnterTheImageVerificationCode: 'Please enter the image verification code',
    accountUntying: 'Account untying',
    unbindSuccessfully: 'Unbind successfully',
    pleaseConfirmTheHotelYouWantToBindTo: 'Please confirm the hotel you want to bind to',
    noEbAccountHasBeenBound: 'No EB account has been bound',
    ebAccountLogin: 'EB Account Login',
  },
  hardwareBluetoothlock: {
    smartDoorLock: 'Smart door lock',
    configurationFailure: 'Configuration failure',
    thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience:
      "This function specifically refers to the connection of smart door locks such as password and Bluetooth, which can be opened by using password and Bluetooth through small programs and apps to improve the customer's check-in experience",
  },
  hardwareChoseroom: {
    selectARoom2: 'Select a room',
  },
  hardwareCreatepassworddialog: {
    createPassword: 'Create password',
    selectType: 'Select type',
    pleaseEnterAgain: 'Please enter again',
    validUntil: 'Valid until',
    pleaseEnterA6DigitPassword: 'Please enter a 6-digit password',
    passwordIsDifferentPleaseReEnter: 'Password is different, please re-enter',
    oneTimePassword: 'One-time password',
    timePeriodCipher: 'Time period cipher',
    offlinePassword: 'Offline password',
    longAgingOfflinePassword: 'Long-aging offline password',
  },
  hardwareEditpassworddialog: {
    oneTimePassword: 'One-time password',
    timePeriodCipher: 'Time period cipher',
    offlinePasswordForALongTime: 'Offline password for a long time',
    offlinePassword: 'Offline password',
    recover2: 'Recover',
    currentPassword: 'Current password',
    pleaseEnterAgain: 'Please enter again',
    validUntil: 'Valid until',
    pleaseEnterA6DigitPassword: 'Please enter a 6-digit password',
    passwordIsDifferentPleaseReEnter: 'Password is different, please re-enter',
    longAgingOfflinePassword: 'Long-aging offline password',
  },
  hardwareHousepricecard: {
    memberRightsShowStoreActivitiesShow: 'Member rights show, store activities show',
    openThePriceBoard: 'View prices',
    downloadRateBoard: 'Download',
    failedToConfigureElectronicPriceBoard: 'Failed to configure electronic price board',
  },
  hardwareIdcard: {
    whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox:
      'When the ID card type is ID card, the ID card information can be read by the ID card reader and automatically filled into the text box',
    idCardReader: 'Id card reader',
    failedToConfigureTheIdCardReader: 'Failed to configure the ID card reader',
  },
  hardwareLock: {
    doorLockType: 'Door lock type',
    selectiveLock: 'Selective lock',
    areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom:
      'Are you sure you want to delete the door lock configuration for this room',
    pleaseEnterRoomNumberAndEquipmentModel: 'Please enter room number and equipment model',
    doorLockCardPrintingRecord: 'Door lock card printing record',
    roomDoorLockConfiguration2: 'Room door lock configuration',
    passwordSetting2: 'Password setting',
    deviceType: 'Device type',
    equipmentBrand: 'Equipment brand',
    equipmentType: 'Equipment type',
    versionNumber: 'Version number',
    roomLockNumber: 'Room lock number',
    doorLock: 'Door lock',
    doorLockPower: 'Door lock power',
    editDoorLockConfiguration: 'Edit door lock configuration',
    selectDevice: 'Select device',
    setTheDoorLock: 'Set the door lock',
    setTheRoomLockNumber: 'Set the room lock number',
    pleaseEnterDoorLock: 'Please enter door lock',
    settingNmsParameters: 'Setting NMS Parameters',
    pleaseEnterNetworkManagementParameters: 'Please enter network management parameters',
    traditionalDoorLock: 'Traditional door lock',
    smartDoorLock: 'Smart door lock',
    pleaseEnterTheLockId: 'Please enter the lock ID',
    pleaseEnterLockmac: 'Please enter lockMac',
    batchDelete: 'Batch Delete',
    confirmBatchDeleteText:
      'Are you sure you want to batch delete the selected room door lock configurations?',
    pleaseSelectRecordsToDelete: 'Please select records to delete first',
    batchDeleteSuccess: 'Batch deletion successful',
    batchDeleteFail: 'Batch deletion failed',
  },
  hardwareLockpassword: {
    createPassword: 'Create Password',
    comeIntoForce: 'Come into force',
    activationCode: 'Activation code',
    applicableRoom: 'Applicable room',
    expirationDate3: 'Expiration date',
    theDoorLockThatSupportsThePasswordIsNotEnabled:
      'The door lock that supports the password is not enabled',
    passwordSetting: 'Password Setting',
    invalidate: 'Invalidate',
    restore: 'Restore',
    confirmInvalidatePassword: 'Are you sure you want to invalidate this password?',
  },
  hardwareLockroom: {
    importTemplateFileName: 'Lock_Import_Template.xlsx',
    downloadSuccess: 'Lock import template downloaded successfully',
    downloadFail: 'Failed to download lock import template',
    importDialogTitle: 'Batch Import Door Locks',
    roomDoorLockConfiguration: 'Room door lock configuration',
    customRule: 'Custom Rule',
    rule: 'Rule',
    deviceType: 'Device Type',
    selectDevice: 'Select Device',
    empty: 'Empty',
    selectLock: 'Select Door Lock',
    deviceBrand: 'Device Brand',
    deviceModel: 'Device Model',
    version: 'Version',
    configurationInfo: 'Configuration Info',
    selectRoom: 'Select Room',
    lockDeviceId: 'Lock Device ID',
    remainingPower: 'Remaining Power',
    remoteOpenDoorType: 'Remote Door Opening Method',
    gatewayOpen: 'Gateway Open',
    bluetoothOpen: 'Bluetooth Open',
    rule1: 'Lock ID = Room Number',
    rule2Prefix: 'Lock ID =',
    rule3Prefix: 'Lock ID =',
    trimRoomNumber: 'Trim First Digit of Room Number',
    import: 'Import',
    clickUpload: 'Click Upload',
    imported: 'Imported',
    rulePrefix: 'Rule:',
    generateLockId: 'Generate Lock ID',
    lockIdLabel: 'Lock ID',
    roomLockNumberLabel: 'Room Lock Number',
    enterRoomLockNumber: 'Enter room lock number',
    enterLockId: 'Enter lock ID',
    gatewayParams: 'Gateway Parameters',
    enterGatewayParams: 'Enter gateway parameters',
    enterLockMac: 'Enter lockMac',
    getFreeGoLock: 'Get FreeGo Locks',
  },
  hardwareNfclock: {
    thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure:
      "This function refers to the docking of Carmen lock, which can improve the efficiency of check-in by making the guest's room card through Light Win Treasure",
    traditionalDoorLock: 'Traditional door lock',
    doorLockInformationConfiguration2: 'Door lock information configuration',
    functionCardManagement2: 'Function card management',
    failedToConfigureATraditionalDoorLock: 'Failed to configure a traditional door lock',
  },
  hardwarePricecard: {
    full: 'Full',
    serviceHotline: 'Service hotline',
    downloadRateBoard: 'Download rate board',
  },
  hardwareSelfdevicedialog: {
    selfServiceMachinePaymentConfiguration: 'Self-service machine payment configuration',
    depositAllocationCollection: 'Deposit allocation collection',
    orderRetentionTimeConfiguration: 'Order retention time configuration',
    whetherTheUnpaidOrderIsCancelledImmediately:
      'Whether the unpaid order is cancelled immediately',
    minutes: 'Minutes',
    checkOutArrangement: 'Check-out arrangement',
    checkOutAccountingConfiguration: 'Check-out accounting configuration',
    temporaryCheckOut: 'Temporary check out',
    checkOut2: 'Check out',
    autoAddRoomFeeConfig: 'Auto add room fee configuration',
    whetherToEnableAutoAddRoomFee: 'Whether to enable auto add room fee',
    occupancyConfiguration: 'Occupancy configuration',
    whetherToSupportHourRoomWithoutReservation: 'Whether to support hour room without reservation',
    supportForTimePeriodsWithoutReservation: 'Support for time periods without reservation',
    theSelfServiceMachineIsSuccessfullyConfigured:
      'The self-service machine is successfully configured',
    selfServiceMachineConfiguration2: 'Self-service machine configuration',
    pleaseFillInTheDepositConfiguration: 'Please fill in the deposit configuration',
    pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked:
      'Please select the time period when the hour room is not booked',
  },
  hardwareSelfservice: {
    selfServiceMachine: 'Self-service machine',
    selfServiceMachineConfiguration2: 'Self-service machine configuration',
    failedToConfigureTheSelfServiceMachine: 'Failed to configure the self-service machine',
    thereIsNoSelfServiceMachineInTheHotel: 'There is no self-service machine in the hotel',
    thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch:
      'This switch is to open the self-service machine and PMS system interface switch, if the hotel needs to connect to the self-service check-in machine, you need to turn on the switch',
  },

  "hardwareSetWitness": {
    "title": "Facial Recognition Device",
    "desc": "Facial recognition for self-service check-in",
    "setting": "Settings",
    "configSuccess": "Facial recognition configuration enabled successfully",
    "configClose": "Facial recognition configuration disabled successfully",
    "configFailed": "Configuration failed"
  },
  "hardwareWitness": {
    "deviceSnSetting": "Device Code Settings",
    "deviceSn": "Device SN",
    "addSn": "Add New SN",
    "enterSn": "Please enter SN",
    "addSnBtn": "+ Add SN",
    "saveSuccess": "Saved successfully",
    "deleteSuccess": "Deleted successfully",
    "snRepeatError": "SN cannot be duplicated",
    "deleteConfirmMsg": "Are you sure you want to delete this device SN?",
    "deleteConfirmTitle": "Tips"
  },


  hardwareSethouserpricecard: {
    transversePlate: 'Transverse plate',
    verticalVersion: 'Vertical version',
    addPictureUpload: 'Add picture upload',
    show: 'Show',
    doNotShow: 'Do not show',
    format: 'Format',
    storePicture: 'Store picture',
    pleaseEnterADescription: 'Please enter a description',
    hourRoomRates: 'Hour room rates',
    pleaseSelectTheNumberOfHours: 'Select the number of hours',
    whetherToDisplayMemberPrices: 'Whether to display member prices',
    roomReservationPhone: 'Room reservation phone',
    pleaseEnterTheReservationNumber: 'Please enter the reservation number',
    bookingGuide: 'Booking guide',
    pleaseEnterThePreOrderGuideCopy: 'Please enter the pre-order guide copy',
    hotelAnnouncement: 'Hotel announcement',
    pleaseEnterTheHotelBulletin: 'Please enter the hotel bulletin',
    uploadedPictures: 'Uploaded pictures',
    storePicturesMustBeUploaded: 'Store pictures must be uploaded',
    onlyJpgjepgpngFormatIsSupported: 'Only jpgjepgpng format is supported!',
  },
  functionalcardAuthorizationcard: {
    authorizationCardBeforeReportingTheLoss: 'Authorization card before reporting the loss',
    authorizationCard: 'Authorization card',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "Generally, only one authorization card needs to be brushed on the lock, and the lock will make 'Didi' twice to indicate authorization success",
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'When the room number or time information on the lock is lost, the room number setting card or the clock setting card can be used to set the lock; or the authorization card can be brushed three times, and the room guest card can be used to open the lock',
  },
  functionalcardExtendssetting: {
    after: 'After',
    inMinutes: 'In minutes',
    findRoomNumber: 'Find Room number',
    timeDeviation: 'Time deviation',
    roomNumberRequired: 'Room number required',
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'When the room number or time information on the lock is lost, the room number setting card or the clock setting card can be used to set the lock; or the authorization card can be brushed three times, and the room guest card can be used to open the lock',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "Generally, only one authorization card needs to be brushed on the lock, and the lock will make 'Didi' twice to indicate authorization success",
  },
  functionalcardIndex: {
    selectiveClassification: 'Selective classification',
    functionCardManagement2: 'Function card management',
    authorizationCard: 'Authorization card',
    extendedSettingsClass: 'Extended Settings class',
    openCategory: 'Open category',
    specificFunctionClass: 'Specific function class',
    businessCardFailure: 'Business card failure',
  },
  functionalcardOpendoor: {
    beforeTheLossWasReported: 'Before the loss was reported',
    publicDoorsCanBeOpened: 'Public doors can be opened',
    canOpenTheLock: 'Can open the lock',
    availablePeriod: 'Available period',
    startTimeRequired: 'Start time required',
    theEndTimeIsRequired: 'The end time is required',
    floorFill: 'Floor fill',
    theFloorMustConsistOf4PureDigits: 'The floor must consist of 4 pure digits',
    layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding:
      'Layer control card: Used to open all locks in a specific layer of a building',
    totalCardCanOpenAllLocksInThisSystem: 'Total card: Can open all locks in this system',
  },
  functionalcardParticularfeature: {
    checkOutCardBeforeTheLossWasReported: 'Check-out card before the loss was reported',
    theMissingCardNumber: 'The missing card number',
    pleaseEnterTheCardNumberToFind: 'Please enter the card number to find',
    theLostCardNumberIsRequired: 'The lost card number is required',
    lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard:
      'Lost card: If a card is lost, it can be reported. Enter the number of the lost card, make a lost card, and brush it once on the door that can open the lost card',
    checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard:
      'Check - out card: Used by the waiter. Generally, the waiter has two cards. One is the layer control card, used to open the door, and the other is the check - out card. When the guest notifies the check - out, the waiter checks the room, and the check - out card is brushed once on the door that can open the check - out card. The previous guest card cannot be opened, and does not affect the new guest card',
  },
  sdkinitIndex: {
    theLockInformationIsInitializedSuccessfullyProcedure:
      'The lock information is initialized successfully. Procedure',
    afterEnteringTheCardManagement: 'After entering the card management',
    performTheInitialConfigurationOfDoorLockInformationFirst:
      'Perform the initial configuration of door lock information first',
    hardwareDeviceType: 'Hardware device type',
    hardwareBrand: 'Hardware brand',
    configurationInformation: 'Configuration information',
    thisParameterIsMandatory: 'This parameter is mandatory',
    initialConfiguration: 'Initial configuration',
    doorLockInformationConfiguration2: 'Door lock information configuration',
    theDoorLockInformationIsConfiguredSuccessfully:
      'The door lock information is configured successfully',
    configurationFailure: 'Configuration failure',
  },
  hotelBaseInfo: {
    basicInformation3: 'Basic Information',
    detailedInformation: 'Detailed Information',
    hotelFacilitiesAndServices: 'Facilities & Services',
    hotelPoliciesAndNotices: 'Hotel Policies and Notices',
  },
  hotelFloor: {
    floorInformationToBeDeveloped: 'Floor information, to be developed',
  },
  hotelPicture: {
    acquiesce: 'Acquiesce',
    theLatestTime: 'The latest time',
    theFarthestTime: 'The farthest time',
    batchDeletion: 'Batch deletion',
    undelete: 'Undelete',
    cover: 'Cover',
    firstMap: 'First map',
    setAsHotelCover: 'Set as hotel cover',
    noPictureInformationIsAvailable: 'No picture information is available',
    submit2: 'Submit',
    photoEditor: 'Photo editor',
    setAsTheFirstPictureOfTheRoomType: 'Set as the first picture of the room type',
    recentRevision: 'Last updated',
    appearance: 'Appearance',
    guestRoom: 'Guest room',
    publicFacilities: 'Public facilities',
    catering: 'Catering',
    surroundingEnvironment: 'Surrounding environment',
    theCoverImageAndFirstImageCannotBeDeletedDirectly:
      'The cover image and first image cannot be deleted directly',
    areYouSureToDeleteThePicture: 'Are you sure to delete the picture',
    operate: 'Operate',
    pleaseSelectAtLeastOnePicture: 'Please select at least one picture',
    pleaseSelectCategory: 'Please select category',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting:
      'Please upload the picture successfully before submitting',
    imagesCannotBeUploadedInBatchEditingMode: 'Images cannot be uploaded in batch editing mode',
    logoOnlyOne: 'Only one Logo image can be uploaded',
    logoSizeLimit: 'Logo image size cannot exceed 500KB',
    logoRatioError: 'Logo must be a 1:1 square image. Current size: {width}×{height}',

  },
  assemblyModifyinventoryprice: {
    unlimitedInventory: 'Unlimited inventory',
    stockLimit: 'Stock limit',
    modifiedPricePool: 'Modified price pool',
    soldInventory: 'Sold inventory',
  },
  hotelPreview: {
    viewPicture: 'View picture',
  },
  hotelRoomType: {
    batchImportRoomType: 'Batch Import Room Types',
    importTemplateFileName: 'RoomType_Import_Template.xlsx',
    downloadSuccess: 'Room type import template downloaded successfully',
    downloadFail: 'Failed to download room type import template',

    newHousingType: 'New housing type',
    partialWindow: 'Partial window',
    skylight: 'Skylight',
    closedWindow: 'Closed window',
    bayWindow: 'Bay window',
    hotelCode: 'Hotel code',
    roomTypeCode: 'Room type code',
    externalRoomTypeCode2: 'External room type code',
    whetherToSellOnline: 'Whether to sell online',
    bedType2: 'Bed type',
  },
  hotelRoom: {
    newRoom: 'New room',
    pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate:
      'Please arrange the room information according to the requirements in the template',
    downloadTemplate: 'Download template',
    downloadFailureData: 'Download failure data',
    batchImport: 'Batch import',
    floor2: 'Floor',
    building: 'Building',
    housingType: 'Housing type',
    faceEast: 'Face east',
    faceWest: 'Face west',
    faceSouth: 'Face south',
    faceNorth: 'Face north',
    stayAwayFromElevators: 'Stay away from elevators',
    nearTheStairs: 'Near the stairs',
    closeToTheRoad: 'Close to the road',
    windowWall: 'Window wall',
    decorativeFalseWindow: 'Decorative false window',
    theRoomNumberCannotBeEmpty: 'The room number cannot be empty',
    theFloorOnWhichTheRoomIsLocatedCannotBeEmpty:
      'The floor on which the room is located cannot be empty',
    theRoomTypeCannotBeEmpty: 'The room type cannot be empty',
    editSuccessfully: 'Edit successfully',
    newSuccess: 'New success',
    theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty:
      'The house type and name cannot be empty. The floor where the house resides cannot be empty',
    currentLimitSelect1FilePleaseRemoveAndAdd: 'Current limit Select 1 file, please remove and add',
    definitiveRemoval: 'Definitive removal',
    abnormalDataInformationTemplate: 'Abnormal data information template',
    xlsFormatOnly: 'Only XLS files are supported',
    dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt:
      'Data cannot be recovered after deleting the room. Are you sure to delete it',
  },
  hotelTypedetail: {
    newHousingType: 'New housing type',
    editRoomType: 'Edit room type',
    viewRoomType: 'View room type',
    basicInformation3: 'Basic Information',
    squareMeter: 'M²',
    bedSize: 'Bed size',
    extraBedCondition: 'Extra bed condition',
    internetAccess: 'Internet access',
    roomTypeFacilities: 'Room type facilities',
    roomTypeStatus: 'Room type status',
    saveAndSubmit: 'Save',
    roomTypeNameAMaximumOf50Characters: 'Room type name: maximum 50 characters',
    floorArea: 'Area (m²)',
    roomTypeEnglishName: 'Room type English name',
    floorType: 'Floor type',
    floor2: 'Floor',
    pleaseEnter1511: 'Please enter -1,5,11',
    chineseRemarks: 'Chinese remarks',
    capacity: 'Capacity (pax/bed)',
    englishRemarks: 'English remarks',
    externalRoomTypeCode2: 'External room type code',
    extraBed: 'Extra bed',
    internetAccess2: 'Internet access',
    roomInternetInformation: 'Room Internet Details',
    broadbandTariff: 'Broadband tariff',
    disposableToiletries: 'Disposable toiletries',
    bathroomType: 'Bathroom type',
    numberOfToilets: 'Number of toilets',
    computer: 'Computer',
    showerRoom: 'Shower room',
    smokeFreeInformation: 'Smoking policy',
    bathroom: 'Bathroom',
    pleaseEnterAnIntegerWithNoMoreThanTwoDigits:
      'Please enter an integer with no more than two digits',
    pleaseEnterAnIntegerGreaterThan0: 'Please enter an integer greater than 0',
    dataDuplicationPleaseConfirm: 'Data duplication Please confirm',
    pleaseEnterAValueOfAThreeDigitIntegerUpTo500:
      'Please enter a value of a three-digit integer up to 500',
    enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters:
      'Enter a maximum of two decimals and a maximum of 6 characters',
    pleaseEnterBuildingArea: 'Please enter building area',
    pleaseEnterTheCapacity: 'Please enter the capacity',
    pleaseEnterAnIntegerOfUpToTwoDigits: 'Please enter an integer of up to two digits',
    roomTypeNameCannotBeEmpty: 'Room type name cannot be empty',
    roomTypeNameCannotExceed50Characters:
      'Room type name cannot exceed 50 characters',
    theLengthCannotExceed30Characters: 'The length cannot exceed 30 characters',
    theTotalNumberOfRoomsCannotBeEmpty: 'The total number of rooms cannot be empty',
    theLengthCannotExceed60Characters: 'The length cannot exceed 60 characters',
    pleaseSelectBedSize: 'Select bed size',
    pleaseSelectWindowType: 'Select window type',
    pleaseSelectRoomTypeStatus: 'Select room type status',
    pleaseSelectExtraBedCondition: 'Select extra bed condition',
    pleaseSelectWhetherYouCanAccessTheInternet: 'Select whether you can access the Internet',
    pleaseSelectAPhone: 'Select a phone',
    pleaseSelectDisposableToiletries: 'Select disposable toiletries',
    pleaseSelectABathroomType: 'Select a bathroom type',
    pleaseSelectTheNumberOfBathrooms: 'Select the number of bathrooms',
    pleaseSelectComputer: 'Select computer',
    pleaseSelectABathRoom: 'Select a bath room',
    pleaseSelectSmokeFreeInformation: 'Select Smoke-free information',
    pleaseSelectOther: 'Select other',
    pleaseSelectBathroom: 'Select bathroom',
    commonFloor: 'Common floor',
    executiveFloor: 'Executive floor',
    businessFloor: 'Business floor',
    noExtraBed: 'No extra bed',
    freeExtraBed: 'Free extra bed',
    payExtraBed: 'Pay extra bed',
    haveInternetAccess: 'Have Internet access',
    someInternetAccess: 'Some Internet access',
    noInternetAccess: 'No Internet access',
    freeWireless: 'Free wireless',
    tollWireless: 'Toll wireless',
    freeWire: 'Free wire',
    tollWire: 'Toll wire',
    nationalTollCall: 'National toll call',
    internationalCall: 'International call',
    freeDomesticLongDistanceCalls: 'Free domestic long distance calls',
    disposableToiletriesAreNotProvided: 'Disposable toiletries are not provided',
    disposableToiletriesAreProvidedForFree: 'Disposable toiletries are provided for free',
    disposableToiletriesAreProvidedForAFee: 'Disposable toiletries are provided for a fee',
    indoor: 'Indoor',
    commonality: 'Commonality',
    aroom: 'A (room)',
    twoRooms: 'Two rooms',
    moreThanTwoRooms: 'More than two rooms',
    allRoomsChargeComputers: 'All rooms charge computers',
    freeComputersInAllRooms: 'Free computers in all rooms',
    freeComputersInSomeRooms: 'Free computers in some rooms',
    nonSmokingRoomsAreNotAvailable: 'Non-smoking rooms are not available',
    nonSmokingRoomsAvailable: 'Non-smoking rooms available',
    noSmoking: 'No smoking',
    partialWindow: 'Partial window',
    skylight: 'Skylight',
    closedWindow: 'Closed window',
    bayWindow: 'Bay window',
    roomTypeNameAndBedSizeAreUnderReview: 'Room type name and bed size are under review',
    roomTypeAddedSuccessfully: 'Room type added successfully',
    containsAMaximumOf7CharactersOnlyDigitsCanBeEntered:
      'Contains a maximum of 7 characters. Only digits can be entered',
    pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters:
      'Please enter an integer and ensure its legality: such as 3 square meters - 5 square meters',
    personbed: 'Pax/bd',
    floor: 'F',
    person: 'Pax',
    bed: 'Bd',
    personPerBed: 'Pax/bd',
    floorShort: 'F',
  },
  managementAccountList: {
    searchAccountAndEmployeeName: 'Search account and employee name',
    staffPosition: 'Staff position',
    createAnAccount: 'Create an account',
    employeeName: 'Employee name',
    employeeRole: 'Employee role',
    confirmTo: 'Confirm to',
    user: 'User',
    areYouSureYouWantToDeleteThisUser: 'Are you sure you want to delete this user',
    isThisMaterial: 'Is this material',
  },
  managementRoleList: {
    enterARoleName: 'Enter a role name',
    newRole: 'New role',
    roleName: 'Role name',
    roleDescription: 'Role description',
    editorRole: 'Editor role',
    modifyPermission: 'Modify permission',
    deletingARole: 'Deleting a role',
    areYouSureYouWantToDeleteThisRole: 'Are you sure you want to delete this role',
  },
  componentsCreateaneditingrole: {
    roleName: 'Role name',
    roleDescription: 'Role description',
    standardPostBased: 'Standard post based',
    limitsOfAuthority: 'Limits of authority',
    pleaseEnterARoleName: 'Please enter a role name',
    modifyRole: 'Modify role',
    newRole: 'New role',
    succeededInModifyingTheRole: 'Succeeded in modifying the role',
    creatingTheRoleSucceeded: 'Creating the role succeeded',
  },
  componentsPopupeditingpermission: {
    editPermission: 'Edit permission',
  },
  componentsUpdatematerial: {
    staffPosition: 'Staff position',
    employeeRole: 'Employee role',
    thePhoneNumberCannotBeEmpty: 'The phone number cannot be empty',
    pleaseEnterYourConfirmationPassword: 'Please enter your confirmation password',
    pleaseEnterEmployeeName: 'Please enter employee name',
    pleaseSelectEmployeeStatus: 'Select employee status',
    pleaseSelectAnEmployeePosition: 'Select an employee position',
    modifyAccount: 'Modify account',
    viewInformation: 'View information',
    addAnAccount: 'Add an account',
    theTwoPasswordEntriesAreDifferent: 'The two password entries are different',
    modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation:
      'Modifying the material information may affect the information about stored goods. Exercise caution when performing this operation',
    materialUnit: 'Material unit',
    pleaseSelectTheMaterialType: 'Select the material type',
    pleaseFillInTheMaterialName: 'Please fill in the material name',
    pleaseSelectMaterialUnit: 'Select material unit',
    modifyMaterial: 'Modify material',
    newMaterial2: 'New material',
    materialModificationSucceeded: 'Material modification succeeded',
    newMaterialSuccessfully: 'New material successfully',
    pleaseEnterTheCorrectPhoneNumber3: 'Please enter the correct account',
  },
  smallwareMaterial: {
    confirmEnable: 'Enable this item?',
    confirmDisable: 'Disable this item?',
    enableSuccess: 'Item enabled successfully',
    disableSuccess: 'Item disabled successfully',
    newMaterial: 'New material',
    thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse:
      'There is inventory under the current material, do not support to delete the material, please delete after the warehouse',
    areYouSureYouWantToDeleteThisMaterial: 'Are you sure you want to delete this material',
    confirmTo: 'Confirm to',
    isThisMaterial: 'Is this material',
  },
  smallwareRealtimestock: {
    saleStatus: 'Sale status',
    exportedInventory: 'Exported inventory',
    resumptionOfSale: 'Resumption of sale',
    banOnSale: 'Ban on sale',
    averagePurchasePriceyuan: 'Average purchase price ',
    sellingPriceyuan: 'Selling price ',
    unmarketable: 'Unmarketable',
    vendibility: 'Vendibility',
    areYouSureYouWantToStopSellingThisMaterial:
      'Are you sure you want to stop selling this material',
    successfulClosure: 'Successful closure',
    successfulResumptionOfSale: 'Successful resumption of sale',
    exportFileName: 'Real-time inventory list',
  },
  smallwareStockshift: {
    undoSuccessfully: 'Undo successfully',
    outboundTime: 'Outbound time',
    newDelivery2: 'New delivery',
    outboundMode: 'Outbound mode',
    theNumberOfTheWarehouseReceipt: 'The number of the warehouse receipt',
    deliveryFromStorage: 'Delivery from storage',
    cancel: 'Cancel',
    exportFileList: 'Export file list',
    doYouConfirmTheCancellation: 'Do you confirm the cancellation?',
  },
  smallwareStockunshift: {
    warehousingTime: 'Warehousing time',
    newStorage: 'New storage',
    theCodeOfTheEntrySlip: 'The code of the entry slip',
    purchasePriceyuan: 'Purchase price ',
    importFileExportList: 'Import file export list',
  },
  componentsAddnewstock: {
    adjustableQuantity: 'Adjustable quantity',
    purchasePrice: 'Purchase price',
    whetherToSell: 'Whether to sell',
    unitSellingPrice: 'Unit selling price',
    pleaseFillInTheUnitPrice: 'Please fill in the unit price',
    pleaseFillInTheQuantityOfStorage: 'Please fill in the quantity of storage',
    pleaseSelectTheMaterialType: 'Select the material type',
    pleaseSelectAMaterialName: 'Select a material name',
    modifiedEntry: 'Modified entry',
    newStorage: 'New storage',
    createdSuccessfully2: 'Created successfully',
    theStorageQuantityCannotBe: 'The storage quantity cannot be',
    theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity:
      'The modified quantity cannot be smaller than the consumed quantity',
  },
  componentsAddoutstock: {
    selected: 'Selected',
    newDelivery2: 'New delivery',
    pleaseSelectOutgoingMaterials: 'Select outgoing materials',
    pleaseSelectTheMaterialToBeShippedOut: 'Select the material to be shipped out',
    successfulDelivery: 'Successful delivery',
  },
  componentsSellricedialog: {
    unitSellingPrice: 'Unit selling price',
    pleaseFillInThePrice: 'Please fill in the price',
  },
  systemsetBase: {
    requireIdNumberEnabled: 'ID number requirement has been enabled successfully',
    requireIdNumberDisabled: 'ID number requirement has been disabled successfully',
    requireIdNumberForCheckin: 'Require ID number when checking in',
    enableAutomaticDepositRefund: 'Enable automatic deposit refund',
    refundImmediatelyAfterCheckOut: 'Refund immediately after guest checkout',
    refundAfter: 'Refund after',
    hoursAutoRefund: 'hours automatically',
    pleaseEnterDelayRefundHours: 'Please enter the delay refund hours',
    delayRefundHoursRangeError: 'Delay refund time must be between 1 and 48 hours',
    depositConfigSuccess: 'Deposit configuration saved successfully',
    tempMakeCardEnabled: 'Enable temporary card issuing',
    tempMakeCardEnabledSuccess: 'Temporary card issuing enabled',
    tempMakeCardDisabledSuccess: 'Temporary card issuing disabled',
    hideCheckInRegisterRoomPrice: 'Hide room rate on check-in registration form',
    hideCheckInRegisterRoomPriceEnabledSuccess: 'Room rate hidden on check-in registration form',
    hideCheckInRegisterRoomPriceDisabledSuccess: 'Room rate shown on check-in registration form',
    weeHours: 'Wee hours',
    shiftPattern: 'Shift pattern',
    messageVoiceReminder: 'Message voice reminder',
    directConnectionSingleSettings: 'Direct connection single Settings',
    automaticHouseSetting: 'Automatic house setting',
    sameDayAdvanceOrders: 'Same-day advance orders',
    allOrders: 'All orders',
    unreservedRoomOrderAutomaticRoomSchedulingPeriod:
      'Unreserved room order automatic room scheduling period',
    inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted:
      'In this time period, the unreserved room order will be automatically executed',
    inventorySyncSetup: 'Inventory sync setup',
    orderSynchronizationSettings: 'Order synchronization Settings',
    nightAuditSetup: 'Night audit setup',
    nightTrialMethod: 'Night trial method',
    manualOperation: 'Manual operation',
    auto: 'Auto',
    storeOrdersHaveNotArrived: 'Store orders have not arrived',
    preArrivalDepartureHandle: 'Pre-arrival & Pre-departure Order Handling',
    preArrivalDepartureHandleTip: 'Configure automatic handling for pre-arrival and pre-departure orders. The system will automatically execute the corresponding operations during night audit',
    preArrivalHandle: 'Pre-arrival Order Handling',
    preDepartureHandle: 'Pre-departure Order Handling',
    noHandle: 'No handling',
    autoCheckIn: 'Auto check-in',
    autoNoshow: 'Auto no-show',
    autoCheckOut: 'Auto check-out',
    autoExtendStay: 'Auto extend stay',
    autoSkip: 'Auto skip',
    shiftSetting: 'Shift setting',
    noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay:
      'No overlap is allowed and the total time interval must cover 24 hours of the day',
    morningShiftSetting: 'Morning shift setting',
    shiftReportimprestMode: 'Shift report (imprest mode)',
    hourRoomCheckOutMessage: 'Hour room check out message',
    fullDayCheckOutMessage: 'Full day check-out message',
    onlineChannelNewOrderAlerts: 'Online channel new order alerts',
    onlineChannelOrderCancellationAlerts: 'Online channel order cancellation alerts',
    hourCheckOutReminder: 'Hour check-out reminder',
    fullDayCheckOutReminder: 'Full day check-out reminder',
    automaticOrderSettingWhenOversold: 'Automatic order setting when oversold',
    hourRoomAutomaticOrderSetting: 'Hour room automatic order setting',
    automaticRowHouseConfiguration: 'Auto-Assign Rooms configuration',
    automaticHouseRules: 'Automatic house rules',
    supportBillingTypes: 'Support billing types',
    '30MinutesBeforeCheckOut': '30 minutes before check-out',
    '15MinutesBeforeCheckOut': '15 minutes before check-out',
    atCheckOut: 'At check-out',
    pleaseEnterTheTime: 'Please enter the time',
    automaticCancellation: 'Automatic cancellation',
    manualCancellation3: 'Manual cancellation',
    automaticOverbookingSetReminders: 'Automatic overbooking set reminders',
    hourRoomAutomaticOrderSettingReminder: 'Hour room automatic order setting reminder',
    autoEnterArAccountText: 'Direct connection orders automatically posted to AR',
    pleaseSelectABusinessDay: 'Please select a business day',
    operationSuccessfulPleaseManuallyTriggerTheNightAudit:
      'Operation successful, please manually trigger the night audit',
    theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame:
      'The start time and end time of the morning shift cannot be the same',
    earlyMorningWatch: 'Early morning watch',
    theAutomaticRowHouseIsSetSuccessfully: 'The Auto-Assign Rooms is set successfully',
    theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull:
      'The eb room status is automatically closed when the room is full',
    supportSwitchOrderSynchronization: 'Support switch order synchronization',
    inventoryAutomaticSynchronizationSystemInventory:
      'Inventory automatic synchronization system inventory',
    whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation:
      'Pre-departure stay extension has higher priority than pre-arrival check-in. If there are no available rooms when the system automatically processes check-in, it will automatically mark as NoShow; if there are no available rooms when the system automatically processes stay extension, it will automatically check out',
    whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing:
      'Pre-departure stay extension has higher priority than pre-arrival check-in. If there are no available rooms when the system automatically processes check-in, it will automatically mark as NoShow; if there are no available rooms when the system automatically processes stay extension, it will automatically check out',
    whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff:
      'When the room is full, the eb room status switch is automatically turned off',
    inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved:
      'Inventory automatic synchronization system inventory switch Settings saved',
    atLeastOneMessageReminderSettingMustBeSelected:
      'At least one message reminder setting must be selected',
    closeturnOnToAutomaticallySortRoomsAtNight:
      'Close (turn on to automatically sort rooms at night)',
    crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations:
      'Cross - business day shifts, you can set the night shift separately for accounting purposes. The night shift does not participate in normal shift time calculations',
    dailyPredeparture: 'Daily predeparture',
    theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving:
      'The hotel supports synchronous switch order channel Settings saving',
    theNightAuditTimeMustBeBetween2100And0800TheNextDay:
      'The night audit time must be between 21:00 and 08:00 the next day',
    theScheduleNeedsToCover24HoursADayPleaseReset:
      'The schedule needs to cover 24 hours a day, please reset',
    showMemberRechargeAmount: 'Display member recharge amount in handover report',
    splitDeposit: 'Split deposit in handover report',
    splitArAccount: 'Split AR account in handover report',
    allowTimeConflict: 'Allow room scheduling time conflict',
    selfCheckInDepositSetting: 'Self check-in deposit setting',
    depositConfig: 'Deposit configuration',
    defaultDepositAmount: 'Default deposit amount',
    defaultDepositError: 'Invalid default deposit amount, please re-enter',
    roomDepositError: 'Room type "{roomName}" setting error, please reset',
    additionalRoomFeeSetting: 'Additional room charge setting',
    fulldayAddFeeRule: 'Full-day surcharge rule',
    fulldayAddFeeType: 'Full-day surcharge type',
    memberRechargeSetting: 'Member prepaid payment setting',
    noVerificationPayment: 'No verification payment',
    enforceAdditionalRoomCharge: 'then enforce additional room charge',
    manualAdditionalRoomFee: 'Manual additional room fee',
    halfDayAdditionalRoomFee: 'Half-day additional room fee',
    fullDayAdditionalRoomFee: 'Full-day additional room fee',
    popUpMethodSetting: 'New page open method',
    newTab: 'Open new tab',
    originalTabRedirection: 'Original tab redirection',
    popupNotification: 'Popup',
    sidebar: 'Right-side drawer',
    morningOrderCheckInAddFee: 'Charge additional room fee for early check-in',
    morningOrderAddFeeEnabled: 'Additional room fee for early check-in is enabled',
    morningOrderAddFeeDisabled: 'Additional room fee for early check-in is disabled',
    breakfastReportCtrl: 'Breakfast report statistics rules',
    repotShowByUserNums: 'Statistics by actual number of guests',
    repotShowByProductNums: 'Statistics by room included breakfast quantity',
    breakfastReportCtrlSuccessByUserNums: 'Breakfast report statistics rule has been set to "Statistics by actual number of guests"',
    breakfastReportCtrlSuccessByProductNums: 'Breakfast report statistics rule has been set to "Statistics by room included breakfast quantity"'
  },
  systemsetConditionConfig: {
    unspaced: 'Unspaced',
    arrangeByFloorBranch: 'Arrange by floor branch',
    lineUpByRoomType: 'Line up by room type',
    theSizeOfTheCell: 'The size of the cell',
    small: 'Small',
    inThe: 'In the',
    big: 'Big',
    wide: 'Wide',
    high: 'High',
    custom: 'Custom',
    roomTypeFont: 'Room type font',
    size: 'Size',
    colour: 'Colour',
    roomNumberFont: 'Room number font',
    whetherFullGuestNamesAreDisplayed: 'Whether full guest names are displayed',
    alreadyRowHouseStatusDisplayContent: 'Already row house status display content',
    alreadyRowHouseStatusDetailsDisplayContent: 'Already row house status details display content',
    noRowRoomStatusDetailsDisplayContent: 'No row room status details display content',
    arrearsIncludeToday: 'Does the outstanding balance include the room charges pending for today',
    bedType2: 'Bed type',
    restoreDefault: 'Restore default',
    roomDiagramArrangement: 'Room diagram arrangement',
    theAppletTakesEffectAtTheSameTime: 'The applet takes effect at the same time',
    cellColor: 'Cell color',
    unarrangedRoomStatusContent: 'Unarranged room status display content',
    powerSwitch: 'Power Switch',
    roomBalance: 'Room Balance',
    depositAmount: 'Deposit Amount',
  },
  systemsetConfiguration: {
    changePriceRangeSettings: 'Change price range Settings',
    revaluationRange: 'Revaluation range',
    theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed:
      'The system will judge whether the average price of each room type in the past 30 days exceeds the change - price range. If so, the change - price will be entered into the change - price audit, and the price will be effective after the audit. The change - price will be automatically rejected after 1 hour if it is not processed',
  },
  systemsetLog: {
    operationRecord: 'Operation record',
  },
  systemsetPrint: {
    documentType: 'Document type',
    paperSize: 'Paper size',
    typeSize: 'Type size',
    printingMode: 'Printing mode',
    noticeToGuests: 'Notice to guests',
  },
  systemsetTarget: {
    monthlyGoalSetting: 'Monthly goal setting',
    goal: 'Goal',
    goalAchievementRate: 'Goal achievement rate',
    intertargetNight: 'Intertarget night',
    targetOccupancyRate: 'Target occupancy rate',
    recommendedTargetValue: 'Recommended target value',
    actualAchievement: 'Actual achievement',
    reachedLastMonth: 'Reached last month',
    theSamePeriodLastYear: 'The same period last year',
    commitFailure: 'Commit failure',
  },
  systemsetWarning: {
    earningsWarning: 'Earnings warning',
    dailyWarning: 'Daily warning',
  },
  systemsetWifi: {
    commonality: 'Commonality',
    batchModification: 'Batch modification',
    pleaseCompleteTheWiFiAccountPassword: 'Please complete the Wi-Fi account password',
    pleaseEnterAValidWifiName: 'Please enter a valid WiFi name',
    noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn:
      'No password or phone-authenticated WiFi does not require filling in',
    pleaseFillInTheWiFiAccount: 'Please fill in the Wi-Fi account',
    roomWifiSettings: 'Room WiFi Settings',
    wifiName: 'WiFi Name',
    wifiPassword: 'WiFi Password',
  },
  assemblyBindavailableproducts: {
    bindAvailableProducts: 'Bind available products',
    bindAtLeastOneProduct: 'Bind at least one product',
  },
  pullnewQrcode: {
    aboutHalfA4: 'About half of A4 paper',
    sizeLarge: 'Large',
    sizeSmall: 'Small',
    sizeMedium: 'Medium',
    lShapedStand: 'L-shaped table card',
    paperSize: 'Paper size',
    displayStandType: 'Type display stand',
    downloadPicture: 'Download picture',
    memberPullNewCodeGenerationPleaseWait: 'Member pull new code generation, please wait',
    memberPoster: 'Member poster',
    frontDeskStaff: 'Front desk staff',
    foreground: 'Foreground',
    commonArea: 'Common area',
    corridor: 'Corridor',
    elevator: 'Elevator',
    displayStand: 'Display stand',
  },
  pullnewMember: {
    memberInformationEntry: 'Member information entry',
    areRequiredFieldsOtherFieldsAreNotRequired:
      'Are required fields, other fields are not required',
    idNumber: 'Id Number',
    inputResult: 'Input result',
    recordSuccessfully: 'Record successfully',
    entryFailure: 'Entry failure',
    memberSale: 'Member sale',
    enter: 'Enter',
    passport: 'Passport',
    pleaseEnterTheIdNumber: 'Please enter the ID number',
    theNameFormatIsIncorrect: 'The name format is incorrect',
    theMobilePhoneNumberCannotBeEmpty: 'The mobile phone number cannot be empty',
    theMobilePhoneNumberFormatIsIncorrect: 'The mobile phone number format is incorrect',
    theFormatOfTheIdCardNumberIsIncorrect: 'The format of the ID card number is incorrect',
    memberInformationEnteredSuccessfully: 'Member information entered successfully',
  },
  pullnewNewlist: {
    promoter: 'Promoter',
    pullTime: 'Pull time',
    pleaseEnterYourPromoterName: 'Please enter your promoter name',
    memberNickname: 'Member nickname',
    pulsingType: 'Pulsing type',
  },
  componentsWarning: {
    byTheMonth: 'By the month',
    achievedOnDays: 'Achieved on days',
    below: 'Below',
    viewRemainingConditions: 'View remaining conditions',
    newEarlyWarningItems: 'New early warning items',
    achieved: 'Achieved',
    additionalCondition: 'Additional condition',
    internightMoonTargetReachWarning: 'Internight moon target reach warning',
    earlyWarningOfMonthlyTargetOfRentalRate: 'Early warning of monthly target of rental rate',
    surplusRoom: 'Surplus room',
    pointScoring: 'Point scoring',
    gmvMonthlyTargetWarning: 'GMV Monthly Target Achievement Warning',
    revparMonthlyTargetWarning: 'RevPAR Monthly Target Achievement Warning',
  },
  componentsWarningday: {
    overallHotel: 'Overall hotel',
    everyday: 'Everyday',
    theDayBefore: 'The day before',
    viewRemainingConditions: 'View remaining conditions',
    newEarlyWarningItems: 'New early warning items',
    additionalCondition: 'Additional condition',
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    pointScoring: 'Point scoring',
    surplusRoom: 'Surplus room',
  },
  payLehuipaySetting: {
    youHaveNotOpenedOnlinePayment: 'You have not opened online payment',
    contactOperationOrTechnicalSupportToEnableTheService:
      'Contact operation or technical support to enable the service',
    lehuiPay: 'Lehui Pay',
    download: 'Download',
    inquire: 'Inquire',
    withdraw: 'Withdraw',
    withdrawalRecord: 'Withdrawal record',
    billDownload: 'Bill download',
    accountBalanceInquiry: 'Account balance inquiry',
    theWithdrawalAmountIsRequired: 'The withdrawal amount is required',
    theAmountRangeIs: 'The amount range is',
    doYouWantToChangeThePaymentMethod: 'Do you want to change the payment method',
    modifyingThePaymentModeSucceeded: 'Modifying the payment mode succeeded',
    pleaseFillInTheWithdrawalAmount: 'Please fill in the withdrawal amount',
    ifTheWithdrawalFailsTheWithdrawalAmountCannotBeLessThan10Yuan:
      'If the withdrawal fails, the withdrawal amount cannot be less than 10 ',
  },
  foodLogin: {
    cashierSystem: 'Food Cashier System',
    shopSystem: 'Food Merchant System',
    pleaseEnterYourAccount: 'Please enter your account',
    noFoodSystemPermission: 'You do not have permission to access the {system}',
    systemConfigurationError: 'System configuration error, please contact technical support',
    loginFailed: 'Login failed, please try again later',
  },
  loginIndex: {
    hotelManagementSystem: 'Hotel management system',
    qrCodeExpired: 'QR code expired',
    pleaseClickRefresh: 'Please click refresh',
    openWechatScanTheQrCode: 'Open WeChat, scan the QR code',
    customerServiceNumber: 'Customer service number',
    theAccountOrPasswordYouEnteredIsIncorrect: 'The account or password you entered is incorrect',
    forgotPassword: 'Forgot password',
    verificationCodeSentToYourMobilePhoneValidFor5Minutes:
      'Verification code sent to your mobile phone, valid for 5 minutes',
    enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes:
      'Enter 8-20 characters, including letters, numbers, and symbols of two or more types',
    submit2: 'Submit',
    loginPasswordUpdateSuccessful: 'Login password update successful',
    reLogin: 'Re - login',
    bind: 'Bind',
    findPassword: 'Find password',
    pleaseEnterTheVerificationCode: 'Please enter the verification code',
    mobilePhoneSmsVerificationCode: 'Mobile phone SMS verification code',
    pleaseEnterTheMobilePhoneVerificationCode: 'Please enter the mobile phone verification code',
    pleaseVerifyTheNewPassword: 'Please verify the new password',
    bindWechat: 'Bind WeChat',
    pleaseEnterTheLoginPassword: 'Please enter the login password',
    theTwoPasswordsEnteredAreInconsistent: 'The two passwords entered are inconsistent!',
    pleaseEnterTheVerificationCode3: 'Please enter the verification code',
    loggingIn: 'Logging in',
    acquire: 'Acquire',
    resendVerificationCode: 'Resend verification code',
    loginNow: 'Login now',
    currentPhoneNumber: 'Current phone number',
    changeSuccessful: 'Change successful',
    afterReGetting: 'After re - getting',
    pleaseEnterCorrectAccount: 'Please enter a valid account',
  },
  pcncomponentRoomtypesortingcomponent: {
    roomTypeRanking: 'Room type ranking',
  },
  componentsPrintsettingdialog: {
    previewEditing: 'Preview editing',
    printTheFullIdNumber: 'Print the full ID number',
    printGuestAddress: 'Print guest address',
    printPaymentInformation: 'Print payment information',
    modifySettings: 'Modify Settings',
    documentType: 'Document type',
    paperSize: 'Paper size',
    typeSize: 'Type size',
    printingMode: 'Printing mode',
    noticeToGuests: 'Notice to guests',
    thisContentWillBeDisplayedOnTheDocumentWhenPrintingPleaseBeSureToPrintATestAfterFillingInTheDocumentToAvoidTheDisplayEffectAffectedByTheNumberOfLinesOrExcessiveWords:
      'This content will be displayed on the document when printing. Please be sure to print a test after filling in the document to avoid the display effect affected by the number of lines or excessive words',
    defaultPrint: 'Default print',
    manualSelection: 'Manual selection',
    standard: 'Standard',
    larger: 'Larger',
    pleaseSelectPaperSize: 'Select paper size',
    pleaseSelectAPrintingMethod: 'Select a printing method',
    pleaseSelectTheSize: 'Select the size',
  },
  assemblyAddprojectdialog: {
    addItem: 'Add item',
    projectName: 'Project name',
    pleaseEnterAProjectName: 'Please enter a project name',
    copies: 'Copies',
    pleaseEnterTheNumberOfCopies: 'Please enter the number of copies',
    pleaseEnterTheNameOfTheOffer: 'Please enter the name of the offer',
    theNumberOfCopiesMustBeGreaterThan: 'The number of copies must be greater than',
  },
  viewsHomePageIndex: {
    commonFunctions: 'Common Functions',
    roomStatusOverview: 'Room Status Overview',
    todayData: "Today's Data",
    thisMonthData: "This Month's Data",
    dataAsOf: 'As of: ',
    todoList: 'To-do List',
    allRead: 'Mark All as Read',
    noTodos: 'You have completed all to-do items',
    efficientDay: 'What an efficient day!',
    logUpdates: 'Log Updates',
    selectedFunctionsTitle: 'Selected Functions',
    selectedFunctionsTip: 'Drag to sort; select at least 1 function',
    maxSix: 'Select up to 6 functions',
    allReadSuccess: 'All marked as read',
  },
  viewsReportFinanceOnlinePaymentReconciliation: {
    tradeDate: 'Trade Date',
    billType: 'Bill Type',
    platform: 'Payment Platform',
    qzTradeNo: 'Payment Transaction No.',
    qzTradeNoPlaceholder: 'Please enter payment transaction no.',
    amountTotal: 'Total Amount',
    feeTotal: 'Total Fees',
    reportName: 'Online Reconciliation Report',
    pleaseSelectAtLeastOneDateType: 'Select at least one date type',
    income: 'Receipt',
    alipay: 'Alipay',
    wechat: 'WeChat',
    merchantCode: 'Merchant Code',
    merchantName: 'Merchant Name',
    qzTradeNoColumn: 'Payment Transaction No.',
    externalOrderNo: 'External Order No.',
    orderAmount: 'Order Amount',
    merchantRate: 'Merchant Rate',
    commission: 'Commission',
    billTypeColumn: 'Bill Type',
    finishTime: 'Completion Time',
    oriQzTradeNo: 'Original Receipt Order No.',
    platformColumn: 'Payment Platform',
  },
  appShop: {
    label1: '🔥 Save 25% on payment commission',
    label2: '💰 Must-read for merchants: Save thousands per month in fees',
    label3: '⚠ Still struggling with high cash-out fees?',
    label4: '⏳ First 100 sign-ups get a QR code box',
    label5: '❓ Why do major brands choose this payment solution?',
    label6: '🛡 Bank-grade security | Trusted by thousands of merchants',
    label7: '📞 Apply now | Rates drop by 25%',
    label8: '💼 Hotel owner story: Earned an extra $430/month*',
  },
  settleDialog: {
    entryRoom: 'Posting Room',
    selectEntryRoom: 'Please select a posting room',
    confirmTotalRoomRate: 'Confirm Total Room Rate',
    preAuthorizationSettlement: 'Pre-Authorization Settlement',
    completeCheckout: 'Complete Checkout',
    additionalChargeAmount: 'Additional Charge Amount',
    inputAdditionalAmount: 'Please enter additional amount',
    detail: 'Details',
    noAdditionalCharge: 'No Additional Charge',
    generateRoomFee: 'Generate Room Fee',
    hangToMaster: 'Post to Master Order',
    hangAccountReason: 'Posting Reason',
    hangAccountTip:
      'Tip: When posting to master order, system will transfer unsettled bills to master order and checkout automatically',
    selectAtLeastOneRoom: 'Please select at least one room order',
    transferBeforeHangAccount:
      'Please transfer out rooms in “Pending Check-in” before hanging account',
    pleaseAddRoomFee: 'Please add the room fee first',
    noRoomOrderFound: 'No room order numbers found, please refresh the page and try again',
    hourlyRoomTip: 'Hourly Room: Please confirm the actual room charge',
    fullDayRoomTip: 'Full Day Room: Please enter additional charge if needed',
    hangAccount: 'Post Charge',
  },
  notUploadList: {
    searchPlaceholder: 'Enter name or room number',
    uploadStatus: 'Upload Status',
    notUploaded: 'Not Uploaded',
    uploaded: 'Uploaded',
    loggedOut: 'Checked Out',
    downloadAllGuestInfo: 'Download All Guest Info',
    idAddress: 'ID Address',
    uploadStatusColumn: 'Police Upload Status',
    downloadInfo: 'Download Info',
    finishUpload: 'Mark as Uploaded',
  },
  notification: {
    markAllRead: 'Mark all as read',
    expand: 'Expand ({count})',
    collapse: 'Collapse ({count})',
    ignore: 'Ignore',
  },
  adjustFinance: {
    title: 'Adjust Finance',
    adjustAccount: 'Adjust',
    balanceZeroWarning: 'Please make sure the balance is zero before submitting',
    addOneRecordWarning: 'Please add at least one entry record',
  },
  roomStatusStatistics: {
    details: 'Details',
  },
  hotelStateDialog: {
    title: 'Room Status Statistics',
    checkIn: 'Occupied',
    prepareCheckIn: 'Expected Check-in',
    sold: 'Sold',
    available: 'Available',
    fetchError: 'Failed to fetch room type data',
  },
  futureRoomIndex: {
    quickSearch: 'Quick Search',
    reEnable: 'Re-enable',
    confirmChangeRoomTitle: 'Replace the original room with the new one?',
    originalRoom: 'Original Room',
    newRoom: 'New Room',
    dragTargetInvalid: 'Drag failed: target cell not found',
    selectSameRoomTypeSameStayDate: 'Select a room of the same room type with the same arrival and departure dates',
    differentRoomTypeSwapNotSupported: 'Swapping with an existing room order is not supported across room types',
    AVL: 'AVL.',
  },
  financePaymentIndex: {
    addPaymentSubject: 'Add Payment Subject',
    paymentSubjectName: 'Payment Subject Name',
    symbol: 'Symbol',
    confirmDelete: 'Are you sure you want to delete this subject?',
  },
  financeAccountDialog: {
    pleaseEnterSubject: 'Please enter the {type} subject',
    pleaseSelectCategoryType: 'Select the {type} category type',
    addTitle: 'Add {type} Subject',
    editTitle: 'Edit {type} Subject',
    subjectName: '{type} Subject',
    subjectCategory: '{type} Subject Category',
    isEnabled: 'Enabled',
  },
  financeConsumerAccount: {
    subjectCategory: 'Subject category',
    addSubject: 'Add subject',
    subjectName: 'Subject name',
    symbol: 'Symbol',
    confirmDelete: 'Are you sure you want to delete this subject?',
  },
  financeSubjectSorting: {
    consumeSortTitle: 'Consumer Subject Sorting',
    paySortTitle: 'Payment Subject Sorting',
    consumeSubjectName: 'Consumer Subject Name',
    paySubjectName: 'Payment Subject Name',
    sortSuccess: 'Sorting successful',
  },
  aiPms: {
    common: {
      noData: 'No data',
      aiDriven: 'AI Powered',
      justNow: 'Just now',
      minutesAgo: '{count} minutes ago',
      hoursAgo: '{count} hours ago',
    },
    aiConfig: { pageTitle: 'AI Configuration', save: 'Save', hotelSection: 'Hotel Configuration', roomTypeSection: 'Room Type Configuration', priceGuard: 'Price Guardrail', enabled: 'Enabled', disabled: 'Disabled', hotelFloorPrice: 'Hotel Floor Price', hotelCeilingPrice: 'Hotel Ceiling Price', floorPrice: 'Floor Price (CNY)', ceilingPrice: 'Ceiling Price (CNY)', floorPricePlaceholder: 'Enter floor price', ceilingPricePlaceholder: 'Enter ceiling price', yuan: 'CNY', roomTypeName: 'Room Type Name', roomTypeCode: 'Room Type Code', amountNonNegative: ' amount must be greater than or equal to 0', floorGreaterThanCeiling: ' floor price cannot exceed ceiling price', hotelLabel: 'Hotel', roomTypeLabel: 'Room type “{name}”', noChanges: 'No configuration changes detected', saveSuccess: 'Saved successfully', pricingSelloutTimeTitle: 'Target Sellout Time Policy', pricingSelloutTimeTip: 'Used for same-day price increases, slow-selling price reductions, and peer-traffic urgency.', custom: 'Custom Policy', legalHoliday: 'Legal Holiday', weekend: 'Friday and Saturday', defaultDate: 'Other Dates (including Sunday)', selectTime: 'Select time', pricingSelloutTimeInvalid: 'The sellout time policy returned by the server is invalid. Explicitly handle it before saving.', pricingSelloutTimeRequired: 'All target sellout times must use HH:mm and be within 14:00–23:59 or 00:00–06:00.' },
    roomPricingReport: { reportTitle: 'Room Type Pricing Report', reportTip: 'AI recommendations, operating basis, and pricing factors', hotelInfo: 'Hotel Information', sellDate: 'Sale Date', metricDate: 'Metric Business Date', hotelOcc: 'Current Hotel OCC', hotelRevpar: 'Current Hotel RevPAR', currentPrice: 'Current Price', aiRecommendedPrice: 'AI Recommended Price', aiCurrentDelta: 'AI vs. Current Price', sameDayOcc: 'Same-day OCC', sameDayRevpar: 'Same-day RevPAR', confidence: 'AI Confidence', inventorySnapshot: 'Sold / Available (Overbooked) / Disabled', operatingBasis: 'Room Type Operating Basis', aiDecision: 'AI Decision', tradeoff: 'Multi-factor Trade-off: ', aiFactors: 'AI Pricing Factors', historicalPrice: 'Historical Price', operation: 'Operating Data', market: 'Market Position', timeEvent: 'Time and Events', guardrailRisk: 'Guardrails and Risks', status: 'Status: ', priceImpact: 'Price Impact: ', conclusion: 'Conclusion: ', reason: 'Reason: ', evidence: 'Evidence: ', riskReminder: 'Risk Reminders', noRisk: 'No additional risk reminders', severity: 'Severity: ', suggestion: 'Suggested Action: ', used: 'Used', notUsed: 'Not Used', notAvailable: 'No Data Available', up: 'Supports Increase', hold: 'Hold', down: 'Supports Decrease', limit: 'Guardrail Limit', none: 'No Direct Impact', yes: 'Yes', no: 'No', yuan: 'CNY', priceAdjustment: 'Adjust Product Prices', priceAdjustmentDialogTitle: 'Smart Pricing: Adjust Product Prices', noAdjustableProducts: 'No adjustable products are available for this room type', roomTypeName: 'Room Type: ', roomTypeCode: 'Room Type Code: ', roomTypeCurrentPrice: 'Room Type Current Price', algorithmRecommendedPrice: 'Algorithm Recommended Price', aiAdjustmentDelta: 'AI Price Change', currencySymbol: '¥', snapshotPriceNote: 'AI recommendations are based on this smart-pricing notice snapshot.', product: 'Product: ', channel: 'Channel', channelId: 'Channel ID: {id}', channelCurrentPrice: 'Current Channel Sale Price', aiAdjustedPrice: 'AI-adjusted Sale Price', operationLabel: 'Action', oneClickAdjustment: 'Adjust Price', confirmGroupAdjustment: 'Adjust prices for {count} channels under this product?', confirmChannelAdjustment: 'Adjust the price for this channel product?', confirmAdjustmentTitle: 'Confirm Price Adjustment', confirm: 'Confirm', cancel: 'Cancel', adjustmentSuccess: 'Price adjusted successfully', bookingHourPreference: 'Booking preference by hour (last 7 days)', bookingHourNoData: 'No hourly booking data available', bookingHourDateRange: '{start} to {end}', bookingHourTooltip: '{hour}:00<br/>Booking share: {value}%' },
    roomPricingFeedback: { button: 'Accept', dialogTitle: 'Submit Feedback', accept: 'Accept', reject: 'Do Not Accept', rejectReasonPlaceholder: 'Please enter a reason for not accepting', actionRequired: 'Please select a feedback result', rejectReasonRequired: 'Please enter a reason for not accepting', rejectReasonTooLong: 'The reason for not accepting cannot exceed 100 characters', acceptSuccess: 'Recommendation accepted', rejectSuccess: 'Non-acceptance feedback submitted' },
    roomPricing: {
      empty: 'No pricing result available',
      roomTypeFallback: 'Room Type {index}',
      decisionTitle: 'Decision Summary',
      riskLabel: 'Risk: ',
      modeLabel: 'Mode: ',
      floorPriceLabel: 'Price Guardrail: ',
      confidenceLabel: 'Confidence: ',
      directionFlat: 'Keep Price',
      directionUp: 'Raise Price',
      directionDown: 'Lower Price',
      priorityLow: 'Low Priority',
      priorityMedium: 'Medium Priority',
      priorityHigh: 'High Priority',
    },
    roomPricingCard: { pricingTime: 'Pricing time: ', expand: 'Expand', collapse: 'Collapse' },
    noticeCenter: {
      unreadCount: '{count} unread',
      readAll: 'Mark all as read',
      defaultTitle: 'AI Notice',
      browserNotificationTitle: 'AI Notification',
      browserNotificationBody: 'You have received a new AI notification.',
      browserPermissionGuide: 'Enable browser notifications to receive new AI notifications in the background.',
      enableBrowserNotification: 'Enable notifications',
      skipBrowserNotification: 'Not now',
      statusRead: 'Read',
      statusUnread: 'Unread',
      emptySummary: 'No notice summary',
      like: 'Like',
      dislike: 'Dislike',
      viewDetail: 'View detail',
      markRead: 'Mark as read',
      emptyList: 'No notices',
      dislikeDialogTitle: 'Submit dislike reason',
      dislikePlaceholder: 'Please leave your suggestion',
      categoryAll: 'All',
      readAllSuccess: 'All notices marked as read',
      markReadSuccess: 'Marked as read',
      likeSuccess: 'Thanks for your feedback',
      dislikeReasonRequired: 'Please enter the dislike reason',
      dislikeSuccess: 'Submitted successfully',
      uncategorized: 'Uncategorized',
    },
    noticeDetail: {
      back: 'Back to AI notices',
      sendTime: 'Generated at: ',
      businessType: 'Primary category: ',
      businessSubType: 'Secondary category: ',
      sideLabel: 'Notice Detail',
      contentTitle: 'Notice Content',
      contentTip: 'Render the original notice in markdown style',
      badReviewTitle: 'Bad Review Details',
      badReviewTip: 'Show the review text and AI suggested reply',
      badReviewContent: 'Review Text',
      badReviewReply: 'Suggested Reply',
      structuredTitle: 'Structured Result',
      structuredTip: 'Show structured data and analysis by AI report sections',
      structuredEmptyTip: 'No displayable structured data was parsed from this content',
      missingNoticeNo: 'Missing noticeNo',
    },
    smartPricing: {
      pageTitle: 'Smart Pricing',
      empty: 'No latest smart pricing notice',
      peerHotelMonitor: {
        title: 'Competitor Traffic-driving Price Monitor',
        refresh: 'Refresh',
        meituan: 'Meituan',
        empty: 'No competitor traffic-driving price data',
        unnamedHotel: 'Unnamed competitor hotel',
        crawlSubmitted: 'Refresh the page later to view the data.',
      },
    },
    futurePricing: { realtimeTab: 'Realtime Pricing Reports', futureTab: 'Future Pricing Reports', reportTitle: 'Future Room Type Pricing Report', reportTip: 'View frozen pricing recommendations and analysis for the next 14 days', empty: 'No future room type pricing report is available', hotelOverview: 'Future Pricing Overview', priceSource: 'Price Source', pricingBusinessDate: 'Pricing Business Date', forecastDateRange: 'Forecast Date Range', to: 'to', confidence: '14-day Confidence', dailyEmpty: 'No daily pricing result is available', analysis: 'Analysis', aiDecision: 'AI Decision', decisionSummary: 'Decision Summary', pricingFactors: 'Pricing Factors', noFactor: 'No factor details are available', status: 'Status', priceImpact: 'Price Impact', reason: 'Reason', conclusion: 'Conclusion', tradeoff: 'Trade-off', riskReminder: 'Risk Reminders', noRisk: 'No risk reminder is available', severity: 'Severity', suggestion: 'Suggestion', sellDate: 'Sale Date', algorithmReferencePrice: 'Algorithm Reference Price', aiRecommendedPrice: 'AI Recommended Price', historicalExpectedOcc: 'Historical Expected OCC', historicalExpectedRevpar: 'Historical Expected RevPAR', holidayEvent: 'Holiday / Event', systemRisk: 'System Risk', yes: 'Yes', no: 'No', legalHoliday: 'Legal Holiday', weekendPeak: 'Weekend Peak', normalDate: 'Regular Date', reportGeneratedAt: 'Report Generated At', listEmpty: 'No completed future pricing report is available', selectDate: 'Select date', dailyAverageOrders: 'Average Daily Orders in Last 7 Days', viewAllReports: 'View All Reports', backToAllReports: 'Back to Report List', realtimeListEmpty: 'No completed room type pricing report is available' },
    futurePricingCalendar: { calendarTitle: 'Future Room Type Pricing Calendar', roomType: 'Room Type', expectedOcc: 'Expected OCC', expectedRevpar: 'Expected RevPAR', pricingBasis: 'Pricing Basis', dataIntegrityRisk: 'Data Integrity Reminder / Risk Notice', highRisk: 'High Risk', calendarEmpty: 'No future pricing calendar data is available', priceUp: 'Increase', priceDown: 'Decrease', priceHold: 'Hold', overallPricingBasis: 'Overall Pricing Basis', roomOverallRisk: 'Room Type Overall Risk Reminder', dailyRiskReminder: 'Daily Risk Reminder' },
    storeManagerReport: {
      pageTitle: 'Store Manager Report',
      pageDesc: 'View the latest daily, weekly, and monthly report results.',
      dailyButton: 'Daily',
      weeklyButton: 'Weekly',
      monthlyButton: 'Monthly',
      datePlaceholder: 'Select date',
      empty: 'No latest store manager report for the selected period',
      contentTitle: 'Report Content',
      contentTip: 'Display the latest report content as-is',
      analysisTitle: 'Structured Analysis',
      analysisTip: 'Display the report by structured sections',
      monthLabel: '{year}-{month}',
      weekLabel: '{start} to {end}',
      dailyTitle: 'Daily Store Report',
      weeklyTitle: 'Weekly Store Report',
      monthlyTitle: 'Monthly Store Report',
      periodLabel: 'Period: {range}',
    },
    storeDiagnosis: {
      pageTitle: 'Store Diagnosis',
      pageDesc: 'One store diagnosis report is generated each day from static information and reviews from the last 31 days. Generation is limited to once per day. The page shows the latest result.',
      refresh: 'Refresh',
      generate: 'Generate diagnosis',
      hotelInfoIncomplete: 'Hotel information is incomplete. Please confirm you are logged in and have selected a hotel.',
      emptyTitle: 'No diagnosis report yet',
      emptyDesc: 'Once hotel profiles, room types, photos, and related data are ready, AI diagnosis starts automatically. It cannot be generated again after that.',
      emptyMeta: 'Hotel code {hotelCode}  Batch {batchNo}',
      taskInfo: 'Task',
      batch: 'Batch',
      todayTask: 'Today’s task',
      preparingData: 'Preparing data',
      generating: 'Generating diagnosis',
      failedNoRetry: 'Failed. Cannot generate again',
      generated: 'Generated',
      notGenerated: 'Not generated. You can generate it manually',
      noReport: 'No report',
      latestDone: 'Latest report completed',
      latestFailed: 'Latest report failed',
      done: 'Completed',
      failed: 'Generation failed',
      statusWait: '1 / Pending check',
      statusDiagnosing: '2 / Diagnosing',
      statusDone: '3 / Completed',
      statusFailed: '4 / Failed',
      metaStatus: 'Status',
      failSummary: 'Failure summary',
      currentStage: 'Current stage',
      crawlRetry: 'Data merge retries',
      diagnoseDone: 'Diagnosis completed',
      diagnosingStage: 'Generating diagnosis',
      generateFailedShort: 'Generation failed',
      failTitle: 'Diagnosis not completed',
      failMessageToday: 'Data merge or AI generation failed. It cannot be generated again today.',
      failMessageLatest: 'The latest diagnosis failed. Today’s report has not been generated and can be created manually.',
      failHintToday: 'It cannot be generated again today. Retry tomorrow, or contact operations.',
      failHintLatest: 'The above is the latest failure. Today’s report has not been generated. Click Generate diagnosis.',
      stepCrawl: '1. Start data merge',
      stepSuccess: '2. Data merge succeeded',
      stepSync: '3. Sync data',
      stepAdp: '4. Start diagnosis',
      progressDiagnosing: 'Data merge and sync are done. The diagnosis report is being generated.',
      progressWait: 'Fetching Meituan/Ctrip profiles, room types, and photos. Diagnosis starts automatically once the data is ready.',
      reportPending: 'The report is not ready yet. Diagnosis starts automatically once the data is ready. You can leave and come back later.',
      reportGenerating: 'Generating the diagnosis report. Please wait…',
      reportBody: 'Diagnosis report',
      reportEmpty: 'The report content is empty',
      generateSuccess: 'Diagnosis task created. Preparing data',
      retryCount: '{count} / {max}',
    },
    structured: {
      channelAnalysis: 'Channel Analysis',
      roomTypeAnalysis: 'Room Type Analysis',
      commentAnalysis: 'Comment Analysis',
      marketAnalysis: 'Market / District Heat',
      momLabel: 'MoM: ',
      yoyLabel: 'YoY: ',
      dayMomLabel: 'Period-over-period: ',
      dayYoyLabel: 'Week-over-week: ',
      weekMomLabel: 'Period-over-period: ',
      weekYoyLabel: 'Month-over-month: ',
      monthMomLabel: 'Period-over-period: ',
      monthYoyLabel: 'Year-over-year: ',
      channel: 'Channel',
      revenue: 'Revenue',
      roomNight: 'Room Nights',
      channelShare: 'Channel Share',
      roomTypeName: 'Room Type',
      totalRooms: 'Total Rooms',
      soldRoomNights: 'Sold Room Nights',
      totalRoomRevenue: 'Total Room Revenue',
      occupancyRate: 'Occupancy',
      averageRoomRate: 'ADR',
      disabledRooms: 'Disabled Rooms',
      commentType: 'Comment Type',
      count: 'Count',
      share: 'Share',
      goodMediumBad: 'Good / Neutral / Bad',
      goodRate: 'Positive Rate',
      eventName: 'Event Name',
      eventFallback: 'Event',
      summaryAnalysis: 'Overall Analysis',
      goodComment: 'Positive',
      mediumComment: 'Neutral',
      badComment: 'Negative',
      channelRevenueChart: 'Channel Revenue',
      roomTypeRevenueChart: 'Room Type Revenue',
    },
    revenueManager: {
      pageTitle: 'Revenue Manager',
      adviceTitle: 'AI Business Advice',
      pendingCount: '{count} pending',
      trafficTitle: 'Traffic Monitor',
      trafficSubtitle: 'AI forecast · real-time updates',
      selectDate: 'Select date',
      todayShortcut: 'Today',
      allDay: 'All day',
      timeLabel: 'Time',
      storeTrafficLabel: 'Store Traffic',
      orderLabel: 'Orders',
      orderCount: '{count} orders',
      summaryNote: '{channel} channel · updated at {time}',
      forecastLabel: 'All-day forecast (AI model)',
      meituanForecast: 'Meituan Traffic Forecast',
      ctripForecast: 'Ctrip Traffic Forecast',
      allDayVisit: 'All-day visits',
      occLabel: 'Occupancy',
      roomNightLabel: 'Room Nights',
      revenueLabel: 'Revenue',
      analysisTag: 'AI Analysis',
      defaultStrategyTag: 'Pricing Strategy',
      collapse: 'Collapse',
      expandMore: 'Expand',
      badReviewLoading: 'Loading bad review reply...',
      badReviewReply: 'Reply',
      badReviewEmpty: 'No bad review reply content available',
      realtimeTitle: 'Real-time Overview',
      revenueForecastTitle: 'Revenue Forecast ({range})',
      occForecastTitle: 'Occupancy Forecast ({range})',
      aiForecastBadge: 'AI Forecast',
      todayForecast: 'Today forecast {value}',
      peakLabel: 'Peak',
      channelMeituan: 'Meituan',
      channelCtrip: 'Ctrip',
      hours1: 'Last 1h',
      hours3: 'Last 3h',
      hours5: 'Last 5h',
      hours12: 'Last 12h',
      yesterdayValue: 'Yesterday {value}',
      futureSevenDays: 'Next 7 Days',
      dailyAdviceTitle: '{date} daily AI advice',
      allDayAdviceTitle: 'All-day AI advice',
      hoursAdviceTitle: 'Last {hours}h AI advice',
      adrForecastLabel: 'ADR Forecast ',
      defaultAdviceDetail: 'Adjust room pricing and delivery strategy based on current demand.',
      displayDate: '{year}-{month}-{day}',
      roomNightValue: '{count} rooms',
      revenueInsightCollapse: 'Collapse AI revenue rationale',
      revenueInsightExpand: 'Expand AI revenue rationale',
      forecastForDate: 'Forecast for {date}: {value}',
      revenueInsightTitle: 'AI Revenue Rationale',
      revenueInsightJudgment: 'Revenue assessment',
      revenueInsightKeySteps: 'Key rationale',
      revenueInsightRisks: 'Risk alerts',
      revenueInsightRecommendations: 'Business recommendations',
      metricTips: {
        traffic: {
          meituan: { title: 'Meituan Traffic', p1: 'Meituan traffic shows visits to this hotel from the Meituan channel within the selected time range.', p2: 'It considers historical performance, recent trends, visits already recorded today, holidays, and related factors.', p3: 'Use it to assess hourly trends and unusual changes; it is not the final all-day total.' },
          ctrip: { title: 'Ctrip Traffic', p1: 'Ctrip traffic shows visits to this hotel from the Ctrip channel within the selected time range.', p2: 'It references comparable historical dates, recent channel performance, real-time changes today, and holidays.', p3: 'Review it with order changes to judge whether traffic is converting into bookings.' },
          order: { title: 'Orders', p1: 'Orders show booking changes generated for the current channel, date, and time range.', p2: 'This metric reflects real-time booking conversion under the active filters.', p3: 'When short-term changes are large, review the all-day forecast and historical performance together.' },
        },
        hotelForecast: {
          meituan: { title: 'Meituan Traffic Forecast', p1: 'This is the estimated total visit volume for the Meituan channel today.', p2: 'It is based on historical traffic, recent channel changes, today performance, holidays, and operating rhythm.', p3: 'Use it to anticipate demand and support pricing, room inventory, and operational planning.' },
          ctrip: { title: 'Ctrip Traffic Forecast', p1: 'This is the estimated total visit volume for the Ctrip channel today.', p2: 'It considers comparable historical dates, recent trends, real-time performance today, and holidays.', p3: 'Use it to assess potential demand and compare it with the Meituan forecast.' },
          occ: { title: 'Occupancy', p1: 'Occupancy is the forecasted proportion of rooms sold today.', p2: 'It considers historical occupancy, recent booking pace, today traffic and orders, and holidays.', p3: 'Use it to assess stay pressure, unsold-room risk, and pricing or promotion direction.' },
          roomNights: { title: 'Room Nights', p1: 'Room nights are the forecasted number of room nights that may be sold today.', p2: 'It references historical sales, recent booking pace, today traffic and orders, and holidays.', p3: 'Review it with occupancy to judge the pace of room inventory consumption.' },
          adr: { title: 'ADR', p1: 'ADR is the forecasted average daily rate for rooms sold today.', p2: 'It is based on historical prices, recent transactions, demand today, and holidays.', p3: 'Review it with occupancy and revenue to avoid pursuing occupancy alone.' },
          revenue: { title: 'Revenue', p1: 'Revenue is the forecasted room sales income for today.', p2: 'It combines forecasted room nights, forecasted ADR, historical performance, recent demand, and holidays.', p3: 'Use it to assess whether business results are on track and identify revenue upside.' },
        },
        futureRevenue: { title: 'Revenue Forecast', p1: 'Revenue forecast shows estimated daily room revenue for the next seven days.', p2: 'It considers historical performance, recent bookings, traffic and orders, current-day performance, and holidays.', p3: 'Use it to identify peak and low-demand dates and plan pricing, room inventory, and operations.' },
        occRevenue: { title: 'Occupancy Forecast', p1: 'Occupancy forecast shows the estimated proportion of rooms sold each day for the next seven days.', p2: 'It considers historical occupancy, recent bookings, channel traffic, orders, current changes, and holidays.', p3: 'Use it to identify sellout or insufficient-occupancy risk early and plan pricing or promotions.' },
      },
    },
  },
  route: {
    ai: 'AI',
    aiRevenueManager: 'Revenue Manager',
    aiSmartPricing: 'Smart Pricing',
    aiNoticeCenter: 'Notification Center',
    aiStoreManagerReport: 'Store Manager Report',
    aiStoreDiagnosis: 'Store Diagnosis',
    aiNoticeDetail: 'Notice Detail',
    aiConfig: 'AI Configuration',
    businessLog: 'Business Day Change Log',
    nightAuditLog: 'Night Audit Log',
    turnoverSubmit: 'Remittance of operating revenue',
    channelConfig: 'Channel Config',
  },
  borrowBorrowset: {
    newItem: 'Add Item',
    usable: 'Available',
    notAvailable: 'Unavailable',
    alreadyRemoved: 'Deleted',
    enterItemName: 'Enter Item Name',
    unitPriceOfGoods2: 'Unit Price',
    inventory: 'Inventory',
    amountBorrowed: 'Borrowed Quantity',
    loanableQuantity: 'Loanable Quantity',
    theNameCannotExceed9CharactersPleaseEnterANewName:
      'The name cannot exceed 9 characters. Please re-enter.',
    priceCannotBeLessThan0PleaseReEnter: 'Price cannot be less than 0. Please re-enter.',
    priceCannotBeGreaterThan9999PleaseReEnter: 'Price cannot exceed 9999. Please re-enter.',
    theInventoryCannotBeLessThan0PleaseReEnter: 'Inventory cannot be less than 0. Please re-enter.',
    inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter:
      'Inventory cannot be less than the borrowed quantity. Please re-enter.',
    areYouSureYouWantToDeleteThisItem: 'Are you sure you want to delete this item?',
    areYouSureYouWantToDisableThisItem: 'Are you sure you want to disable this item?',
    thisItemHasNotBeenReturnedConfirmToDelete:
      'This item has not been returned yet. Confirm deletion?',
  },
  systemsetNotice: {
    systemMessageReminder: 'System Message Reminder',
    messageReminderSettingsAtLeastOneItem: 'Message reminder settings (at least one item)',
    hourlyRoomCheckoutMessage: 'Hourly Room Checkout Message',
    fullDayCheckoutMessage: 'Full-day Room Checkout Message',
    messageVoiceReminder: 'Voice Message Reminder',
    onlineChannelNewOrderReminder: 'Online Channel New Order Reminder',
    onlineChannelOrderCancellationReminder: 'Online Channel Order Cancellation Reminder',
    hourlyRoomCheckoutReminder: 'Hourly Room Checkout Reminder',
    fullDayCheckoutReminder: 'Full-day Checkout Reminder',
    operationFailed: 'Operation failed',
    thirtyMinutesBeforeCheckout: '30 minutes before checkout',
    fifteenMinutesBeforeCheckout: '15 minutes before checkout',
    atCheckoutTime: 'At checkout',
    checkoutTimeUpdated: 'Checkout reminder time updated successfully',
    voiceSettingUpdated: 'Voice reminder setting updated successfully',
  },
  binding: {
    publicAccountMessageReminder: 'Official Account Message Reminder',
    scanToBindUser: 'Scan to Bind User',
    cancelEdit: 'Cancel Edit',
    allMembers: 'All Members',
    scanToBindTitle: 'Scan to Bind Official Account',
    scanWithWechat: 'Please scan with WeChat to bind',
    qrCodeGenerateFail: 'Failed to generate QR code, please try again later',
    unbindSuccess: 'Unbound successfully!',
    unbindFail: 'Unbind failed, please retry',
    confirmCloseQrDialog: 'Are you sure to close the QR code dialog?',
    orderCreate: 'New Order',
    orderCancel: 'Order Cancelled',
    orderConfirm: 'Order Pending Confirmation',
    orderCheckOutTip: 'Before Check-out',
    orderCheckOut: 'Check-out',
    orderCreateEbk: 'EBK New Order',
    orderCancelEbk: 'EBK Order Cancelled',
    roomCleanDone: 'Room Cleaned',
    ebAccountOffline: 'EB Account Offline',
    computerHardwareOffline: 'Computer Hardware Offline',
    ebWarnNotice: 'EB Room Overbooking Warning',
  },
  writeDoorCardIndex: {
    preIssuedDoorCard: 'Pre-issued key card',
    effectiveTime: 'Effective time',
    expiryTime: 'Expiration Time',
    viewPassword: 'View password',
    passwordStatusNotSent: 'Not sent',
    passwordStatusSending: 'Sending',
    passwordStatusSent: 'Sent successfully',
    passwordStatusFailed: 'Failed to send',
    generatePasswordOnly: 'Generate password only',
    generateAndSendPassword: 'Generate & send password',
    getLockInfoFailed: 'Failed to get room lock information',
    makeCardFailedPrefix: 'Card issuing failed: ',
    deactivateFailedPrefix: 'Failed to deactivate card: ',
    pleaseEnterValidPhoneNumber: 'Please enter a valid mobile number.',
    passwordSendSuccess: 'Password sent successfully.',
    roomPasswordGeneratedAndSent:
      'The room password has been generated and sent to the guest. Please remind the guest to check the SMS for the door password.',
    roomPasswordGenerated: 'The room password has been generated.',
    invalidTimeString: 'Invalid time string.',
    temporaryMakeCard: 'Temporary Make Card',
    validDoorCard: 'Current valid key cards',
    makeCardLogTitle: 'Card Issuance Record',
    makeType: 'Card Type',
    operationResult: 'Operation Result',
    createTime: 'Created time',
  },
  operating: {
    total: 'Total',
    index: 'No.',
    businessDay: 'Business Day',
    totalAccount: 'Summary',
    totalOcc: 'Total Occupancy (%)',
    fullDayOcc: 'Full-day Occ (%)',
    hourDayOcc: 'Hourly Occ (%)',
    avgPrice: 'Avg Price',
    revPar: 'RevPAR ',
    totalRoomNight: 'Total Room Nights',
    fullDayRoomNight: 'Full-day Room Nights',
    busLongRoomNight: 'Long-stay Room Nights',
    hourRoomNight: 'Hourly Room Nights',
    teamRoomNight: 'Group Room Nights',
    freeRoomNight: 'Free Room Nights',
    privateRoomNight: 'Staff-use Room Nights',
    houseRent: 'Room Revenue ',
    smallGoods: 'Goods ',
    meals: 'Meal Fee ',
    serviceFee: 'Service Fee ',
    memberFee: 'Membership Fee ',
    otherFee: 'Other Fee ',
    generalIncome: 'Total Revenue ',
    roomNight: 'Room Nights',
    avgRoomPrice: 'Avg Room Price',
    totalHouseRent: 'Total Room Fee',
    rentalRate: 'Occupancy (%)',
    roomNightProportion: 'Room Night %',
    calcFormula: 'Calculation Formula',
    known: 'OK',
  },
  incomeIncomesum: {
    pleaseCheckTheStartAndEndTimesOfTheSearch: 'Please check the start and end times of the search',
    roomRateIncome: 'Room Rate Income ',
    smallwareIncome: 'Small Goods Income',
    mealFeeIncome: 'Meal Fee Income',
    reportTitle: 'Income Summary Report',
    cooperationModel: 'Cooperation Model',
    status: 'New/Replace Sign',
    roomsCount: 'Physical Room Count',
    startBusiness: 'Business Start Time',
  },
  commonImportDialog: {
    tip: 'Please organize the information according to the template requirements.',
    downloadTemplate: 'Download Template',
    removeFileConfirm: 'Confirm removal of',
    limitOneFile: 'Only 1 file is allowed. Please remove before adding another.',
    uploadError: 'Upload failed, please try again',
    reupload: 'Re-upload',
  },
  orderAntiflyRoom: {
    powerOnTime: 'Power On Time',
    powerOffTime: 'Power Off Time',
    isAntifly: 'Is Antifly',
    powerDuration: 'Power Duration',
  },
  roomOccupiedDetail: {
    title: 'Occupied Room Details',
    unassigned: 'Unassigned',
    roomOrderNo: 'Room Order No.',
    roomCount: 'Rooms',
    roomType: 'Room Type',
    roomNo: 'Room No.',
    contact: 'Contact',
    arrival: 'Arrival',
    departure: 'Departure',
    orderAndPayStatus: 'Order Status (Payment)',
    unpaidOrderNotAllowed: 'Unpaid orders cannot be operated',
    invalidRoomOrderOperation:
      'Unpaid, pending check-in, or unassigned room orders cannot be operated',
  },
  hardware: {
    smartRoomControl: 'Smart Room Control',
    smartRoomControlDesc: 'Support remote control of smart devices in guest rooms',
    smartRoomControlSetting: 'Smart Room Control Settings',
    appKey: 'App Key',
    appKeyPlaceholder: 'Please enter App Key',
    appSecret: 'App Secret',
    appSecretPlaceholder: 'Please enter App Secret',
    thirdHotel: 'Third-party Hotel',
    thirdHotelPlaceholder: 'Please enter third-party hotel',
    thirdGroup: 'Third-party Group',
    thirdGroupPlaceholder: 'Please enter third-party group',
    enable: 'Enabled',
    disable: 'Disabled',
    deviceType: 'Device Type',
    fullDayAutoOff: 'Full-day Auto Off',
    hourAutoOff: 'Hourly Auto Off',
  },
  lockpwd: {
    makeCardLogTitle: 'Door Card Issuance Log',
    operationType: 'Operation Type',
    operationTime: 'Operation Time',
    makeCard: 'Issue Card',
    cancelCard: 'Cancel Card',
    roomTypeCode: 'Room Type Code',
    roomTypeName: 'Room Type Name',
    roomNumber: 'Room Number',
    lockBrandName: 'Lock Brand',
    lockId: 'Lock ID',
    orderRoomNo: 'Order Room No.',
    operator: 'Operator',
    makeType: 'Card Type',
    validPeriod: 'Card Validity Period',
    operationResult: 'Operation Result',
    errorMessage: 'Failure Message',
  },
  roomType: {
    createBundleRoomType: 'Create Bundle Room Type',
    roomTypeName: 'Room Type Name',
    relatedRoomTypes: 'Related Room Types',
    relateRoom: 'Relate Rooms',
    selectedRooms: 'Selected Rooms',
  },
  channelConfig: {
    noChannelConfigData: 'No channel config data',
    directConnected: 'Direct Connected',
    notDirectConnected: 'Not Connected',
    roomTypeMatch: 'Room Type Matching',
    bindNewAccount: 'Bind New Account',
    openDirectConnection: 'Enable Direct Connection',
    meituanHomestayStore: 'Meituan Homestay Store',
    tujiaHomestayAccount: 'Tujia Homestay Account',
    deleteAccount: 'Delete Account',
    noBoundAccount: 'No bound account',
    breakDirectConnection: 'Disconnect',
    directConnectionStatus: 'Connection Status',
    channelDiscount: 'Channel Discount',
    channelCommission: 'Channel Commission',
    qzCommission: 'Qingzhu Commission',
    meituanRoomType: 'Meituan Room Type',
    meituanRoomTypeId: 'Meituan Room Type ID',
    tujiaHouse: 'Tujia House',
    tujiaHouseId: 'Tujia House ID',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    homestay: 'Homestay',
    goodsTypeNormal: 'Standard Product',
    goodsTypeFree: 'Free Room Product',
    goodsTypeOnlineHour: 'Online Hourly Room',
    goodsTypePresaleFullDay: 'Presale Full-Day Room',
    goodsTypePresaleHour: 'Presale Hourly Room',
    fetchChannelConfigFail: 'Failed to fetch channel config',
    goodsTypePrefix: 'Product Type {type}',
    openDirectSuccess: 'Direct connection enabled successfully',
    openDirectFail: 'Failed to enable direct connection',
    channelNotSupportRoomMatch: 'This channel does not support room type matching',
    fetchRoomMatchFail: 'Failed to fetch room type matching data',
    pleaseSelectRoomType: 'Please select a Qingyingbao room type',
    pleaseSelectProduct: 'Please select a Qingyingbao product',
    bindFail: 'Binding failed',
    confirmUnbindRoomType: 'Are you sure you want to unbind this room type?',
    unbindFail: 'Unbinding failed',
    channelNotSupportAccountBind: 'This channel does not support account binding',
    bindAccountSuccess: 'Account bound successfully',
    bindAccountFail: 'Failed to bind account',
    fetchAccountDetailFail: 'Failed to fetch account details',
    confirmDeleteAccount: 'Are you sure you want to delete this account?',
    confirmBreakDirect: 'Are you sure you want to disconnect?',
    breakDirectSuccess: 'Disconnected successfully',
    breakDirectFail: 'Failed to disconnect',
    turnoverSubmit: 'Operating Revenue Turnover',
    pushPriceLibrary: 'Push 90-Day Price & Inventory',
    pushPriceLibrarySuccess: 'Price and inventory pushed successfully',
    pushPriceLibraryFail: 'Failed to push price and inventory',
    pushPriceLibrarySwitch: 'Push Price Switch',
    pushSwitchOnSuccess: 'Push switch turned on',
    pushSwitchOffSuccess: 'Push switch turned off',
    pushSwitchChangeFail: 'Failed to change push switch',
  },
  incomeBusinessIncomeDetail: {
    reportTitle: 'Business income detail report',
    consumeTotal: 'Consumption total',
    settleTotal: 'Payment total',
    roomFee: 'Room fee',
    mealFee: 'Meal fee',
    goodsFee: 'Merchandise',
    serviceFee: 'Service fee',
    memberFee: 'Membership fee',
    otherConsume: 'Other consumption',
    dailyBalance: 'Daily balance',
    orderNo: 'Order No.',
    roomOrderNo: 'Room Order No.',
    roomNo: 'Room No.',
    guestName: 'Guest name',
    noData: 'No data',
  },
  turnoverSubmit: {
    summaryLoadFailed: 'Cash drawer turnover data failed to load. Operations on this page are disabled.',
    reload: 'Reload',
    initBeforeUse: 'Please initialize the current cash drawer balances before first use.',
    initCashier: 'Initialize Cash Drawer',
    submitManage: 'Turnover Management',
    summaryTipPrefix: 'Note: The consumption and settlement data counted here is from',
    to: 'to',
    summaryTipSuffix: '',
    consumeSubject: 'Consumption Subjects',
    paymentSubject: 'Payment Subjects',
    serialNumber: 'No.',
    subtotal: 'Subtotal',
    subject: 'Subject',
    amount: 'Amount',
    dataSummary: 'Data Summary',
    lastBalanceSummary: 'Previous cash drawer balance: {total} = Cash({cash}) + Bank Card({bankCard}) + Other({other})',
    currentAmountSummary: 'Current cash drawer amount: {total} = Cash({cash}) + Bank Card({bankCard}) + Other({other})',
    currentCash: 'Current Cash:',
    currentBankCard: 'Current Bank Card:',
    currentOther: 'Current Other:',
    submitCash: 'Turn Over Cash',
    submitBankCard: 'Turn Over Bank Card',
    submitOther: 'Turn Over Other',
    cashBalance: 'Cash Balance:',
    bankCardBalance: 'Bank Card Balance:',
    otherBalance: 'Other Balance:',
    remark: 'Remark:',
    submit: 'Turn Over',
    submitHistory: 'Turnover History',
    submitTime: 'Turnover Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    operator: 'Operator',
    pleaseEnter: 'Please enter',
    search: 'Search',
    export: 'Export',
    lastCashierBalance: 'Previous Cash Drawer Balance',
    cash: 'Cash',
    bankCard: 'Bank Card',
    other: 'Other',
    currentCashierAmount: 'Current Period Cash Drawer Amount',
    currentSubmitAmount: 'Current Period Turnover Amount',
    currentCashierBalance: 'Current Period Cash Drawer Balance',
    initTipLine1: 'Please enter the actual current cash drawer amount.',
    initTipLine2: 'After initialization, a history record with remark [Initialization Data] will be generated.',
    currentCashierCash: 'Current Cash Drawer Cash',
    currentCashierBankCard: 'Current Cash Drawer Bank Card',
    currentCashierOther: 'Current Cash Drawer Other',
    skipInit: 'Skip Initialization',
    confirmInit: 'Confirm Initialization',
    pleaseEnterAmount: 'Please enter amount',
    invalidAmountFormat: 'Invalid amount format. Up to 2 decimal places are allowed.',
    notGreaterThanCurrentCash: 'Cannot exceed [Current Cash]',
    notGreaterThanCurrentBankCard: 'Cannot exceed [Current Bank Card]',
    notGreaterThanCurrentOther: 'Cannot exceed [Current Other]',
    hotelHistoricalTotal: 'Hotel Historical Total',
    currentTime: 'Current Time',
    initBalanceCannotBeNegative: 'Initial balance cannot be less than 0',
    cashierInitSuccess: 'Cash drawer initialized successfully',
    exportFailed: 'Export failed',
    checkSubmitAmount: 'Please check whether the submitted amount is correct',
    confirmSubmitMessage: 'Confirm turning over this revenue record?',
    tip: 'Tip',
    submitSuccess: 'Submitted successfully',
    submitFailed: 'Submission failed',
    total: 'Total',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'Price Source', bookingHourOrderCountTitle: 'Hourly Booking Orders', bookingHourOrderCountNoData: 'No hourly booking order data available', bookingHourOrderCountDateRange: 'Last 7 days {start} to {end} | Today {date}', bookingHourOrderCountDateOnly: 'Today {date}', bookingHourOrderCountSevenDay: 'Orders in Last 7 Days', bookingHourOrderCountToday: 'Today Orders', bookingHourOrderUnit: 'orders', bookingHourOrderAxis: 'Orders', viewTodayReports: 'View Today\'s Reports', backToTodayReports: 'Back to Today\'s Reports', backToLatestReport: 'Back to Latest Report', historyEmpty: 'This smart-pricing report is unavailable', todayReportTitle: 'Reports for {date}', pricingTime: 'Pricing Time', reportTitle: 'Report Title', pricingChannel: 'Pricing Channel', viewDetail: 'Details', todayReportEmpty: 'No completed room-type pricing reports today',
  },
  commonBook: {
    commonBooking: 'Unified Booking', fitBooking: 'Individual Booking', longStayBooking: 'Long-stay Booking', teamBooking: 'Group Booking', walkIn: 'Walk-in', ebkManualMove: 'EBK Manual Transfer',
    sourceType: 'Source Type', externalChannel: 'External Channel', channelOrderNo: 'Channel Order No.', arrivalTime: 'Arrival Time', departureTime: 'Departure Time', retentionTime: 'Hold Until', stayDuration: 'Stay Duration', days: 'Days', contact: 'Contact', contactPhone: 'Contact Phone', teamType: 'Group Type', teamName: 'Group Name', contractNo: 'Contract No.',
    paymentInfo: 'Payment Information', paymentMethod: 'Payment Method', amount: 'Amount', storedValueMember: 'Stored-value Member', paymentCode: 'Payment Verification Code', remark: 'Remarks', totalRooms: 'Rooms', stayDays: 'Stay Days', taxAmount: 'Tax', roomPrice: 'Room Rate', totalPrice: 'Total Price', submitBooking: 'Confirm Booking',
    addRoom: 'Add Room', addRoomType: 'Add Room Type', roomType: 'Room Type', roomStatus: 'Room Status', room: 'Room', loading: 'Loading', noAvailableRoomType: 'No room types available', noAvailableRoom: 'No rooms available. Adjust the room type or status.', noValidRoomType: 'No valid room types', selectedRoomCount: '{count} room(s) selected; select at least 1', emptyClean: 'Vacant Clean', emptyDirty: 'Vacant Dirty', selectRoomType: 'Select a room type',
    availableRooms: 'Available', breakfast: 'Breakfast', roomCount: 'Rooms', bookedRoomCount: 'Booked Rooms', walkInRoomCount: 'Rooms to Check In', arrangeRoom: 'Assign Room', dailyPrice: 'Daily Price', unassignedRooms: '{count} room(s) unassigned', assignedRoom: 'Assigned {room}', selectedRoom: 'Selected {room}', delete: 'Delete', to: 'to', addGuest: 'Add Guest', channelRoomType: 'Channel Room Type', currencyUnit: 'CNY', tax: 'Tax',
    pleaseSelect: 'Please select', pleaseEnter: 'Please enter', enterChannelName: 'Enter channel name', cancel: 'Cancel', confirm: 'Confirm', close: 'Close', roomDetail: 'Room Folio Details',
    selectSourceType: 'Select a source type', selectMemberInfo: 'Select member information', selectCompany: 'Select a corporate account', selectStayType: 'Select a stay type', selectArrivalTime: 'Select an arrival time', selectDepartureTime: 'Select a departure time', enterContact: 'Enter a contact', selectTeamType: 'Select a group type', enterTeamName: 'Enter a group name',
    basePriceMode: 'Base Price Mode', sellingPriceMode: 'Selling Price Mode', useEbkOrderInfo: 'Use EB Order Information', initializationFailed: 'Unified booking failed to initialize. Close and try again.', dictionaryLoadFailed: 'Failed to load booking dictionaries', companyNotFound: 'No matching corporate account found',
    minimumStayDays: 'The minimum stay for this scenario is {count} day(s)', maximumStayDays: 'The maximum stay for this scenario is {count} day(s)', retentionBeforeArrival: 'Hold time cannot be earlier than arrival time', retentionTooLate: 'Hold time exceeds the latest time allowed for this scenario', retentionOutOfRange: 'Hold time is outside the allowed range',
    invalidBreakfast: 'Breakfast count for {roomType} must be an integer from 0 to 999 and cannot be empty', invalidRoomCount: 'Room count for {roomType} must be a non-negative integer and cannot be empty', enterExternalChannel: 'Enter the external channel name', invalidHourDuration: 'Stay duration must be an integer from 1 to 12 hours', invalidStayDays: 'Stay days must be an integer from {min} to {max}', incompleteStay: '{roomType} has an incomplete stay period', arrivalBeforeBusinessDate: 'Arrival for {roomType} cannot be before the current business date', roomTypeStayRange: 'The stay for {roomType} must be between 1 and {max} days', roomTypeDuplicateStay: 'Duplicate stay periods cannot be added for {roomType}',
    selectAtLeastOneRoomType: 'Select at least one bookable room type', selectMember: 'Select a member', missingProductOrPrice: 'A selected room type is missing a product or daily prices', roomCountExceedsAvailability: 'Booked rooms exceed current availability', walkInRequiresRoom: 'A walk-in must have specific rooms assigned', guestRequiredPerRoom: 'Enter a guest for every room', completeGuestName: 'Complete all guest names', selectPaymentForDeposit: 'Select a payment method when collecting a deposit', selectMemberForStoredValue: 'Select a member for stored-value payment', insufficientMemberBalance: 'Member balance is {balance} CNY. Select another payment method.', enterStoredValueCode: 'Enter the payment verification code for stored-value payment',
    bookingFailed: 'Booking failed. Adjust the details and try again.', bookingSuccess: 'Booking successful', overOccupancyConfirmation: 'The number of guests exceeds the room maximum. Continue check-in?', overOccupancyPromptTitle: 'Notice', walkInMissingMasterRoom: 'Walk-in succeeded, but no master room folio number was returned', checkInSuccess: 'Check-in successful', createdWithoutOrderNo: 'Created successfully, but no order number was returned. Record the payment on the finance page.', walkInWithoutMasterRoomForPayment: 'Check-in succeeded, but no master room folio number was returned. Record the payment on the finance page.', onlinePaymentFailed: 'Online payment request failed', paymentStatusFailed: 'Failed to query payment status',
    sameStayExists: 'The same stay period already exists for this room type', departureAfterArrival: 'Departure must be later than arrival', duplicateStayNotAllowed: 'Duplicate stay periods are not allowed for the same room type', selectUnaddedRoom: 'Select a room that has not been added', keepOneWalkInRoom: 'Keep at least one room for a walk-in', ebkRoomCountMismatch: 'The booked room count differs from the channel order. Continue booking?', continueBooking: 'Continue Booking', modify: 'Modify',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'Price Source', bookingHourOrderCountTitle: 'Hourly Booking Orders', bookingHourOrderCountNoData: 'No hourly booking order data available', bookingHourOrderCountDateRange: 'Last 7 days {start} to {end} | Today {date}', bookingHourOrderCountDateOnly: 'Today {date}', bookingHourOrderCountSevenDay: 'Orders in Last 7 Days', bookingHourOrderCountToday: 'Today Orders', bookingHourOrderUnit: 'orders', bookingHourOrderAxis: 'Orders', viewTodayReports: 'View Today\'s Reports', backToTodayReports: 'Back to Today\'s Reports', backToLatestReport: 'Back to Latest Report', historyEmpty: 'This smart-pricing report is unavailable', todayReportTitle: 'Reports for {date}', pricingTime: 'Pricing Time', reportTitle: 'Report Title', pricingChannel: 'Pricing Channel', viewDetail: 'Details', todayReportEmpty: 'No completed room-type pricing reports today',
  },

  inventoryPhase1: {
    itemType: 'Item Type',
    itemSpec: 'Item Specification',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: 'Item Name',
    itemCode: 'Item Code',
    enterItemName: 'Enter item name',
    itemUnit: 'Unit',
    itemSort: 'Item Sorting',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: 'New Item',
    modifyItem: 'Edit Item',
    warningQty: '预警数量',
    warningQtyLabel: 'Stock Warning Quantity',
    salePoint: 'Sales Outlets',
    scene: 'Usage Scenarios',
    guestRoom: 'Guest Room',
    fnb: 'Food & Beverage',
    meeting: 'Meeting',
    sceneSale: 'Available for sale',
    sceneClean: 'Available for housekeeping',
    sceneBorrow: 'Available for borrowing',
    selectType: 'Please select an item type',
    selectSpec: 'Please select an item specification',
    fillItemName: 'Please enter the item name',
    selectSalePoint: 'Please select at least one sales outlet',
    warningCloseHint: 'Set to 0 to disable warnings',
    inboundType: 'Stock In Method',
    outboundType: 'Stock Out Method',
    manualInbound: 'Manual Stock In',
    sale: 'Item Sale',
    roomClean: 'Housekeeping Supplies',
    roomBorrow: 'Room Borrowing',
    manualOutbound: 'Manual Stock Out',
    newOutbound: 'New outbound',
    selectOutboundType: 'Please select outbound type',
    createTime: '创建时间',
    catalogSource: 'Source',
    groupCatalog: 'Group catalog',
    hotelCatalog: 'Hotel',
    groupCatalogCannotEdit: 'Group catalog cannot be edited',
    groupCatalogCannotDelete: 'Group catalog cannot be deleted',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: 'Available for sale',
    filterRoomClean: 'Available for housekeeping',
    filterRoomBorrow: 'Available for borrowing',
    availableSalePoint: 'Available Sales Outlets',
    borrowReturn: 'Borrowed Item Return',
    saleVoid: 'Sale Reversal',
    sortOrder: 'Sort Order',
    fillWarningQty: 'Please enter the stock warning quantity',
    warningQtyInvalid: 'Stock warning quantity must be a non-negative integer',
  },
  aiPmsCtripPeerSync: {
    ctrip: 'Ctrip',
    account: 'Account',
    mobilePlaceholder: 'Enter mobile number',
    code: 'SMS code',
    codePlaceholder: 'Enter SMS code',
    login: 'Log in',
    resend: 'Resend',
    send: 'Send code',
    collectFailed: 'Failed to collect Ctrip competitor prices. Refresh later.',
    dataFailed: 'Failed to load data',
    relogin: 'Log in again',
    unbind: 'Unbind',
    updatedAt: 'Updated: {time}',
    hotelName: 'Hotel',
    price: 'Price',
    empty: 'No {channel} competitor entry prices available',
    accountRequired: 'Enter your Ctrip account',
    codeRequired: 'Enter the SMS verification code',
    loggingIn: 'Logging in; Ctrip competitor prices will be collected after login',
    smsSent: 'SMS code sent. Enter the code',
    smsFailed: 'Failed to send SMS code. Please resend',
    verifyFailed: 'SMS verification failed. Enter the code again to log in',
    loginFailed: 'Ctrip login failed. Send a new code to log in',
    deviceVerify: 'Complete device verification for your Ctrip account, then send a new code to log in',
    loginRequired: 'Send an SMS code to log in to Ctrip again',
    expired: 'Ctrip account expired. Please log in',
    sending: 'Sending SMS code…',
    collecting: 'Logged in. Collecting Ctrip competitor prices…',
    today: 'Today {time}',
    daysAgo: '{days} days ago',
    crawlSubmitted: 'Ctrip favorite hotel collection task submitted',
    smsSubmitted: 'SMS code request submitted',
    unbindConfirm: 'Unbind the current Ctrip account? Historical prices will be retained.',
    unbindTitle: 'Unbind Ctrip account',
    unbound: 'Ctrip account unbound',
  },
};
